import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import React__default from 'react';
import { parseHtml, QueryString, DateUtils, DistanceUnit, formatDistance, slugify, useDebouncedEffect, useAddViewportHeightCssVariable } from '@grandvisionhq/utils';
import classnames from 'classnames';
import { Icon, iconExists } from '@grandvisionhq/icons';
import { parseLink, useIntl, useFeatureToggles, useSelector } from '@grandvisionhq/state';
import { eachDayOfInterval, isWithinInterval, isSameDay as isSameDay$1, format, addYears, addMonths, addWeeks, addDays, startOfWeek, parseISO, endOfWeek, isValid } from 'date-fns';
import { WizardProgress, Logo, MediaQuery, Button, Alert, Loader, toast, Modal, QuickFilterButton, ScrollIntoView, InfoWindow, ErrorBoundary as ErrorBoundary$1, Delayed } from '@grandvisionhq/common';
import { DataLayer } from '@grandvisionhq/analytics';
import { gql, useLazyQuery, Types, useMutation } from '@grandvisionhq/graphql';
import { Heading, Text, SkeletonLoader, Hr, Button as Button$1, Container, Toggle } from '@grandvisionhq/elements';
import { Containers, Components, Util, useStoreFinderContext, StoreFinderProvider } from '@grandvisionhq/stores-v2';
import { Address, LocationSearchMap, LocationSearch } from '@grandvisionhq/locations';
import { v5, NIL } from 'uuid';
import { getToken, Selectors } from '@grandvisionhq/auth';
import { useFormContext, CheckboxView, Field, Util as Util$1, Form, TextArea } from '@grandvisionhq/forms';
import { WithUserData } from '@grandvisionhq/my-account';

const getRuntimeConfigValues = (publicRuntimeConfig)=>{
    var ref;
    var ref1;
    const { APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID , APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE , APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES ,  } = (ref1 = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : (ref = publicRuntimeConfig.grandvision) === null || ref === void 0 ? void 0 : ref.featureConfigs) !== null && ref1 !== void 0 ? ref1 : {};
    const virtualAppointmentTypeId = typeof APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID === 'string' ? APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID : undefined;
    const virtualStoreCode = typeof APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE === 'string' ? APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE : undefined;
    const alternativeUrlStores = typeof APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES === 'string' ? APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES : undefined;
    return {
        virtualStoreCode,
        virtualAppointmentTypeId,
        alternativeUrlStores
    };
};

/**
 * @deprecated: use getRuntimeConfigValues instead.
 */ const getVirtualAppointmentValues = (publicRuntimeConfig)=>getRuntimeConfigValues(publicRuntimeConfig)
;

const getRuntimeFeatureValues = (publicRuntimeConfig)=>{
    var ref;
    var ref1;
    const enabledFeatures = (ref1 = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : (ref = publicRuntimeConfig.grandvision) === null || ref === void 0 ? void 0 : ref.features) !== null && ref1 !== void 0 ? ref1 : [];
    const myAccount = isFeatureEnabled(enabledFeatures, 'MYACCOUNT');
    return {
        myAccount
    };
};
const isFeatureEnabled = (enabledFeatures, feature)=>{
    return enabledFeatures.includes(feature);
};

const getLiteralText = (value, items)=>{
    const item1 = items.find((item)=>item.value === value
    );
    return item1 === null || item1 === void 0 ? void 0 : item1.title;
};

const fromArrayToString = (value)=>{
    if (!value && (value === null || value === void 0 ? void 0 : value.length) === 0) {
        return undefined;
    }
    const stringValue = Array.isArray(value) ? value[0] : value;
    return stringValue ? stringValue : undefined;
};

function touchFormFields(state) {
    return Object.entries(state).reduce((result, [key, value])=>{
        return swcHelpers.objectSpread({}, result, {
            [key]: swcHelpers.objectSpread({}, value, {
                isTouched: true
            })
        });
    }, {});
}
function touchComposedFormFields(state) {
    return Object.entries(state).reduce((result, [key, value])=>{
        return swcHelpers.objectSpread({}, result, {
            [key]: touchFormFields(value)
        });
    }, {});
}

const STORAGE_KEY$1 = 'affiliate-id';
const getStoredAffiliateId = ()=>{
    const isClient = typeof window !== 'undefined';
    if (!isClient) {
        return '';
    }
    const json = window.sessionStorage.getItem(STORAGE_KEY$1);
    const affiliateId = json ? JSON.parse(json) : undefined;
    return affiliateId;
};
const setStoredAffiliateId = (id)=>{
    const isClient = typeof window !== 'undefined';
    if (!isClient || !(id === null || id === void 0 ? void 0 : id.length)) {
        return false;
    }
    window.sessionStorage.setItem(STORAGE_KEY$1, JSON.stringify(id));
    return true;
};
const clearStoredAffiliateId = ()=>{
    const isClient = typeof window !== 'undefined';
    if (!isClient) {
        return false;
    }
    window.sessionStorage.removeItem(STORAGE_KEY$1);
    return true;
};

const STORAGE_KEY = 'created-appointments';
const getStoredAppointment = (id)=>{
    const isClient = typeof window !== 'undefined';
    if (!id || !isClient) {
        return null;
    }
    var ref;
    const json = (ref = window.sessionStorage.getItem(STORAGE_KEY)) !== null && ref !== void 0 ? ref : '{}';
    const appointments = JSON.parse(json);
    var _id;
    const appointment = (_id = appointments[id]) !== null && _id !== void 0 ? _id : null;
    return appointment ? swcHelpers.objectSpread({}, appointment, {
        startTime: new Date(appointment.startTime),
        endTime: new Date(appointment.endTime)
    }) : null;
};
const setStoredAppointment = (appointment)=>{
    const isClient = typeof window !== 'undefined';
    if (!isClient) {
        return false;
    }
    var ref;
    const json = (ref = window.sessionStorage.getItem(STORAGE_KEY)) !== null && ref !== void 0 ? ref : '{}';
    const appointments = JSON.parse(json);
    appointments[appointment.id] = appointment;
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(appointments));
    return true;
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getVirtualAppointmentValues: getVirtualAppointmentValues,
  getRuntimeConfigValues: getRuntimeConfigValues,
  getRuntimeFeatureValues: getRuntimeFeatureValues,
  getLiteralText: getLiteralText,
  fromArrayToString: fromArrayToString,
  touchFormFields: touchFormFields,
  touchComposedFormFields: touchComposedFormFields,
  setStoredAffiliateId: setStoredAffiliateId,
  clearStoredAffiliateId: clearStoredAffiliateId,
  getStoredAffiliateId: getStoredAffiliateId,
  setStoredAppointment: setStoredAppointment,
  getStoredAppointment: getStoredAppointment
});

var types = /*#__PURE__*/Object.freeze({
  __proto__: null
});

const PageDataContext = /*#__PURE__*/ React.createContext({});
var PageDataProvider = (_param)=>{
    var { children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    const { Provider  } = PageDataContext;
    return /*#__PURE__*/ React.createElement(Provider, {
        value: rest
    }, children);
};
const usePageData = ()=>React.useContext(PageDataContext)
;

const defaultRoutingContextValue$2 = [
    {
        goTo: ()=>null
    },
    {
        component: undefined,
        queryParams: {},
        currentRoute: '',
        basePath: '',
        signInMyAccountUrl: undefined,
        routerId: undefined
    }, 
];
const RoutingContext$2 = /*#__PURE__*/ React.createContext(defaultRoutingContextValue$2);
const useRoutingContext$2 = ()=>React.useContext(RoutingContext$2)
;

const shiftDate = (date, period, amount = 1)=>{
    switch(period){
        case 'day':
            return addDays(date, amount);
        case 'week':
            return addWeeks(date, amount);
        case 'month':
            return addMonths(date, amount);
        case 'year':
            return addYears(date, amount);
    }
};
const isDateBefore = (date1, date2)=>new Date(date1).setHours(0, 0, 0, 0) < new Date(date2).setHours(0, 0, 0, 0)
;
const isSameDay = (date1, date2)=>isSameDay$1(date1, date2)
;
const isWithinTimeSpan = (date, start, end)=>isWithinInterval(date, {
        start,
        end
    })
;
// Date-fns ^2.0.0 doesn't accept string dates anymore.
// Use this fn to make sure your date is either a Date or number
const parseDate = (date)=>typeof date === 'string' ? parseISO(date) : date
;
/**
 * Serialize a Date as a local ISO8601 date string. Like Date.prototype.toISOString,
 * but in the local timezone and just the date, no time or timezone offset.
 */ const toLocalDate = (date)=>format(date, 'yyyy-MM-dd')
;
const toLocalTimeMinutes = (date)=>format(date, 'HH:mm')
;
const getWeekDaysByDate = (date = new Date(), weekStartOffset)=>{
    const start = addDays(startOfWeek(parseDate(date)), weekStartOffset || 0);
    const end = addDays(endOfWeek(parseDate(date)), weekStartOffset || 0);
    return eachDayOfInterval({
        start,
        end
    });
};
const getWeekDaysByDates = (dates, weekStartOffset)=>dates.map((date)=>getWeekDaysByDate(date, weekStartOffset)
    )
;
/**
 * @param weekStartDay accepts values 0-6 which map to Sunday through Saturday
 * Assuming weekStartDay === 2 that sets the start day to Tuesday, however in
 * this case if the day is Sunday or Monday these are in the same week as Tuesday
 * and since this week starts on Tuesday they won't be shown. This function makes
 * sure to account for that and adjust the offset to the week before on the same
 * day as weekStartDay
 * */ const adjustOffsetToAccountForHiddenDays = (date, weekStartDay)=>{
    const isDayThatIsHidden = date.getDay() < weekStartDay;
    const adjustedOffset = (7 - weekStartDay) * -1;
    return isDayThatIsHidden ? adjustedOffset : weekStartDay;
};
const getWeekDaysForWeeksFromDate = (date, weeks, weekStartOffset)=>{
    const dates = [];
    let i = 0;
    while(i < weeks){
        dates.push(shiftDate(date, 'week', i));
        i++;
    }
    return getWeekDaysByDates(dates, adjustOffsetToAccountForHiddenDays(date, weekStartOffset !== null && weekStartOffset !== void 0 ? weekStartOffset : 0));
};
const getDayLabel = (date, size)=>{
    const days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday', 
    ];
    return `appointments.${size}Days.${days[date.getDay()]}`;
};

const CampaignInfoBanner = (_param)=> {
    var { className , text , icon  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "text",
        "icon"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('campaign-info-banner', className)
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: "campaign-info-banner__constrained-box"
    }, icon && /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        width: 18,
        height: 18
    }), /*#__PURE__*/ React.createElement("p", {
        className: "typography-text typography-text--caption campaign-info-banner__constrained-box__text"
    }, text)));
};

const CampaignInfoBannerContainer = (_param)=>{
    var { startEndDateCompound , bannerIcon , bannerTitle  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "startEndDateCompound",
        "bannerIcon",
        "bannerTitle"
    ]);
    const [, { routerId , currentRoute  }] = useRoutingContext$2();
    const text = React.useMemo(()=>bannerTitle && parseHtml(parseLink(bannerTitle, true))
    , [
        bannerTitle, 
    ]);
    const showBanner = React.useMemo(()=>{
        if (routerId !== 'book-appointment' || ![
            '',
            'where',
            'what',
            'when',
            'who'
        ].includes(currentRoute) || !text || !(startEndDateCompound === null || startEndDateCompound === void 0 ? void 0 : startEndDateCompound.startDate) || !(startEndDateCompound === null || startEndDateCompound === void 0 ? void 0 : startEndDateCompound.endDate)) {
            return false;
        }
        const currentTime = new Date();
        const startDate = new Date(startEndDateCompound.startDate);
        const endDate = new Date(startEndDateCompound.endDate);
        return isWithinTimeSpan(currentTime, startDate, endDate);
    }, [
        startEndDateCompound,
        text,
        routerId,
        currentRoute
    ]);
    const displayIcon = React.useMemo(()=>bannerIcon && iconExists(bannerIcon)
    , [
        bannerIcon
    ]);
    if (showBanner === false || !text) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(CampaignInfoBanner, swcHelpers.extends({
        icon: displayIcon ? bannerIcon : undefined,
        text: text
    }, rest));
};

const fromStoreQueryToStore$2 = (storeQueryData)=>{
    if (!storeQueryData) {
        return null;
    }
    try {
        const { code , name: name1 , shortName , email , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , slug , appointmentTypes ,  } = storeQueryData;
        var _amount, _unit;
        return {
            code,
            name: name1,
            shortName,
            streetName,
            town,
            country,
            phone,
            slug: slug !== null && slug !== void 0 ? slug : undefined,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
            postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
            province: province !== null && province !== void 0 ? province : undefined,
            lat: lat !== null && lat !== void 0 ? lat : undefined,
            lon: lon !== null && lon !== void 0 ? lon : undefined,
            emailAddress: email !== null && email !== void 0 ? email : undefined,
            appointmentTypes: appointmentTypes.filter(({ isAvailableInStore  })=>isAvailableInStore
            ).map(({ id , name , description , duration , price , isChildAppointment  })=>({
                    id,
                    name,
                    description: description !== null && description !== void 0 ? description : '',
                    duration: {
                        amount: (_amount = duration.amount) !== null && _amount !== void 0 ? _amount : 0,
                        unit: (_unit = duration.unit) !== null && _unit !== void 0 ? _unit : 'MINUTES'
                    },
                    price: price !== null && price !== void 0 ? price : undefined,
                    isChildAppointment
                })
            )
        };
    } catch (e) {
        console.error('Store query data adapter failed to parse input data correctly.', e, storeQueryData);
        return null;
    }
};

const bookAppointmentType$1 = gql`
  fragment BookAppointmentStoreAppointmentType on StoreAppointmentType {
    id
    name
    description
    duration {
      amount
      unit
    }
    price {
      amount
      currency
    }
    isAvailableInStore
    isChildAppointment
  }
`;
const bookAppointmentStore = gql`
  fragment BookAppointmentStore on Store {
    code
    name
    shortName
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    email
    phone
    slug
    appointmentTypes {
      ...BookAppointmentStoreAppointmentType
    }
  }
  ${bookAppointmentType$1}
`;
const GET_BOOK_APPOINTMENT_STORE = gql`
  query GetBookAppointmentStore($code: Int, $deviceGeoLocation: GeoLocationInput, $slug: String) {
    store(code: $code, deviceGeoLocation: $deviceGeoLocation, slug: $slug) {
      ...BookAppointmentStore
    }
  }
  ${bookAppointmentStore}
`;

const useBookAppointmentStore = ()=>{
    const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_STORE);
    const { locale  } = useIntl();
    if (queryState.error) {
        console.error(queryState.error);
    }
    const getBookAppointmentStore = React.useCallback((code)=>query(swcHelpers.objectSpread({
            variables: {
                code
            }
        }, locale ? {
            context: {
                forwardHeaders: {
                    'Accept-Language': locale
                }
            }
        } : {}))
    , [
        query,
        locale
    ]);
    const data = React.useMemo(()=>{
        var ref;
        return fromStoreQueryToStore$2((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            getBookAppointmentStore,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getBookAppointmentStore,
        queryState,
        data, 
    ]);
};

const fromAppointmentTypeQueryToAppointmentType = (appointmentTypeDataQuery)=>{
    if (!appointmentTypeDataQuery) {
        return null;
    }
    try {
        const { id , name , description , duration , isChildAppointment  } = appointmentTypeDataQuery;
        return {
            id,
            name,
            description,
            isChildAppointment,
            duration: {
                amount: duration.amount,
                unit: duration.unit
            }
        };
    } catch (e) {
        console.error('Appointment type query data adapter failed to parse input data correctly.', e, appointmentTypeDataQuery);
        return null;
    }
};

const bookAppointmentType = gql`
  fragment BookAppointmentType on AppointmentType {
    id
    name
    description
    duration {
      amount
      unit
    }
    isChildAppointment
  }
`;
const GET_BOOK_APPOINTMENT_TYPE = gql`
  query GetBookAppointmentType($id: ID!) {
    appointmentType(id: $id) {
      ...BookAppointmentType
    }
  }
  ${bookAppointmentType}
`;

const useBookAppointmentType = ()=>{
    const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_TYPE);
    const { locale  } = useIntl();
    if (queryState.error) {
        console.error(queryState.error);
    }
    const getBookAppointmentType = React.useCallback((id)=>query(swcHelpers.objectSpread({
            variables: {
                id
            }
        }, locale ? {
            context: {
                forwardHeaders: {
                    'Accept-Language': locale
                }
            }
        } : {}))
    , [
        query,
        locale
    ]);
    const data = React.useMemo(()=>{
        var ref;
        return fromAppointmentTypeQueryToAppointmentType((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.appointmentType);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            getBookAppointmentType,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getBookAppointmentType,
        queryState,
        data, 
    ]);
};

const getFormattedParams = ({ storeId , typeId , linkedAppointmentTypeId , start , end , appointmentId , virtualStoreCode , virtualAppointmentTypeId , alternativeUrlStores  })=>{
    return {
        storeId: storeId !== undefined ? parseInt(storeId, 10) : undefined,
        typeId,
        linkedAppointmentTypeId,
        start: (start === null || start === void 0 ? void 0 : start.length) ? start : undefined,
        end: (end === null || end === void 0 ? void 0 : end.length) ? end : undefined,
        appointmentId: appointmentId !== null && appointmentId !== void 0 ? appointmentId : undefined,
        virtualStoreCode: virtualStoreCode !== undefined ? parseInt(virtualStoreCode, 10) : undefined,
        virtualAppointmentTypeId,
        alternativeUrlStores: alternativeUrlStores === null || alternativeUrlStores === void 0 ? void 0 : alternativeUrlStores.split(',').map((string)=>parseInt(string, 10)
        )
    };
};
const hasValidVirtualAppointmentConfig = (params)=>params.virtualStoreCode !== undefined && params.virtualAppointmentTypeId !== undefined
;
const hasValidVirtualAppointmentParams = (params)=>hasValidVirtualAppointmentConfig(params) && params.typeId === params.virtualAppointmentTypeId && params.storeId === params.virtualStoreCode
;
const hasInvalidVirtualAppointmentParams = (params)=>hasValidVirtualAppointmentConfig(params) && (params.typeId === params.virtualAppointmentTypeId && params.storeId !== params.virtualStoreCode || params.typeId !== params.virtualAppointmentTypeId && params.storeId === params.virtualStoreCode)
;
const replaceCurrentRoute = (baseUrl, asPath, currentRoute, newRoute, queryParams)=>{
    const cleanAsPath = asPath.replace(currentRoute, newRoute).split('?')[0];
    const clearQueryParameters = QueryString.stringify(queryParams, Object.entries(queryParams).length === 0);
    return `${baseUrl}${cleanAsPath}${clearQueryParameters}`;
};
const isAppointmentTypeValid = ({ store , typeId  })=>{
    var ref;
    return Boolean(store === null || store === void 0 ? void 0 : (ref = store.appointmentTypes) === null || ref === void 0 ? void 0 : ref.find(({ id  })=>id === typeId
    ));
};
const generateVirtualAppointmentStoreData = (code, virtualAppointmentType)=>({
        code,
        name: '[placeholder-virtual-appointment-store-name]',
        shortName: '[placeholder-virtual-appointment-store-short-name]',
        streetName: '[placeholder-virtual-appointment-store-street-name]',
        streetNumber: undefined,
        additionalStreetInfo: undefined,
        postalCode: undefined,
        province: undefined,
        town: '[placeholder-virtual-appointment-store-town]',
        country: '[placeholder-virtual-appointment-store-country]',
        lat: undefined,
        lon: undefined,
        phone: '[placeholder-virtual-appointment-store-phone]',
        emailAddress: undefined,
        appointmentTypes: [
            virtualAppointmentType
        ]
    })
;

const useVirtualAppointment = ()=>{
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingVirtualAppointmentTypeId , appointmentBookingVirtualAppointmentStoreCode ,  } = featureConfigs !== null && featureConfigs !== void 0 ? featureConfigs : {};
    const { getLabel  } = useIntl();
    const enabled = appointmentBookingVirtualAppointmentTypeId !== undefined && appointmentBookingVirtualAppointmentStoreCode !== undefined;
    const isVirtualAppointmentStore = React.useCallback((store)=>store ? store.code === appointmentBookingVirtualAppointmentStoreCode : false
    , [
        appointmentBookingVirtualAppointmentStoreCode
    ]);
    const isVirtualAppointmentType = React.useCallback((type)=>type ? type.id === appointmentBookingVirtualAppointmentTypeId : false
    , [
        appointmentBookingVirtualAppointmentTypeId
    ]);
    const getStoreData = React.useCallback((store, type)=>{
        if (appointmentBookingVirtualAppointmentStoreCode === undefined || !type) {
            return null;
        }
        return store ? swcHelpers.objectSpread({}, store, {
            appointmentTypes: [
                type
            ]
        }) : generateVirtualAppointmentStoreData(appointmentBookingVirtualAppointmentStoreCode, type);
    }, [
        appointmentBookingVirtualAppointmentStoreCode
    ]);
    const getAppointmentTypeData = React.useCallback((type)=>{
        if (appointmentBookingVirtualAppointmentTypeId === undefined) {
            return null;
        }
        var ref;
        return swcHelpers.objectSpread({}, type, {
            id: appointmentBookingVirtualAppointmentTypeId,
            name: getLabel('appointments.virtualAppointment.name'),
            description: getLabel('appointments.virtualAppointment.description'),
            isChildAppointment: false,
            duration: (ref = type === null || type === void 0 ? void 0 : type.duration) !== null && ref !== void 0 ? ref : {
                amount: 0,
                unit: 'MINUTES'
            }
        });
    }, [
        appointmentBookingVirtualAppointmentTypeId,
        getLabel
    ]);
    return React.useMemo(()=>[
            {
                isVirtualAppointmentStore,
                isVirtualAppointmentType,
                getStoreData,
                getAppointmentTypeData
            },
            {
                enabled,
                storeCode: appointmentBookingVirtualAppointmentStoreCode,
                typeId: appointmentBookingVirtualAppointmentTypeId
            }, 
        ]
    , [
        isVirtualAppointmentStore,
        isVirtualAppointmentType,
        getStoreData,
        getAppointmentTypeData,
        enabled,
        appointmentBookingVirtualAppointmentStoreCode,
        appointmentBookingVirtualAppointmentTypeId, 
    ]);
};

const defaultState = {
    store: null,
    type: null,
    timeSlot: null,
    appointment: null
};
const useAppointmentState = (initialState = defaultState)=>{
    const [state1, dispatch] = React.useReducer((state, action)=>{
        switch(action.type){
            case 'book-appointment/set-store':
                return swcHelpers.objectSpread({}, state, {
                    store: action.payload
                });
            case 'book-appointment/set-type':
                return swcHelpers.objectSpread({}, state, {
                    type: action.payload
                });
            case 'book-appointment/set-time-slot':
                return swcHelpers.objectSpread({}, state, {
                    timeSlot: action.payload
                });
            case 'book-appointment/set-appointment':
                return swcHelpers.objectSpread({}, state, {
                    appointment: action.payload
                });
            default:
                return state;
        }
    }, initialState);
    const setStore = React.useCallback((store)=>{
        if (state1.store !== store) {
            dispatch({
                type: 'book-appointment/set-store',
                payload: store
            });
        }
    }, [
        state1
    ]);
    const setType = React.useCallback((type)=>{
        if (state1.type !== type) {
            dispatch({
                type: 'book-appointment/set-type',
                payload: type
            });
        }
    }, [
        state1
    ]);
    const setTimeSlot = React.useCallback((timeSlot)=>dispatch({
            type: 'book-appointment/set-time-slot',
            payload: timeSlot
        })
    , []);
    const setAppointment = React.useCallback((appointment)=>dispatch({
            type: 'book-appointment/set-appointment',
            payload: appointment
        })
    , []);
    return React.useMemo(()=>[
            {
                setStore,
                setType,
                setTimeSlot,
                setAppointment
            },
            state1
        ]
    , [
        state1,
        setStore,
        setType,
        setTimeSlot,
        setAppointment, 
    ]);
};
const appointmentContext = /*#__PURE__*/ React.createContext(null);
const AppointmentContextProvider = ({ children , initialState  } = {})=>{
    const { Provider  } = appointmentContext;
    var ref;
    const initialStore = (ref = initialState === null || initialState === void 0 ? void 0 : initialState.store) !== null && ref !== void 0 ? ref : defaultState.store;
    var ref1;
    const initialType = (ref1 = initialState === null || initialState === void 0 ? void 0 : initialState.type) !== null && ref1 !== void 0 ? ref1 : defaultState.type;
    const initialTimeSlot = (initialState === null || initialState === void 0 ? void 0 : initialState.timeSlot) ? {
        from: new Date(parseInt(initialState.timeSlot.from, 10)),
        until: new Date(parseInt(initialState.timeSlot.until, 10))
    } : defaultState.timeSlot;
    const [, { queryParams  }] = useRoutingContext$2();
    const appointmentId = fromArrayToString(queryParams.appointmentId);
    var ref2;
    const initialAppointment = (ref2 = getStoredAppointment(appointmentId)) !== null && ref2 !== void 0 ? ref2 : null;
    const [{ isVirtualAppointmentStore , isVirtualAppointmentType , getStoreData , getAppointmentTypeData  }, ] = useVirtualAppointment();
    // Enrich virtual appointment type data when provided, for example with bloomreach label values.
    const type = isVirtualAppointmentType(initialType) ? getAppointmentTypeData(initialType) : initialType;
    // Enrich virtual appointment store data when provided, for example with bloomreach label values.
    const store = isVirtualAppointmentStore(initialStore) ? getStoreData(initialStore, type) : initialStore;
    const value = useAppointmentState(swcHelpers.objectSpread({}, defaultState, {
        store,
        type,
        timeSlot: initialTimeSlot,
        appointment: initialAppointment
    }));
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, children);
};
const useAppointmentContext = ()=>React.useContext(appointmentContext)
;

const useAppointmentTypes = ()=>{
    const pageData = usePageData();
    const [, { store  }] = useAppointmentContext();
    const sortedAppointmentTypes = React.useMemo(()=>{
        var ref;
        const appointmentTypes = (ref = store === null || store === void 0 ? void 0 : store.appointmentTypes) !== null && ref !== void 0 ? ref : [];
        return appointmentTypes.sort((a, b)=>{
            var _appointmentTypes;
            const pageTypes = (_appointmentTypes = pageData.appointmentTypes) !== null && _appointmentTypes !== void 0 ? _appointmentTypes : [];
            const aIndex = pageTypes.findIndex(({ typeId  })=>typeId === a.id
            );
            const bIndex = pageTypes.findIndex(({ typeId  })=>typeId === b.id
            );
            if (aIndex === -1) {
                return 1;
            } else if (bIndex === -1) {
                return -1;
            } else {
                return aIndex - bIndex;
            }
        });
    }, [
        pageData,
        store
    ]);
    var ref3;
    const appointmentTypeIcons = React.useMemo(()=>{
        var ref;
        return (ref3 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.icon !== undefined) {
                acc[entry.typeId] = entry.icon;
            }
            return acc;
        }, {})) !== null && ref3 !== void 0 ? ref3 : {};
    }, [
        pageData
    ]);
    var ref1;
    const appointmentGlobalLabels = React.useMemo(()=>{
        var ref;
        return (ref1 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.globalLabel !== undefined) {
                acc[entry.typeId] = entry.globalLabel;
            }
            return acc;
        }, {})) !== null && ref1 !== void 0 ? ref1 : {};
    }, [
        pageData
    ]);
    var ref2;
    const appointmentTypeToolTips = React.useMemo(()=>{
        var ref;
        return (ref2 = (ref = pageData.appointmentTypes) === null || ref === void 0 ? void 0 : ref.reduce((acc, entry)=>{
            if (entry.typeDetails !== undefined) {
                acc[entry.typeId] = entry.typeDetails;
            }
            return acc;
        }, {})) !== null && ref2 !== void 0 ? ref2 : {};
    }, [
        pageData
    ]);
    return React.useMemo(()=>({
            sortedAppointmentTypes,
            appointmentTypeIcons,
            appointmentGlobalLabels,
            appointmentTypeToolTips
        })
    , [
        sortedAppointmentTypes,
        appointmentTypeIcons,
        appointmentGlobalLabels,
        appointmentTypeToolTips
    ]);
};

const useBookAppointmentStoreWithUrlParam = ()=>{
    const [, { queryParams  }] = useRoutingContext$2();
    const [getBookAppointmentStore, { called , data , loading , error  }] = useBookAppointmentStore();
    const [{ setStore  }, { store  }] = useAppointmentContext();
    const [{ getAppointmentTypeData , getStoreData  }, { storeCode: virtualStoreCode  }, ] = useVirtualAppointment();
    React.useEffect(()=>{
        if (error) {
            console.error(error);
            return;
        }
        const { storeId: storeIdFromUrl  } = queryParams;
        const storeId = fromArrayToString(storeIdFromUrl);
        if (loading || !storeId || storeId === `${store === null || store === void 0 ? void 0 : store.code}`) {
            return;
        }
        const isVirtualAppointmentStoreCode = Number(storeId) === virtualStoreCode;
        if (isVirtualAppointmentStoreCode) {
            setStore(getStoreData(undefined, getAppointmentTypeData()));
            return;
        }
        getBookAppointmentStore(Number(storeId));
    }, [
        queryParams,
        store,
        loading,
        error,
        virtualStoreCode,
        setStore,
        getStoreData,
        getAppointmentTypeData,
        getBookAppointmentStore, 
    ]);
    React.useEffect(()=>{
        if (!called || !data || loading) {
            return;
        }
        setStore(data);
    }, [
        called,
        data,
        loading,
        setStore
    ]);
};

const useBookAppointmentTypeWithUrlParam = ()=>{
    const [, { queryParams  }] = useRoutingContext$2();
    const [getBookAppointmentType, { error , loading , called , data  }] = useBookAppointmentType();
    const [{ setType  }, { type  }] = useAppointmentContext();
    const [{ getAppointmentTypeData  }, { typeId: virtualTypeId  }] = useVirtualAppointment();
    React.useEffect(()=>{
        if (error) {
            console.error(error);
            return;
        }
        const { typeId: typeIdFromUrl  } = queryParams;
        const typeId = fromArrayToString(typeIdFromUrl);
        if (loading || !typeId || typeId === (type === null || type === void 0 ? void 0 : type.id)) {
            return;
        }
        const isVirtualAppointmentTypeId = typeId === virtualTypeId;
        if (isVirtualAppointmentTypeId) {
            setType(getAppointmentTypeData());
            return;
        }
        getBookAppointmentType(typeId);
    }, [
        queryParams,
        type,
        loading,
        error,
        virtualTypeId,
        setType,
        getAppointmentTypeData,
        getBookAppointmentType, 
    ]);
    React.useEffect(()=>{
        if (!called || !data || loading) {
            return;
        }
        setType(data);
    }, [
        called,
        data,
        loading,
        setType
    ]);
};

const useBookAppointmentTimeSlotWithUrlParam = ()=>{
    const [, { queryParams  }] = useRoutingContext$2();
    const [{ setTimeSlot  }, { timeSlot  }] = useAppointmentContext();
    React.useEffect(()=>{
        const { start: startFromUrl , end: endFromUrl  } = queryParams;
        const start = fromArrayToString(startFromUrl);
        const end = fromArrayToString(endFromUrl);
        const hasDifferentTimeSlotFromUrl = !timeSlot || start !== `${timeSlot.from.getTime()}` || end !== `${timeSlot.until.getTime()}`;
        if (start && end && hasDifferentTimeSlotFromUrl) {
            setTimeSlot({
                from: new Date(Number(start)),
                until: new Date(Number(end))
            });
        }
    }, [
        queryParams,
        timeSlot,
        setTimeSlot
    ]);
};

const getExtraDataEvent = (data)=>{
    const { appointment , store  } = data !== null && data !== void 0 ? data : {};
    var _id, ref, ref1, ref2;
    return swcHelpers.objectSpread({
        appointment: {
            type_of_appointment: appointment ? getTypeOfAppointment(appointment) : '',
            type_of_service: (_id = appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType.id) !== null && _id !== void 0 ? _id : '',
            age_range: appointment ? getAgeRange(appointment) : ''
        },
        store: {
            id: store ? String(store.code) : '',
            name: (ref = store === null || store === void 0 ? void 0 : store.name) !== null && ref !== void 0 ? ref : '',
            address: getStoreAddress(store),
            postalCode: (ref1 = store === null || store === void 0 ? void 0 : store.postalCode) !== null && ref1 !== void 0 ? ref1 : '',
            city: (ref2 = store === null || store === void 0 ? void 0 : store.town) !== null && ref2 !== void 0 ? ref2 : ''
        },
        time: {
            startTime: (appointment === null || appointment === void 0 ? void 0 : appointment.startTime) ? DateUtils.toLocalDateTimeTimeZone(appointment.startTime) : '',
            endTime: (appointment === null || appointment === void 0 ? void 0 : appointment.endTime) ? DateUtils.toLocalDateTimeTimeZone(appointment.endTime) : ''
        }
    }, (appointment === null || appointment === void 0 ? void 0 : appointment.id) ? {
        appointmentId: {
            id: appointment.id
        }
    } : {});
};
const getTypeOfAppointment = (appointment)=>appointment.appointmentType.isVirtualAppointment ? 'videocall' : 'onsite'
;
const getAgeRange = (appointment)=>appointment.appointmentType.isChildAppointment ? 'child appointment' : 'adult'
;
const getStoreAddress = (store)=>store ? `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}` : ''
;
const getStoreDetails = (storeDetails)=>{
    const { city , country , id , name , postalCode  } = storeDetails;
    return {
        city,
        country,
        id,
        name,
        postalCode,
        address: getStoreAddress(swcHelpers.objectSpread({
            town: storeDetails.city
        }, storeDetails))
    };
};
const getStoreDetailsWithoutCountry = (storeDetails)=>{
    const { city , id , name , postalCode  } = storeDetails;
    return {
        city,
        id,
        name,
        postalCode,
        address: getStoreAddress(swcHelpers.objectSpread({
            town: storeDetails.city
        }, storeDetails))
    };
};
const getAgeRangeLabel = (isChildAppointment)=>isChildAppointment === undefined ? '' : isChildAppointment ? 'child appointment' : 'adult'
;

const rescheduleAppointmentScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '800',
                condition_of_appointment: 'reschedule',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: 'screen-for',
                section_of_the_element: '',
                text_of_the_element: 'reschedule',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const rescheduleAppointmentConfirmationScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '900',
                condition_of_appointment: 'reschedule',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: 'screen-for',
                section_of_the_element: '',
                text_of_the_element: 'reschedule-confirmation',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const cancelAppointmentScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '1000',
                condition_of_appointment: 'cancel',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: 'screen-for',
                section_of_the_element: '',
                text_of_the_element: 'cancel',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const cancelAppointmentConfirmationScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '1100',
                condition_of_appointment: 'cancel',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: 'screen-for',
                section_of_the_element: '',
                text_of_the_element: 'cancel-confirmation',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentWhereStepScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '110',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'where',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentWhatStepScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '200',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'what',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentWhenStepScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '300',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'when',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentWhoStepScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '400',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'who',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const getStepNumber$1 = (steps, step)=>steps[step]
;
const isValidStepKey = (route, steps)=>route in steps
;
const bookAppointmentStepClickEvent = (input, steps, originStep, targetStep)=>{
    const originStepNumber = getStepNumber$1(steps, originStep);
    const targetStepNumber = getStepNumber$1(steps, targetStep);
    return {
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '420',
                condition_of_appointment: 'new',
                action_taken: 'change'
            },
            label: {
                clicked_element: 'main menu',
                text_of_the_element: `${originStepNumber} - ${targetStepNumber}`,
                extra: getExtraDataEvent(input)
            }
        }
    };
};
const bookAppointmentSelectedChoiceClickEvent = (input, steps, originStep, targetStep)=>{
    const originStepNumber = getStepNumber$1(steps, originStep);
    const targetStepNumber = getStepNumber$1(steps, targetStep);
    return {
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '421',
                condition_of_appointment: 'new',
                action_taken: 'change'
            },
            label: {
                clicked_element: 'side menu',
                text_of_the_element: `${originStepNumber} - ${targetStepNumber}`,
                extra: getExtraDataEvent(input)
            }
        }
    };
};
const bookAppointmentConfirmationScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '500',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'appointment confirmation',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentOnSurveyLinkClick = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '520',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element: 'provide information - start survey',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const storeBookAppointmentClickEvent = ({ event , storeDetails ,  })=>({
        event,
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction: 'book appointment click'
            },
            store: getStoreDetails(storeDetails)
        }
    })
;
const storeFastAppointmentClickEvent = ({ event , storeDetails , selectedDateTime , appointmentType ,  })=>({
        event,
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction: 'book fast appointment click'
            },
            store: getStoreDetails(storeDetails),
            fastAppointment: {
                selectedDateTime: DateUtils.toLocalDateTimeTimeZone(selectedDateTime),
                appointmentType
            }
        }
    })
;
const storeChangeAppointmentTypeClickEvent = ({ event , storeDetails ,  })=>({
        event,
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction: 'change appointment type click'
            },
            store: getStoreDetails(storeDetails)
        }
    })
;
const appointmentBookingPreferredTimeEvent = ({ condition_of_appointment , appointment , step_number , isChildAppointment , text_of_the_element , storeDetails , time ,  })=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number,
                condition_of_appointment,
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element,
                extra: {
                    appointment: swcHelpers.objectSpread({}, appointment, {
                        age_range: getAgeRangeLabel(isChildAppointment)
                    }),
                    store: getStoreDetailsWithoutCountry(storeDetails),
                    time: {
                        startTime: time.startTime ? DateUtils.toLocalDateTimeTimeZone(time.startTime) : '',
                        endTime: time.endTime ? DateUtils.toLocalDateTimeTimeZone(time.endTime) : ''
                    }
                }
            }
        }
    })
;
const appointmentBookingAlternativeLocationEvent = ({ condition_of_appointment , appointment , isChildAppointment , text_of_the_element , storeDetails , time ,  })=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '397',
                condition_of_appointment,
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element,
                extra: {
                    appointment: swcHelpers.objectSpread({}, appointment, {
                        age_range: getAgeRangeLabel(isChildAppointment)
                    }),
                    store: getStoreDetailsWithoutCountry(storeDetails),
                    time: {
                        startTime: time.startTime ? DateUtils.toLocalDateTimeTimeZone(time.startTime) : '',
                        endTime: time.endTime ? DateUtils.toLocalDateTimeTimeZone(time.endTime) : ''
                    }
                }
            }
        }
    })
;
const appointmentConditionMapStepNumberAddToCalendar = {
    new: '510',
    reschedule: '910'
};
const appointmentBookingAddToCalendarEvent = ({ condition_of_appointment , appointment , isChildAppointment , text_of_the_element , storeDetails ,  })=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: appointmentConditionMapStepNumberAddToCalendar[condition_of_appointment],
                condition_of_appointment,
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element,
                extra: {
                    appointment: swcHelpers.objectSpread({}, appointment, {
                        age_range: getAgeRangeLabel(isChildAppointment)
                    }),
                    store: getStoreDetailsWithoutCountry(storeDetails),
                    time: {
                        // time is not applicable in this case
                        startTime: '',
                        endTime: ''
                    }
                }
            }
        }
    })
;

const steps = {
    where: 0,
    what: 1,
    when: 2,
    who: 3
};
const mapStepToRoute = Object.keys(steps).reduce((obj, key)=>swcHelpers.objectSpread({}, obj, {
        [steps[key]]: key
    })
, {});

const useDisableSteps = (active, queryParams)=>{
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingVirtualAppointmentTypeId  } = featureConfigs !== null && featureConfigs !== void 0 ? featureConfigs : {};
    const disabledSteps1 = React.useMemo(()=>{
        const disabledSteps = Object.keys(mapStepToRoute).map((step)=>Number(step)
        ).filter((step)=>step > active
        );
        const isVirtualAppointmentTypeId = queryParams.typeId === appointmentBookingVirtualAppointmentTypeId;
        /**  disable What step if typeId is virtual appointment type on the When or Who step */ if (isVirtualAppointmentTypeId && (active === steps.when || active === steps.who)) {
            disabledSteps.push(steps.what);
        }
        return disabledSteps;
    }, [
        active,
        queryParams,
        appointmentBookingVirtualAppointmentTypeId
    ]);
    return disabledSteps1;
};

const NavigationContainer = (_param)=>{
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    const { getLabel  } = useIntl();
    const [{ goTo  }, { queryParams , currentRoute  }] = useRoutingContext$2();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [{ setStore , setType , setTimeSlot  }, { store , type , timeSlot  }] = useAppointmentContext();
    const labels = React.useMemo(()=>[
            getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[0]}`),
            getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[1]}`),
            getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[2]}`),
            getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[3]}`), 
        ]
    , [
        getLabel
    ]);
    var _currentRoute;
    const active = (_currentRoute = steps[currentRoute]) !== null && _currentRoute !== void 0 ? _currentRoute : steps.where;
    const onStepClick = React.useCallback((_, index)=>{
        /** Do not do anything if clicking on the active */ if (active === index) {
            return;
        }
        const targetRoute = mapStepToRoute[index];
        const dataLayerSteps = {
            '': 1,
            where: 1,
            what: 2,
            when: 3,
            who: 4
        };
        if (isValidStepKey(currentRoute, dataLayerSteps) && isValidStepKey(targetRoute, dataLayerSteps)) {
            const dataLayerEvent = bookAppointmentStepClickEvent({
                store: store && !isVirtualAppointmentType(type) ? {
                    code: store.code,
                    streetName: store.streetName,
                    town: store.town,
                    name: store.name,
                    postalCode: store.postalCode,
                    streetNumber: store.streetNumber,
                    additionalStreetInfo: store.additionalStreetInfo
                } : undefined,
                appointment: type ? {
                    appointmentType: {
                        id: type.id,
                        isChildAppointment: type.isChildAppointment,
                        isVirtualAppointment: isVirtualAppointmentType(type)
                    },
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                } : undefined
            }, dataLayerSteps, currentRoute, targetRoute);
            DataLayer.pushEvent(dataLayerEvent);
        }
        switch(index){
            /** On Where route click remove all query params from url */ case 0:
                {
                    const { typeId , search , userLocation  } = queryParams;
                    setStore(null);
                    setTimeSlot(null);
                    goTo(targetRoute, {
                        typeId,
                        search,
                        userLocation
                    });
                    return;
                }
            /** On What route click should keep only storeId parameter in url */ case 1:
                {
                    const { storeId , search , userLocation  } = queryParams;
                    setType(null);
                    setTimeSlot(null);
                    goTo(targetRoute, {
                        storeId,
                        search,
                        userLocation
                    });
                    return;
                }
            /** On When route click remove start and end from query params */ case 2:
                {
                    const restQueryParams = swcHelpers.objectWithoutProperties(queryParams, [
                        "start",
                        "end"
                    ]);
                    setTimeSlot(null);
                    goTo(targetRoute, restQueryParams);
                    return;
                }
            default:
                {
                    goTo(targetRoute, queryParams);
                    return;
                }
        }
    }, [
        goTo,
        store,
        type,
        timeSlot,
        setType,
        setTimeSlot,
        setStore,
        isVirtualAppointmentType,
        currentRoute,
        active,
        queryParams, 
    ]);
    const disabledSteps = useDisableSteps(active, queryParams);
    /** If has typeId in the url and active step is Where, skip What step
   * The same logic for virtual appointment typeId
   */ const skippedSteps = React.useMemo(()=>queryParams.typeId && active === steps.where ? [
            steps.what
        ] : []
    , [
        queryParams,
        active
    ]);
    return /*#__PURE__*/ React.createElement(WizardProgress, swcHelpers.extends({}, rest, {
        className: classnames('book-appointment-navigation', className),
        steps: labels,
        active: active,
        disableSteps: disabledSteps,
        onClick: onStepClick,
        skipSteps: skippedSteps
    }));
};

const Header = (_param)=> {
    var { className , logo , isMobile , hasNavigation =true , title , srOnlyText  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "logo",
        "isMobile",
        "hasNavigation",
        "title",
        "srOnlyText"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('book-appointment-header', className)
    }), /*#__PURE__*/ React.createElement("header", {
        className: classnames('book-appointment-header__header', {
            'book-appointment-header__header--has-only-logo': !hasNavigation
        })
    }, logo && /*#__PURE__*/ React.createElement(Logo, {
        className: "book-appointment-header__logo",
        url: "/",
        image: logo,
        title: title,
        srOnlyText: `, ${srOnlyText}`
    }), hasNavigation && /*#__PURE__*/ React.createElement(NavigationContainer, {
        className: "book-appointment-header__navigation"
    })));
};

const HeaderContainer = (_param)=>{
    var { hasNavigation  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "hasNavigation"
    ]);
    const { logo  } = usePageData();
    const { getLabel  } = useIntl();
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    return /*#__PURE__*/ React.createElement(Header, swcHelpers.extends({}, rest, {
        isMobile: isMobile,
        logo: logo,
        hasNavigation: hasNavigation,
        title: getLabel('appointments.component.headerContainer.linkTitle'),
        srOnlyText: getLabel('appointments.component.headerContainer.linkTitle')
    }));
};

const Layout = (_param)=> {
    var { children , className , hasNavigation =true , resetHtmlScrolling =false , banner  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "hasNavigation",
        "resetHtmlScrolling",
        "banner"
    ]);
    return React.createElement(React.Fragment, null, resetHtmlScrolling ? /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
          /* fixes scroll to top issue */
          html {
            overflow: auto;
          }
        `) : null, /*#__PURE__*/ React.createElement("main", swcHelpers.extends({}, rest, {
        className: classnames('book-appointment-layout', className)
    }), /*#__PURE__*/ React.createElement(HeaderContainer, {
        hasNavigation: hasNavigation
    }), /*#__PURE__*/ React.createElement(CampaignInfoBannerContainer, swcHelpers.extends({}, banner)), /*#__PURE__*/ React.createElement("div", {
        "data-t": "layout-container",
        className: classnames('book-appointment-layout__container', {
            'book-appointment-layout__container--without-navigation': !hasNavigation
        })
    }, children)));
};

const LayoutContainer = (props)=>{
    const [_, { currentRoute  }] = useRoutingContext$2();
    const { campaignInfoBanner  } = usePageData();
    React.useEffect(()=>{
        /** If already at the top of the page should trigger scroll event
     * if client side routing changed to show the header. */ if (window.scrollY === 0) {
            window.dispatchEvent(new CustomEvent('scroll'));
        } else {
            window.scrollTo(0, 0);
        }
    }, [
        currentRoute
    ]);
    return /*#__PURE__*/ React.createElement(Layout, swcHelpers.extends({}, props, {
        banner: campaignInfoBanner,
        hasNavigation: currentRoute !== 'confirmation',
        resetHtmlScrolling: ![
            '',
            'where'
        ].includes(currentRoute)
    }));
};

const normaliseQueryParams = (queryParams)=>Object.entries(queryParams).filter((entry)=>{
        const isValidValue = (value)=>[
                'string',
                'undefined'
            ].includes(typeof value)
        ;
        const [, value1] = entry;
        return isValidValue(value1) || Array.isArray(value1) && value1.every(isValidValue);
    }).reduce((acc, [key, value])=>{
        const result = fromArrayToString(value);
        if (result !== undefined) {
            acc[key] = result;
        }
        return acc;
    }, {})
;

const useClientSideRouter = ({ basePath , initialRoute ='' , initialQueryParams ={} , onRouteChange , routerId  })=>{
    const [currentQueryParams1, setCurrentQueryParams] = React.useState(normaliseQueryParams(initialQueryParams));
    const [currentRoute, setCurrentRoute] = React.useState(initialRoute);
    const onRedirect = React.useCallback((event)=>{
        const { state  } = event;
        const { as =''  } = state !== null && state !== void 0 ? state : {};
        const [pathname, queryParams] = as.split('?');
        const routePath = pathname.replace(basePath, '');
        const [_, route] = routePath.split('/');
        var ref;
        setCurrentQueryParams(normaliseQueryParams((ref = QueryString.parse(queryParams !== null && queryParams !== void 0 ? queryParams : '')) !== null && ref !== void 0 ? ref : {}));
        setCurrentRoute(route || '');
        onRouteChange && onRouteChange(route || '');
    }, [
        basePath,
        onRouteChange
    ]);
    const goTo = React.useCallback((redirectPath)=>{
        // Need to add state to pushState to not break browser back button event
        window.history.pushState({
            as: redirectPath
        }, '', redirectPath);
        onRedirect({
            state: {
                as: redirectPath
            }
        });
    }, []);
    const updateCurrentQueryParams = React.useCallback((href)=>{
        var ref;
        const search = (ref = (href !== null && href !== void 0 ? href : window.location.href).split('?')[1]) !== null && ref !== void 0 ? ref : '';
        const currentQueryParams = normaliseQueryParams(QueryString.parse(search));
        setCurrentQueryParams(currentQueryParams);
    }, []);
    /*
   * Since we have no way to detect replaceState calls,
   * but we need to know when the query parameters are updated,
   * we want to hook into the replaceState calls by using a proxy.
   */ React.useEffect(()=>{
        // Store original value
        const original = window.history.replaceState;
        // Create revocable proxy
        const revocable = Proxy.revocable(window.history.replaceState, {
            apply: (target, thisArgument, args)=>{
                const result = Reflect.apply(target, thisArgument, args) // Call original implementation
                ;
                const url = args[2];
                updateCurrentQueryParams(url instanceof URL ? url.href : url) // Update query params we use across the app
                ;
                return result;
            }
        });
        // Temporarily replace original implementation by the proxy. Is reverted on unmounting.
        window.history.replaceState = revocable.proxy;
        return ()=>{
            window.history.replaceState = original // Restore original implementation
            ;
            revocable.revoke() // Revoke proxy
            ;
        };
    }, [
        updateCurrentQueryParams
    ]);
    React.useEffect(()=>{
        window.addEventListener('popstate', onRedirect);
        return ()=>{
            window.removeEventListener('popstate', onRedirect);
        };
    }, [
        onRedirect
    ]);
    return React.useMemo(()=>[
            {
                goTo
            },
            {
                basePath,
                currentRoute,
                queryParams: currentQueryParams1,
                routerId
            }
        ]
    , [
        goTo,
        basePath,
        currentRoute,
        currentQueryParams1,
        routerId
    ]);
};

const RoutingContextProvider$2 = ({ routeMap , initialRoutingState , initialAppointmentState , children , signInMyAccountUrl ='/my-account/login' ,  })=>{
    const { Provider  } = RoutingContext$2;
    const { basePath , currentRoute: initialRoute , queryParams: initialQueryParams ,  } = initialRoutingState;
    const [{ goTo  }, { queryParams: queryParams1 , currentRoute , routerId  }] = useClientSideRouter({
        basePath,
        initialRoute,
        initialQueryParams,
        routerId: 'book-appointment'
    });
    const goToHandler = React.useCallback((route, queryParams)=>{
        const newQueryParams = swcHelpers.objectSpread({}, queryParams);
        Object.keys(newQueryParams).forEach((key)=>newQueryParams[key] === undefined ? delete newQueryParams[key] : {}
        );
        goTo(`${basePath}/${route}${QueryString.toQueryParams(newQueryParams)}`);
    }, [
        basePath,
        goTo
    ]);
    const value = React.useMemo(()=>[
            {
                goTo: goToHandler
            },
            {
                component: routeMap[currentRoute],
                queryParams: queryParams1,
                currentRoute,
                basePath,
                signInMyAccountUrl,
                routerId
            }, 
        ]
    , [
        routeMap,
        goToHandler,
        currentRoute,
        basePath,
        queryParams1,
        signInMyAccountUrl,
        routerId
    ]);
    const RootComponent = routeMap[currentRoute];
    React.useEffect(()=>{
        if (initialQueryParams === null || initialQueryParams === void 0 ? void 0 : initialQueryParams.affiliateId) {
            setStoredAffiliateId(fromArrayToString(initialQueryParams === null || initialQueryParams === void 0 ? void 0 : initialQueryParams.affiliateId));
        }
    }, [
        initialQueryParams
    ]);
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, /*#__PURE__*/ React.createElement(AppointmentContextProvider, {
        initialState: initialAppointmentState
    }, /*#__PURE__*/ React.createElement(LayoutContainer, null, /*#__PURE__*/ React.createElement(RootComponent, null), children)));
};
RoutingContextProvider$2.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, currentRoute, routeMap, params, locale) {
        const isValidRoute = currentRoute in routeMap;
        if (!isValidRoute) {
            throw new Error('UNKNOWN_ERROR');
        }
        const RootComponent = routeMap[currentRoute];
        const initialAppointmentState = yield RootComponent.getServerSideProps(apolloClient, params, locale);
        return {
            initialAppointmentState
        };
    });
    return function(apolloClient, currentRoute, routeMap, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

const useAddToCalendarDlEventDispatcher = ({ appointmentCondition , store , type , timeSlot , isVirtualAppointment  })=>{
    const pushAddToCalendarDlEvent = React__default.useCallback(()=>{
        if (store) {
            var ref;
            const dataLayerEvent = appointmentBookingAddToCalendarEvent({
                condition_of_appointment: appointmentCondition,
                isChildAppointment: type === null || type === void 0 ? void 0 : type.isChildAppointment,
                appointment: {
                    type_of_appointment: isVirtualAppointment ? 'videocall' : 'onsite',
                    type_of_service: (ref = type === null || type === void 0 ? void 0 : type.id) !== null && ref !== void 0 ? ref : ''
                },
                storeDetails: swcHelpers.objectSpread({
                    id: store.code.toString(),
                    city: store.town
                }, store),
                text_of_the_element: 'add to calendar',
                time: {
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                }
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        appointmentCondition,
        store,
        type,
        timeSlot,
        isVirtualAppointment
    ]);
    return React__default.useMemo(()=>({
            pushAddToCalendarDlEvent
        })
    , [
        pushAddToCalendarDlEvent
    ]);
};

const appointment$4 = gql`
  fragment BookAppointmentResult on Appointment {
    id
    status
    isReservation
    store {
      code
    }
    appointmentType {
      name
    }
    startTime
    endTime
    invitee {
      firstName
      lastName
      phone
      email
    }
    child {
      firstName
      lastName
      dateOfBirth
    }
    preferredChannelOfCommunication
    customerComment
    createdBy
  }
`;
const failures$1 = gql`
  fragment FailureMessage on AppointmentFailure {
    message
  }
`;
const BOOK_APPOINTMENT = gql`
  mutation BookAppointment($data: BookAppointmentInput!) {
    bookAppointment(data: $data) {
      appointment {
        ...BookAppointmentResult
      }
      failures {
        ...FailureMessage
      }
    }
  }
  ${appointment$4}
  ${failures$1}
`;

const calendarAvailability = gql`
  fragment CalendarAvailability on Availability {
    perDay
    percentageAvailable
    slotsAvailable
    storeCode
  }
`;
const GET_CALENDAR_AVAILABILITY = gql`
  query GetCalendarAvailability(
    $appointmentTypeIds: [ID!]!
    $endDate: String!
    $endTime: String
    $startDate: String!
    $startTime: String
    $storeCodes: [String!]!
  ) {
    availabilityByStoreCodes(
      appointmentTypeIds: $appointmentTypeIds
      endDate: $endDate
      endTime: $endTime
      startDate: $startDate
      startTime: $startTime
      storeCodes: $storeCodes
    ) {
      ...CalendarAvailability
    }
  }
  ${calendarAvailability}
`;

const timeSlots = gql`
  fragment TimeSlots on TimeSlot {
    from
    until
  }
`;
const GET_TIME_SLOTS = gql`
  query GetTimeSlots(
    $appointmentTypeId: ID!
    $date: String
    $opticianId: ID
    $storeCode: ID
    $storeId: ID
  ) {
    timeSlots(
      appointmentTypeId: $appointmentTypeId
      date: $date
      opticianId: $opticianId
      storeCode: $storeCode
      storeId: $storeId
    ) {
      ...TimeSlots
    }
  }
  ${timeSlots}
`;

const storeOfferByCode = gql`
  fragment StoreOfferByCode on Store {
    offers {
      title
      description
      url
      imageUrl
    }
  }
`;
const GET_STORE_OFFER_BY_CODE = gql`
  query GetStoreOfferByCode($code: Int) {
    store(code: $code) {
      ...StoreOfferByCode
    }
  }
  ${storeOfferByCode}
`;

const availableStoreNearbyBookAppointmentType = gql`
  fragment AvailableStoreNearbyAppointmentType on StoreAppointmentType {
    id
    name
    description
    duration {
      amount
      unit
    }
    isAvailableInStore
    isChildAppointment
  }
`;
const availableStoreNearby = gql`
  fragment AvailableStoreNearby on Store {
    code
    name
    shortName
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    email
    phone
    slug
    appointmentTypes {
      ...AvailableStoreNearbyAppointmentType
    }
    distance
  }
  ${availableStoreNearbyBookAppointmentType}
`;
const availableStoreNearbyResponseFailure = gql`
  fragment AvailableStoreNearbyResponseFailure on AppointmentFailure {
    message
  }
`;
const availableStoreNearbyResponse = gql`
  fragment AvailableStoreNearbyResponseData on AvailableStoreNearbyResponse {
    store {
      ...AvailableStoreNearby
    }
    failures {
      ...AvailableStoreNearbyResponseFailure
    }
  }
  ${availableStoreNearby}
  ${availableStoreNearbyResponseFailure}
`;
const GET_AVAILABLE_STORE_NEARBY = gql`
  query GetAvailableStoreNearby(
    $latitude: Latitude!
    $longitude: Longitude!
    $appointmentTypeId: ID!
    $startDate: Date!
    $startTime: String
    $endTime: String
  ) {
    availableStoreNearby(
      latitude: $latitude
      longitude: $longitude
      appointmentTypeId: $appointmentTypeId
      startDate: $startDate
      startTime: $startTime
      endTime: $endTime
    ) {
      ...AvailableStoreNearbyResponseData
    }
  }
  ${availableStoreNearbyResponse}
`;

const user = gql`
  fragment BookAppointmentUser on Customer {
    email
    defaultBillingAddress {
      salutation
      firstName
      lastName
      postalCode
    }
    personalDetails {
      salutation
      firstName
      lastName
      phone
      dateOfBirth
      ssn
    }
    optIns {
      id
      literalText
      uiType
      value
    }
  }
`;
const GET_BOOK_APPOINTMENT_USER = gql`
  query GetBookAppointmentUser {
    me {
      ...BookAppointmentUser
    }
  }
  ${user}
`;

const storeOpeningTimesByCode = gql`
  fragment StoreOpeningTimesByCode on Store {
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      dateOpenClosed
      openClosed
      openClosedTime {
        open
        close
      }
    }
  }
`;
const GET_STORE_OPENING_TIMES_BY_CODE = gql`
  query GetStoreOpeningTimesByCode($code: Int) {
    store(code: $code) {
      ...StoreOpeningTimesByCode
    }
  }
  ${storeOpeningTimesByCode}
`;

const fromTimeSlotsQueryToTimeSlots = (data)=>{
    if (!data) {
        return null;
    }
    return data.map(({ from , until  })=>({
            from: new Date(from),
            until: new Date(until)
        })
    );
};

const fromCalendarAvailabilityQueryToCalendarAvailability = (data)=>{
    var _perDay;
    const perDay = (_perDay = data === null || data === void 0 ? void 0 : data.availabilityByStoreCodes[0].perDay) !== null && _perDay !== void 0 ? _perDay : {};
    return Object.entries(perDay).reduce((acc, [dateString, { slotsAvailable  }])=>{
        acc[dateString] = slotsAvailable ? slotsAvailable > 0 : false;
        return acc;
    }, {});
};

const fromStoreOfferQueryToStore = (data)=>{
    if (!data) {
        return null;
    }
    try {
        return data.offers.map((offer)=>{
            const { title , description , url , imageUrl  } = offer;
            return {
                title,
                description: description !== null && description !== void 0 ? description : undefined,
                url: url !== null && url !== void 0 ? url : undefined,
                imageUrl: imageUrl !== null && imageUrl !== void 0 ? imageUrl : undefined
            };
        });
    } catch (e) {
        console.error('Store offer data adapter failed to parse input data correctly.', e, data);
        return null;
    }
};

const useCalendarAvailability = ()=>{
    const [query, queryState] = useLazyQuery(GET_CALENDAR_AVAILABILITY, {
        fetchPolicy: 'no-cache',
        context: {
            timeout: 10000
        }
    });
    const getCalendarAvailability = React.useCallback(({ appointmentTypeId , storeCode , startDate , endDate , startTime , endTime  })=>{
        query({
            variables: {
                appointmentTypeIds: [
                    appointmentTypeId
                ],
                storeCodes: [
                    storeCode
                ],
                startDate: toLocalDate(startDate),
                endDate: toLocalDate(endDate),
                startTime: startTime ? toLocalTimeMinutes(startTime) : undefined,
                endTime: endTime ? toLocalTimeMinutes(endTime) : undefined
            }
        });
    }, [
        query
    ]);
    const data = React.useMemo(()=>fromCalendarAvailabilityQueryToCalendarAvailability(queryState.data)
    , [
        queryState.data
    ]);
    const { called , error , loading  } = queryState;
    return React.useMemo(()=>[
            getCalendarAvailability,
            {
                called,
                loading,
                data,
                error
            }
        ]
    , [
        getCalendarAvailability,
        called,
        loading,
        data,
        error, 
    ]);
};

const useTimeSlots = (props = {})=>{
    const { locale  } = useIntl();
    const { timeFilters  } = props;
    const [query, queryState] = useLazyQuery(GET_TIME_SLOTS, {
        fetchPolicy: 'no-cache',
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.timeSlots) ? fromTimeSlotsQueryToTimeSlots(queryState.data.timeSlots) : null;
    }, [
        queryState
    ]);
    const filtered = React.useMemo(()=>{
        const result = {
            included: [],
            excluded: []
        };
        if (!data) {
            return result;
        }
        const sorted = data.sort((a, b)=>a.from.getTime() - b.from.getTime()
        );
        if (!(timeFilters === null || timeFilters === void 0 ? void 0 : timeFilters.length)) {
            result.included = sorted;
            return result;
        }
        return sorted.reduce((acc, timeSlot)=>{
            const include = timeFilters.some((filter)=>filter(timeSlot.from)
            );
            if (include) {
                acc.included.push(timeSlot);
            } else {
                acc.excluded.push(timeSlot);
            }
            return acc;
        }, result);
    }, [
        timeFilters,
        data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data,
                filtered
            }), 
        ]
    , [
        data,
        filtered,
        queryState,
        query
    ]);
};

const useStoreOfferByCode = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_OFFER_BY_CODE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store) ? fromStoreOfferQueryToStore(queryState.data.store) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const fromAvailableStoreQueryToStore = (storeQueryData, distanceUnit)=>{
    if (!storeQueryData) {
        return null;
    }
    try {
        const { code , name: name1 , shortName , email , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , slug , appointmentTypes , distance: distance1 ,  } = storeQueryData;
        let computedDistanceUnit = distanceUnit;
        if (distance1 && distance1 < 1000) {
            if (distanceUnit === DistanceUnit.meter || distanceUnit === DistanceUnit.km) {
                computedDistanceUnit = DistanceUnit.meter;
            }
        }
        const isDistanceInMeters = (distance)=>typeof distance === 'number'
        ;
        var _amount, _unit;
        return {
            code,
            name: name1,
            shortName,
            streetName,
            town,
            country,
            phone,
            slug: slug !== null && slug !== void 0 ? slug : undefined,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
            postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
            province: province !== null && province !== void 0 ? province : undefined,
            lat: lat !== null && lat !== void 0 ? lat : undefined,
            lon: lon !== null && lon !== void 0 ? lon : undefined,
            emailAddress: email !== null && email !== void 0 ? email : undefined,
            appointmentTypes: appointmentTypes.filter(({ isAvailableInStore  })=>isAvailableInStore
            ).map(({ id , name , description , duration , isChildAppointment  })=>({
                    id,
                    name,
                    description: description !== null && description !== void 0 ? description : '',
                    duration: {
                        amount: (_amount = duration.amount) !== null && _amount !== void 0 ? _amount : 0,
                        unit: (_unit = duration.unit) !== null && _unit !== void 0 ? _unit : 'MINUTES'
                    },
                    isChildAppointment
                })
            ),
            distance: isDistanceInMeters(distance1) ? formatDistance(distance1, computedDistanceUnit, {
                separator: ' '
            }) : undefined
        };
    } catch (e) {
        console.error('Available store query data adapter failed to parse input data correctly.', e, storeQueryData);
        return null;
    }
};

const useAvailableStoreNearby = ()=>{
    const [query, queryState] = useLazyQuery(GET_AVAILABLE_STORE_NEARBY, {
        fetchPolicy: 'no-cache'
    });
    const { distanceUnit  } = useIntl();
    const data = React.useMemo(()=>{
        var ref;
        return fromAvailableStoreQueryToStore((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.availableStoreNearby.store, distanceUnit);
    }, [
        queryState.data,
        distanceUnit
    ]);
    const getAvailableStoreNearby = React.useCallback(({ latitude , longitude , appointmentTypeId , startDate , startTime , endTime  })=>{
        query({
            variables: {
                latitude,
                longitude,
                appointmentTypeId,
                startDate: toLocalDate(startDate),
                startTime,
                endTime
            }
        });
    }, [
        query
    ]);
    return React.useMemo(()=>[
            getAvailableStoreNearby,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getAvailableStoreNearby,
        queryState,
        data, 
    ]);
};

const AppointmentConfirmationInstructions = (_param)=>{
    var { isPhone , confirmationContent , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "isPhone",
        "confirmationContent",
        "className"
    ]);
    if (!confirmationContent) return null;
    var _description;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-confirmation-instructions', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: classnames('appointment-confirmation-instructions__section-heading', className)
    }, confirmationContent.title), confirmationContent.image && /*#__PURE__*/ React.createElement("img", {
        className: classnames('appointment-confirmation-instructions__image', className),
        src: isPhone ? confirmationContent.image.mobile.url : confirmationContent.image.original.url,
        alt: (_description = confirmationContent.image.description) !== null && _description !== void 0 ? _description : undefined
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames('appointment-confirmation-instructions__description', className),
        dangerouslySetInnerHTML: {
            __html: confirmationContent.description.value
        }
    }));
};

const AppointmentConfirmationInstructionsContainer = (props)=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    return /*#__PURE__*/ React.createElement(AppointmentConfirmationInstructions, swcHelpers.extends({}, props, {
        isPhone: isPhone
    }));
};

var AppointmentCommunicationChannel$2;
(function(AppointmentCommunicationChannel) {
    AppointmentCommunicationChannel["EMAIL"] = "EMAIL";
    AppointmentCommunicationChannel["SMS"] = "SMS";
})(AppointmentCommunicationChannel$2 || (AppointmentCommunicationChannel$2 = {}));
const AppointmentOverview = (_param)=>{
    var { appointment , className , labels , addressData , children , isStoreLoading =false  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointment",
        "className",
        "labels",
        "addressData",
        "children",
        "isStoreLoading"
    ]);
    const { dateTime , getLabel  } = useIntl();
    const { invitee , child , appointmentType , startTime , endTime  } = appointment;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-overview', className)
    }), invitee && /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: "appointment-overview__body-head"
    }, invitee.firstName, " ", invitee.lastName), child && /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: "appointment-overview__body-head"
    }, labels.child, ": ", child.firstName, " ", child.lastName), /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__details"
    }, appointmentType && /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: "appointment-overview__body-head"
    }, appointmentType.name), isValid(startTime) && isValid(endTime) && /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__date-time",
        "data-t": "address-data"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "appointment-overview__date"
    }, dateTime.formatLongDate(startTime)), /*#__PURE__*/ React.createElement(Text, null, `${dateTime.formatTime(startTime)} - ${dateTime.formatTime(endTime)}`))), isStoreLoading ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__store"
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "60px",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "20px",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "50%",
        height: "20px",
        rx: "5",
        fill: "currentColor",
        y: "30"
    })))) : addressData && /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__store"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: "appointment-overview__body-head"
    }, addressData.storeName), /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__store-address"
    }, /*#__PURE__*/ React.createElement(Address, {
        data: addressData
    }))), labels.additionalInformation && appointment.customerComment ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__additional-information"
    }, labels.additionalInformation, appointment.customerComment) : null, children);
};

const AppointmentOverviewContainer = (_param)=>{
    var { appointment , store , isStoreLoading  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "appointment",
        "store",
        "isStoreLoading"
    ]);
    const { getLabel  } = useIntl();
    var _streetNumber, _additionalStreetInfo, _postalCode;
    const addressData = React.useMemo(()=>store ? {
            storeName: store.name,
            streetName: store.streetName,
            town: store.town,
            streetNumber: (_streetNumber = store.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : '',
            additionalStreetInfo: (_additionalStreetInfo = store.additionalStreetInfo) !== null && _additionalStreetInfo !== void 0 ? _additionalStreetInfo : '',
            postalCode: (_postalCode = store.postalCode) !== null && _postalCode !== void 0 ? _postalCode : ''
        } : undefined
    , [
        store
    ]);
    const labels = React.useMemo(()=>({
            child: getLabel('appointments.component.appointmentOverview.child'),
            additionalInformation: getLabel('appointments.component.appointmentOverview.additionalInformation')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentOverview, swcHelpers.extends({}, props, {
        appointment: appointment,
        labels: labels,
        addressData: addressData,
        isStoreLoading: isStoreLoading
    }));
};

const AppointmentSurvey = (_param)=> {
    var { className , labels , surveyUrl , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "surveyUrl",
        "onClick"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-survey', className)
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, labels.title), /*#__PURE__*/ React.createElement(Text, null, labels.description), /*#__PURE__*/ React.createElement(Button, {
        className: "appointment-survey__button",
        caption: labels.cta,
        icon: "checklist",
        href: surveyUrl,
        onClick: onClick,
        hrefTarget: "_blank"
    }));
};

const AppointmentSurveyContainer = (props)=>{
    const { getLabel  } = useIntl();
    const [, { type , appointment , store , timeSlot  }] = useAppointmentContext();
    const { featureConfigs  } = useFeatureToggles();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.component.appointmentSurvey.title'),
            description: getLabel('appointments.component.appointmentSurvey.description'),
            cta: getLabel('appointments.component.appointmentSurvey.cta')
        })
    , [
        getLabel
    ]);
    const surveyUrl = React.useMemo(()=>{
        var ref;
        if (!type || !(appointment === null || appointment === void 0 ? void 0 : appointment.id) || (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation)) {
            return;
        }
        const appointmentBookingSurveyConfig = (ref = featureConfigs.appointmentBookingSurveyLinks) === null || ref === void 0 ? void 0 : ref.find((appointmentBookingSurveyLink)=>{
            return appointmentBookingSurveyLink[0] === (type === null || type === void 0 ? void 0 : type.id);
        });
        if (appointmentBookingSurveyConfig) {
            var ref1;
            return (ref1 = appointmentBookingSurveyConfig[1]) === null || ref1 === void 0 ? void 0 : ref1.replace(`{appointmentId}`, appointment.id);
        }
    }, [
        appointment,
        type,
        featureConfigs.appointmentBookingSurveyLinks
    ]);
    const onSurveyLinkClick = React.useCallback(()=>{
        if (store && type && timeSlot && appointment) {
            const dataLayerEvent = bookAppointmentOnSurveyLinkClick({
                store: !isVirtualAppointmentType(type) ? {
                    code: store.code,
                    streetName: store.streetName,
                    town: store.town,
                    name: store.name,
                    postalCode: store.postalCode,
                    streetNumber: store.streetNumber,
                    additionalStreetInfo: store.additionalStreetInfo
                } : undefined,
                appointment: {
                    id: appointment === null || appointment === void 0 ? void 0 : appointment.id,
                    appointmentType: {
                        id: type.id,
                        isChildAppointment: type.isChildAppointment,
                        isVirtualAppointment: isVirtualAppointmentType(type)
                    },
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                }
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        store,
        type,
        timeSlot,
        appointment,
        isVirtualAppointmentType
    ]);
    if (!surveyUrl) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AppointmentSurvey, swcHelpers.extends({}, props, {
        labels: labels,
        surveyUrl: surveyUrl,
        onClick: onSurveyLinkClick
    }));
};

// https://icalendar.org/iCalendar-RFC-5545/3-1-content-lines.html
const foldTextIfNeededAccordingToICSSpec = (text, numOfChars = 74)=>{
    const regex = new RegExp(`(.{${numOfChars}})`, 'g');
    // formats text into new line and a space after X characters
    return text.replace(regex, '$1\n ');
};
// https://developer.mozilla.org/en-US/docs/Glossary/CRLF
const convertToCRLFLineEndings = (text)=>text.replace(/\n/g, '\r\n')
;
const generateIcsEvent = ({ title , description , location , start , end , lat , lon , name , email , appointmentTypeId  })=>{
    // Do not change indenting, it will break the format
    return convertToCRLFLineEndings(`BEGIN:VCALENDAR
VERSION:2.0
CALSCALE:GREGORIAN
PRODID:grandvision/appointment
METHOD:PUBLISH
X-PUBLISHED-TTL:PT1H
BEGIN:VEVENT
UID:${v5(appointmentTypeId || 'appointment', NIL)}
${foldTextIfNeededAccordingToICSSpec(`SUMMARY:${title}`)}
DTSTAMP:${format(new Date(), `yyyyMMdd'T'HHmmss`)}
DTSTART:${format(start, `yyyyMMdd'T'HHmmss`)}
DTEND:${format(end, `yyyyMMdd'T'HHmmss`)}
SEQUENCE:1
${foldTextIfNeededAccordingToICSSpec(`DESCRIPTION:${description}`)}${/* don't put a newline if GEO coords not available */ lat && lon ? `\nGEO:${lat};${lon}` : ``}
${foldTextIfNeededAccordingToICSSpec(`LOCATION:${location}`)}
STATUS:CONFIRMED
${foldTextIfNeededAccordingToICSSpec(`ORGANIZER;CN=${name}:mailto:${email ? `${email}` : ``}`)}
BEGIN:VALARM
ACTION:DISPLAY
${foldTextIfNeededAccordingToICSSpec(`DESCRIPTION:Reminder: ${description}`, 74)}
TRIGGER:-PT2H
END:VALARM
END:VEVENT
END:VCALENDAR
`);
};
const generateIcsBlob = (icsEvent)=>new Blob([
        icsEvent
    ], {
        type: 'text/calendar'
    })
;
const generateIcsUrl = (icsBlob)=>URL.createObjectURL(icsBlob)
;
var ICSUtils = {
    generateIcsEvent,
    generateIcsBlob,
    generateIcsUrl
};

const ICSButton = (_param)=>{
    var { appointmentType , className , timeSlot , store , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointmentType",
        "className",
        "timeSlot",
        "store",
        "onClick"
    ]);
    const onButtonClick = React.useCallback(()=>{
        onClick === null || onClick === void 0 ? void 0 : onClick();
        const { name , description , id  } = appointmentType;
        const { town , streetName , streetNumber , additionalStreetInfo , postalCode , lat , lon , name: storeName , email ,  } = store;
        const icsEvent = ICSUtils.generateIcsEvent({
            title: name,
            description: description ? description : name,
            location: `${town} - ${streetName}${streetNumber ? ` ${streetNumber}` : ''}${additionalStreetInfo ? `, ${additionalStreetInfo}` : ''}${postalCode ? `, ${postalCode}` : ''}`,
            start: timeSlot.from,
            end: timeSlot.until,
            lat,
            lon,
            name: storeName,
            email,
            appointmentTypeId: id
        });
        const icsBlob = ICSUtils.generateIcsBlob(icsEvent);
        window.navigator.msSaveOrOpenBlob ? window.navigator.msSaveOrOpenBlob(icsBlob, 'appointment') // IE11
         : window.open(ICSUtils.generateIcsUrl(icsBlob), '_blank') // Evergreen
        ;
    }, [
        appointmentType,
        timeSlot,
        store,
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({}, rest, {
        onClick: onButtonClick,
        className: classnames('ics-button', className),
        icon: "calendar"
    }));
};

const StoreOverview = (_param)=> {
    var { className , labels , mapImageUrl , addressData , phoneHidden , emailHidden , email , storeDetailLink , phone  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "mapImageUrl",
        "addressData",
        "phoneHidden",
        "emailHidden",
        "email",
        "storeDetailLink",
        "phone"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-overview', className)
    }), /*#__PURE__*/ React.createElement("img", {
        className: "store-overview__map",
        src: mapImageUrl,
        alt: addressData.storeName,
        "data-t": "staticMapImage"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "store-overview__content"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: "store-overview__store-name"
    }, addressData.storeName), /*#__PURE__*/ React.createElement(Address, {
        data: addressData,
        className: "store-overview__address"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-overview__contact"
    }, !phoneHidden && phone && /*#__PURE__*/ React.createElement("div", {
        className: "store-overview__contact-field"
    }, /*#__PURE__*/ React.createElement("a", {
        href: `tel:${phone}`,
        "data-t": "phone"
    }, phone)), !emailHidden && email && /*#__PURE__*/ React.createElement("div", {
        className: "store-overview__contact-field"
    }, /*#__PURE__*/ React.createElement("a", {
        href: `mailto:${email}`,
        "data-t": "email"
    }, email)))), /*#__PURE__*/ React.createElement("a", {
        target: "_blank",
        rel: "noreferrer",
        href: storeDetailLink
    }, labels.storeDetailLink)));
};

const StoreOverviewContainer = (_param)=>{
    var { store , googleMapsApiKey , storesUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store",
        "googleMapsApiKey",
        "storesUrl"
    ]);
    const { getLabel  } = useIntl();
    const { isStoreDetailsEmailEnabled , isStoreDetailsPhoneEnabled  } = useFeatureToggles();
    const labels = React.useMemo(()=>({
            storeDetailLink: getLabel('appointments.component.storeOverview.storeDetailLink')
        })
    , [
        getLabel
    ]);
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province , country , name , lat , lon , phone , email , slug ,  } = store;
    const addressData = React.useMemo(()=>({
            storeName: name,
            additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : '',
            streetName,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : '',
            postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : '',
            town,
            province: province !== null && province !== void 0 ? province : '',
            country
        })
    , [
        name,
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province,
        country
    ]);
    const mapImageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lon}&zoom=13&size=640x200&scale=2&markers=anchor:28,48|icon:https://assets.grandvision.io/global/store2.png|scale:2%7C${lat},${lon}&mapType=roadmap&key=${googleMapsApiKey}`;
    const storeDetailLink = `${storesUrl}/${slugify(town)}/${slug}`;
    return /*#__PURE__*/ React.createElement(StoreOverview, swcHelpers.extends({}, rest, {
        labels: labels,
        addressData: addressData,
        mapImageUrl: mapImageUrl,
        storeDetailLink: storeDetailLink,
        phoneHidden: !isStoreDetailsPhoneEnabled,
        emailHidden: !isStoreDetailsEmailEnabled,
        phone: phone,
        email: email
    }));
};

const adaptUserData = (data, labels)=>{
    const user = [];
    const { firstName , lastName , email , phone , child  } = data;
    user.push({
        label: labels.name,
        value: `${firstName !== null && firstName !== void 0 ? firstName : ''} ${lastName !== null && lastName !== void 0 ? lastName : ''}`.trim()
    });
    var ref, ref1;
    user.push({
        label: labels.child,
        value: `${(ref = child === null || child === void 0 ? void 0 : child.firstName) !== null && ref !== void 0 ? ref : ''} ${(ref1 = child === null || child === void 0 ? void 0 : child.lastName) !== null && ref1 !== void 0 ? ref1 : ''}`.trim()
    });
    user.push({
        label: labels.email,
        value: email !== null && email !== void 0 ? email : ''
    });
    user.push({
        label: labels.phone,
        value: phone !== null && phone !== void 0 ? phone : ''
    });
    return user.filter((el)=>el.value !== ''
    );
};

const UserInfoOverview = (_param)=>{
    var { className , user  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "user"
    ]);
    if (!user.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('user-info-overview', className)
    }), user.map(({ label , value  })=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: label
        }, /*#__PURE__*/ React.createElement(Text, {
            className: "user-info-overview__label",
            variant: "body-head"
        }, label), /*#__PURE__*/ React.createElement(Text, {
            className: "user-info-overview__value"
        }, value))
    ));
};

const UserInfoOverviewContainer = (_param)=>{
    var { user  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "user"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            name: getLabel('appointments.component.userInfoOverview.name'),
            child: getLabel('appointments.component.userInfoOverview.child'),
            email: getLabel('appointments.component.userInfoOverview.email'),
            phone: getLabel('appointments.component.userInfoOverview.phone')
        })
    , [
        getLabel
    ]);
    const userData = React.useMemo(()=>adaptUserData(user, labels)
    , [
        user,
        labels
    ]);
    return /*#__PURE__*/ React.createElement(UserInfoOverview, swcHelpers.extends({}, rest, {
        user: userData
    }));
};

const StoreOffers$1 = Containers.StoreOffers;
const AppointmentConfirmation = ({ className , labels , store , offers , type , timeSlot , appointment , googleMapsApiKey , storesUrl , directionsUrl , appointmentConfirmationContent , offerFallbackImageUrl , isVirtualAppointmentType , onICSButtonClick ,  })=>{
    var ref, ref1, ref2, ref3;
     return React.createElement("main", {
        className: classnames('appointment-confirmation', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "appointment-confirmation__headings"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__heading",
        component: "h2",
        variant: "small"
    }, labels.heading), /*#__PURE__*/ React.createElement(Hr, {
        className: "appointment-confirmation__horizontal-rule"
    }), labels.subHeading && /*#__PURE__*/ React.createElement("p", {
        className: "appointment-confirmation__sub-heading"
    }, labels.subHeading)), /*#__PURE__*/ React.createElement(Alert, {
        icon: "checkmark-circle",
        type: "success",
        message: /*#__PURE__*/ React.createElement("b", null, labels.notification),
        className: "appointment-confirmation__alert"
    }), /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__appointment"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.appointment), /*#__PURE__*/ React.createElement(AppointmentOverviewContainer, {
        className: "appointment-confirmation__section-content appointment-confirmation__appointment_overview",
        appointment: swcHelpers.objectSpread({}, appointment, {
            invitee: undefined,
            child: undefined
        })
    }), !appointment.isReservation && /*#__PURE__*/ React.createElement(ICSButton, {
        className: "appointment-confirmation__button",
        caption: labels.addToCalendar,
        appointmentType: type,
        timeSlot: timeSlot,
        store: store,
        variant: "outline",
        onClick: onICSButtonClick
    })), /*#__PURE__*/ React.createElement(AppointmentSurveyContainer, null), !isVirtualAppointmentType && /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__where"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.where), googleMapsApiKey && storesUrl && /*#__PURE__*/ React.createElement(StoreOverviewContainer, {
        className: "appointment-confirmation__section-content",
        store: store,
        googleMapsApiKey: googleMapsApiKey,
        storesUrl: storesUrl
    }), directionsUrl && /*#__PURE__*/ React.createElement(Button, {
        className: "appointment-confirmation__button",
        icon: "location-pin",
        variant: "outline",
        hrefTarget: "_blank",
        href: directionsUrl,
        caption: labels.getDirections
    })), /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__who"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.who), /*#__PURE__*/ React.createElement(UserInfoOverviewContainer, {
        className: "appointment-confirmation__section-content",
        user: {
            firstName: (ref = appointment.invitee) === null || ref === void 0 ? void 0 : ref.firstName,
            lastName: (ref1 = appointment.invitee) === null || ref1 === void 0 ? void 0 : ref1.lastName,
            email: (ref2 = appointment.invitee) === null || ref2 === void 0 ? void 0 : ref2.email,
            phone: (ref3 = appointment.invitee) === null || ref3 === void 0 ? void 0 : ref3.phone,
            child: appointment.child
        }
    })), !appointment.isReservation && /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__cant-make-it"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.cantMakeIt), /*#__PURE__*/ React.createElement("p", {
        className: "appointment-confirmation__section-content appointment-confirmation__cancel-or-reschedule"
    }, labels.cancelOrReschedule)), !appointment.isReservation && appointmentConfirmationContent && /*#__PURE__*/ React.createElement(AppointmentConfirmationInstructionsContainer, {
        confirmationContent: appointmentConfirmationContent
    }), !appointment.isReservation && offers && offers.length > 0 && /*#__PURE__*/ React.createElement(StoreOffers$1, {
        className: "appointment-confirmation__store-offers",
        fallbackImage: offerFallbackImageUrl,
        offers: offers,
        linkTarget: "_blank"
    }), /*#__PURE__*/ React.createElement(Button, {
        className: "appointment-confirmation__button",
        variant: "outline",
        hrefTarget: "_blank",
        href: "/",
        caption: labels.exploreProducts
    }));
};

const emptyArray$1 = [];
const AppointmentConfirmationContainer = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const [, { store , type , timeSlot , appointment: baseAppointment  }] = useAppointmentContext();
    const { googleMapsApiKey , storesUrl , opco , appointmentTypes , offerFallbackImageUrl ,  } = usePageData();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [getStoreOfferByCode, storeOfferByCode] = useStoreOfferByCode({
        code: 0
    });
    var ref;
    const labels = React.useMemo(()=>{
        var ref1;
        return {
            heading: getFormattedLabel(`appointments.component.appointmentConfirmation.${(baseAppointment === null || baseAppointment === void 0 ? void 0 : baseAppointment.isReservation) ? 'reservationHeading' : 'heading'}`, {
                labelData: {
                    name: (ref = baseAppointment === null || baseAppointment === void 0 ? void 0 : (ref1 = baseAppointment.invitee) === null || ref1 === void 0 ? void 0 : ref1.firstName) !== null && ref !== void 0 ? ref : ''
                }
            }),
            subHeading: getLabel(`appointments.component.appointmentConfirmation.${(baseAppointment === null || baseAppointment === void 0 ? void 0 : baseAppointment.isReservation) ? 'reservationSubheading' : 'subHeading'}`),
            notification: getLabel(`appointments.component.appointmentConfirmation.${(baseAppointment === null || baseAppointment === void 0 ? void 0 : baseAppointment.preferredChannelOfCommunication) === Types.AppointmentCommunicationChannel.EMAIL ? 'emailNotification' : 'smsNotification'}`),
            addToCalendar: getLabel('appointments.component.appointmentConfirmation.addToCalendar'),
            appointment: getLabel('appointments.component.appointmentConfirmation.appointment'),
            where: getLabel('appointments.component.appointmentConfirmation.where'),
            who: getLabel('appointments.component.appointmentConfirmation.who'),
            getDirections: getLabel('appointments.component.appointmentConfirmation.getDirections'),
            cantMakeIt: getLabel('appointments.component.appointmentConfirmation.cantMakeIt'),
            cancelOrReschedule: getFormattedLabel('appointments.component.appointmentConfirmation.cancelOrReschedule', {
                parseHTML: true,
                parseLink: true
            }),
            exploreProducts: getLabel('appointments.component.appointmentConfirmation.exploreProducts')
        };
    }, [
        baseAppointment,
        getLabel,
        getFormattedLabel
    ]);
    const appointment = React.useMemo(()=>baseAppointment && type ? swcHelpers.objectSpread({}, baseAppointment, {
            appointmentType: type
        }) : null
    , [
        baseAppointment,
        type
    ]);
    const directionsUrl = React.useMemo(()=>store ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([
            ...store.streetName.split(' '),
            store.town,
            opco || ''
        ].join(' '))}` : undefined
    , [
        store,
        opco
    ]);
    const appointmentConfirmationContent = React.useMemo(()=>{
        const foundContent = appointmentTypes === null || appointmentTypes === void 0 ? void 0 : appointmentTypes.find((content)=>{
            return content.typeId === (type === null || type === void 0 ? void 0 : type.id);
        });
        return foundContent === null || foundContent === void 0 ? void 0 : foundContent.appointmentConfirmationContent;
    }, [
        appointmentTypes,
        type
    ]);
    React.useEffect(()=>{
        if (!store) return;
        getStoreOfferByCode({
            variables: {
                code: Number(store.code)
            }
        });
    }, [
        getStoreOfferByCode,
        appointment,
        store
    ]);
    const { pushAddToCalendarDlEvent  } = useAddToCalendarDlEventDispatcher({
        appointmentCondition: 'new',
        type,
        store,
        isVirtualAppointment: isVirtualAppointmentType(type),
        timeSlot
    });
    React.useEffect(()=>{
        clearStoredAffiliateId();
    }, []);
    if (!store || !type || !timeSlot || !appointment) {
        return null;
    }
    var _data;
    return /*#__PURE__*/ React.createElement(AppointmentConfirmation, {
        labels: labels,
        store: store,
        offers: (_data = storeOfferByCode.data) !== null && _data !== void 0 ? _data : emptyArray$1,
        type: type,
        timeSlot: timeSlot,
        appointment: appointment,
        isVirtualAppointmentType: isVirtualAppointmentType(type),
        googleMapsApiKey: !isVirtualAppointmentType(type) ? googleMapsApiKey : undefined,
        storesUrl: !isVirtualAppointmentType(type) ? storesUrl : undefined,
        directionsUrl: directionsUrl,
        appointmentConfirmationContent: appointmentConfirmationContent,
        offerFallbackImageUrl: offerFallbackImageUrl,
        onICSButtonClick: pushAddToCalendarDlEvent
    });
};

const getBookAppointmentStore = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, code, locale) {
        if (code === undefined) {
            return null;
        }
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_BOOK_APPOINTMENT_STORE,
                variables: {
                    code
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeQueryData = data === null || data === void 0 ? void 0 : data.store;
            const storeData = fromStoreQueryToStore$2(storeQueryData);
            if (error) {
                console.error(error);
            }
            return storeData;
        } catch (error) {
            console.error(error);
            return null;
        }
    });
    return function getBookAppointmentStore(apolloClient, code, locale) {
        return _ref.apply(this, arguments);
    };
}();

const getBookAppointmentType = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, id, locale) {
        if (id === undefined) {
            return null;
        }
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_BOOK_APPOINTMENT_TYPE,
                variables: {
                    id
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const appointmentTypeQueryData = data === null || data === void 0 ? void 0 : data.appointmentType;
            const appointmentTypeData = fromAppointmentTypeQueryToAppointmentType(appointmentTypeQueryData);
            if (error) {
                console.error(error);
            }
            return appointmentTypeData;
        } catch (error) {
            console.error(error);
            return null;
        }
    });
    return function getBookAppointmentType(apolloClient, id, locale) {
        return _ref.apply(this, arguments);
    };
}();

var RoutingError$2;
(function(RoutingError) {
    RoutingError["MISSING_STORE_ID"] = "MISSING_STORE_ID";
    RoutingError["ALTERNATIVE_URL_STORE"] = "ALTERNATIVE_URL_STORE";
    RoutingError["STORE_NOT_FOUND"] = "STORE_NOT_FOUND";
    RoutingError["LINKED_APPOINTMENT_TYPE_NOT_VALID"] = "LINKED_APPOINTMENT_TYPE_NOT_VALID";
    RoutingError["MISSING_TYPE_ID"] = "MISSING_TYPE_ID";
    RoutingError["TYPE_NOT_FOUND"] = "TYPE_NOT_FOUND";
    RoutingError["TYPE_NOT_AVAILABLE_FOR_STORE"] = "TYPE_NOT_AVAILABLE_FOR_STORE";
    RoutingError["INVALID_VIRTUAL_APPOINTMENT"] = "INVALID_VIRTUAL_APPOINTMENT";
    RoutingError["MISSING_TIMESLOT_START"] = "MISSING_TIMESLOT_START";
    RoutingError["MISSING_TIMESLOT_END"] = "MISSING_TIMESLOT_END";
    RoutingError["MISSING_APPOINTMENT_ID"] = "MISSING_APPOINTMENT_ID";
})(RoutingError$2 || (RoutingError$2 = {}));
const MissingStoreIdError = ()=>new Error(RoutingError$2.MISSING_STORE_ID)
;
const AlternativeUrlStoreError = ()=>new Error(RoutingError$2.ALTERNATIVE_URL_STORE)
;
const StoreNotFoundError = ()=>new Error(RoutingError$2.STORE_NOT_FOUND)
;
const MissingTypeIdError = ()=>new Error(RoutingError$2.MISSING_TYPE_ID)
;
const TypeNotFoundError = ()=>new Error(RoutingError$2.TYPE_NOT_FOUND)
;
const TypeNotAvailableForStoreError = ()=>new Error(RoutingError$2.TYPE_NOT_AVAILABLE_FOR_STORE)
;
const LinkedAppointmentTypeNotValidError = ()=>new Error(RoutingError$2.LINKED_APPOINTMENT_TYPE_NOT_VALID)
;
const InvalidVirtualAppointmentError = ()=>new Error(RoutingError$2.INVALID_VIRTUAL_APPOINTMENT)
;
const MissingTimeSlotStartError = ()=>new Error(RoutingError$2.MISSING_TIMESLOT_START)
;
const MissingTimeSlotEndError = ()=>new Error(RoutingError$2.MISSING_TIMESLOT_END)
;
const MissingAppointmentIdError = ()=>new Error(RoutingError$2.MISSING_APPOINTMENT_ID)
;
const routingErrorHandler$2 = (errorMessage, selfUrl, asPath, currentRoute, queryParams)=>{
    switch(errorMessage){
        case RoutingError$2.STORE_NOT_FOUND:
        case RoutingError$2.ALTERNATIVE_URL_STORE:
            delete queryParams.storeId;
        case RoutingError$2.MISSING_STORE_ID:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, '', queryParams)
            };
        case RoutingError$2.TYPE_NOT_AVAILABLE_FOR_STORE:
            if (currentRoute === '' || currentRoute === 'where') {
                delete queryParams.storeId;
            } else {
                delete queryParams.typeId;
            }
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, [
                    '',
                    'where'
                ].includes(currentRoute) ? currentRoute : 'what', queryParams)
            };
        case RoutingError$2.LINKED_APPOINTMENT_TYPE_NOT_VALID:
            delete queryParams.linkedAppointmentTypeId;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, currentRoute, queryParams)
            };
        case RoutingError$2.TYPE_NOT_FOUND:
            delete queryParams.typeId;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, [
                    '',
                    'where'
                ].includes(currentRoute) ? currentRoute : 'what', queryParams)
            };
        case RoutingError$2.MISSING_TYPE_ID:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, 'what', queryParams)
            };
        case RoutingError$2.INVALID_VIRTUAL_APPOINTMENT:
            delete queryParams.storeId;
            delete queryParams.typeId;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, '', queryParams)
            };
        case RoutingError$2.MISSING_TIMESLOT_START:
        case RoutingError$2.MISSING_TIMESLOT_END:
            delete queryParams.start;
            delete queryParams.end;
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, 'when', queryParams)
            };
        case RoutingError$2.MISSING_APPOINTMENT_ID:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, 'who', queryParams)
            };
        default:
            return {
                type: 'not-found'
            };
    }
};

const whereStep = 'where';
const isClient = typeof window !== 'undefined';
const ConfirmationRoot = ()=>{
    const [, { store , type , timeSlot , appointment  }] = useAppointmentContext();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [{ goTo  }] = useRoutingContext$2();
    if (isClient && !appointment) {
        goTo(whereStep, {});
        return null;
    }
    React.useEffect(()=>{
        if (store && type && timeSlot && appointment) {
            const dataLayerEvent = bookAppointmentConfirmationScreenEvent({
                store: !isVirtualAppointmentType(type) ? {
                    code: store.code,
                    streetName: store.streetName,
                    town: store.town,
                    name: store.name,
                    postalCode: store.postalCode,
                    streetNumber: store.streetNumber,
                    additionalStreetInfo: store.additionalStreetInfo
                } : undefined,
                appointment: {
                    id: appointment === null || appointment === void 0 ? void 0 : appointment.id,
                    appointmentType: {
                        id: type.id,
                        isChildAppointment: type.isChildAppointment,
                        isVirtualAppointment: isVirtualAppointmentType(type)
                    },
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                }
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    // Only run on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ React.createElement(AppointmentConfirmationContainer, null);
};
ConfirmationRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        if (formattedParams.storeId === undefined) {
            throw MissingStoreIdError();
        }
        if ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.storeId)) {
            throw AlternativeUrlStoreError();
        }
        if (formattedParams.typeId === undefined) {
            throw MissingTypeIdError();
        }
        if (formattedParams.start === undefined) {
            throw MissingTimeSlotStartError();
        }
        if (formattedParams.end === undefined) {
            throw MissingTimeSlotEndError();
        }
        if (formattedParams.appointmentId === undefined) {
            throw MissingAppointmentIdError();
        }
        let promises = [
            null,
            null
        ];
        if (hasValidVirtualAppointmentParams(formattedParams)) {
            const type = yield getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
            promises = [
                type ? generateVirtualAppointmentStoreData(formattedParams.virtualStoreCode, type) : null,
                type, 
            ];
        } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        } else {
            promises = [
                getBookAppointmentStore(apolloClient, formattedParams.storeId, locale),
                getBookAppointmentType(apolloClient, formattedParams.typeId, locale), 
            ];
        }
        const [store, type] = yield Promise.all(promises);
        if (!store) {
            throw StoreNotFoundError();
        } else if (!type) {
            throw TypeNotFoundError();
        } else if (type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        }
        return Promise.resolve({
            store,
            type,
            timeSlot: {
                from: formattedParams.start,
                until: formattedParams.end
            }
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

const defaultAppointmentFormContextValues = {
    Form: undefined
};
const appointmentFormContext = /*#__PURE__*/ React.createContext(defaultAppointmentFormContextValues);
const useAppointmentForm = ()=>{
    const context = React.useContext(appointmentFormContext);
    if (context === defaultAppointmentFormContextValues) {
        throw new Error('No AppointmentFormContextProvider available. You might still need to wrap the application with the appointment form context Provider.');
    }
    return context;
};
const AppointmentFormContextProvider = ({ Form , children  })=>{
    const { Provider  } = appointmentFormContext;
    const value = React.useMemo(()=>({
            Form
        })
    , [
        Form
    ]);
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, children);
};
appointmentFormContext.displayName = 'AppointmentFormContext';
appointmentFormContext.Consumer;

var _isReservation, _firstName, _lastName, ref$1, ref1, ref2, ref3, _preferredChannelOfCommunication, _customerComment;
const fromBookAppointmentMutationToBookedAppointment = (data)=>{
    var ref7, ref4, ref5, ref6;
    return data ? {
        id: data.id,
        isReservation: (_isReservation = data.isReservation) !== null && _isReservation !== void 0 ? _isReservation : false,
        startTime: new Date(data.startTime),
        endTime: new Date(data.endTime),
        child: data.child ? {
            firstName: (_firstName = data.child.firstName) !== null && _firstName !== void 0 ? _firstName : '',
            lastName: (_lastName = data.child.lastName) !== null && _lastName !== void 0 ? _lastName : '',
            dateOfBirth: data.child.dateOfBirth ? new Date(data.child.dateOfBirth) : null
        } : undefined,
        invitee: {
            firstName: (ref$1 = (ref7 = data.invitee) === null || ref7 === void 0 ? void 0 : ref7.firstName) !== null && ref$1 !== void 0 ? ref$1 : '',
            lastName: (ref1 = (ref4 = data.invitee) === null || ref4 === void 0 ? void 0 : ref4.lastName) !== null && ref1 !== void 0 ? ref1 : '',
            email: (ref2 = (ref5 = data.invitee) === null || ref5 === void 0 ? void 0 : ref5.email) !== null && ref2 !== void 0 ? ref2 : '',
            phone: (ref3 = (ref6 = data.invitee) === null || ref6 === void 0 ? void 0 : ref6.phone) !== null && ref3 !== void 0 ? ref3 : ''
        },
        preferredChannelOfCommunication: (_preferredChannelOfCommunication = data.preferredChannelOfCommunication) !== null && _preferredChannelOfCommunication !== void 0 ? _preferredChannelOfCommunication : undefined,
        customerComment: (_customerComment = data.customerComment) !== null && _customerComment !== void 0 ? _customerComment : undefined
    } : undefined;
};

const TIMEOUT = 30000;
const useBookAppointment = ()=>{
    const [, { store , type , timeSlot  }] = useAppointmentContext();
    const [query, queryState] = useMutation(BOOK_APPOINTMENT);
    const bookAppointment = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(token, formData) {
            if (!type || !store || !timeSlot) {
                throw new Error('Invalid application state, undefined type, store or timeslot');
            }
            try {
                yield query(swcHelpers.objectSpread({}, token ? {
                    context: {
                        forwardHeaders: {
                            Authorization: `Bearer ${token}`
                        },
                        timeout: TIMEOUT
                    }
                } : {
                    context: {
                        timeout: TIMEOUT
                    }
                }, {
                    variables: {
                        data: swcHelpers.objectSpread({
                            appointmentTypeId: type.id,
                            storeCode: `${store.code}`,
                            startTime: DateUtils.toLocalDateTime(timeSlot.from),
                            endTime: DateUtils.toLocalDateTime(timeSlot.until),
                            affiliateId: getStoredAffiliateId()
                        }, formData)
                    }
                }));
            } catch (e) {
                console.error('Error while creating appointment', e);
            }
        });
        return function(token, formData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        query,
        store,
        type,
        timeSlot
    ]);
    const data = React.useMemo(()=>{
        var ref, ref1;
        return {
            appointment: fromBookAppointmentMutationToBookedAppointment((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.bookAppointment.appointment),
            failures: (ref1 = queryState.data) === null || ref1 === void 0 ? void 0 : ref1.bookAppointment.failures
        };
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            bookAppointment,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        bookAppointment,
        queryState,
        data, 
    ]);
};

const useUser = ()=>{
    const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_USER);
    const userQuery = React.useCallback((token)=>query({
            context: {
                forwardHeaders: {
                    Authorization: `Bearer ${token}`
                }
            }
        })
    , [
        query
    ]);
    var ref;
    const data = React.useMemo(()=>{
        var ref1;
        return (ref = (ref1 = queryState.data) === null || ref1 === void 0 ? void 0 : ref1.me) !== null && ref !== void 0 ? ref : undefined;
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            userQuery,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        userQuery,
        queryState,
        data, 
    ]);
};

const useAuthToken = ()=>{
    const [execute, setExecute] = React.useState(true);
    const [token, setToken] = React.useState(undefined);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(undefined);
    const refreshToken = React.useCallback(()=>setExecute(true)
    , []);
    React.useEffect(()=>{
        const execAsync = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                setExecute(false);
                setLoading(true);
                setError(undefined);
                try {
                    const result = yield getToken();
                    if (result === null || result === void 0 ? void 0 : result.length) {
                        setToken(result);
                    }
                } catch (e) {
                    if (e instanceof Error) {
                        setError(e);
                    } else {
                        const message = 'Unknown error while getting the auth token';
                        setError(new Error(message));
                        console.error(message, e);
                    }
                } finally{
                    setLoading(false);
                }
            });
            return function execAsync() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!execute) {
            return;
        }
        execAsync();
    }, [
        execute
    ]);
    return React.useMemo(()=>[
            {
                refreshToken
            },
            {
                loading,
                data: token,
                error
            }
        ]
    , [
        refreshToken,
        loading,
        token,
        error, 
    ]);
};

var BookAppointmentFormLayout;
(function(BookAppointmentFormLayout) {
    BookAppointmentFormLayout["DEFAULT"] = "DEFAULT";
    BookAppointmentFormLayout["CHILD"] = "CHILD";
})(BookAppointmentFormLayout || (BookAppointmentFormLayout = {}));

const SelectedChoices = (_param)=> {
    var { className , choices  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "choices"
    ]);
    return React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('appointments-selected-choices', className)
    }), Object.entries(choices).map(([choice, { name , action , onClick  }], index)=>/*#__PURE__*/ React.createElement("li", {
            key: `${choice}-${name}`,
            className: "appointments-selected-choices__list-item"
        }, /*#__PURE__*/ React.createElement("button", {
            className: "appointments-selected-choices__button",
            onClick: onClick
        }, /*#__PURE__*/ React.createElement(Icon, {
            className: "appointments-selected-choices__checkmark",
            name: "checkmark",
            width: 30,
            height: 30
        }), /*#__PURE__*/ React.createElement(Text, {
            className: "appointments-selected-choices__name",
            variant: "caption"
        }, name), /*#__PURE__*/ React.createElement(Text, {
            className: "appointments-selected-choices__action",
            variant: "caption",
            "data-t": `changeSelectedChoice${index + 1}`
        }, action)))
    ));
};

const SelectedChoicesContainer = (props)=>{
    const { getLabel , dateTime: { formatLongDate , formatTime  } ,  } = useIntl();
    const [{ setStore , setType , setTimeSlot  }, { store , type , timeSlot  }] = useAppointmentContext();
    const [{ isVirtualAppointmentStore , isVirtualAppointmentType  }] = useVirtualAppointment();
    const [{ goTo  }, { currentRoute , queryParams  }] = useRoutingContext$2();
    const onNavigate = React.useCallback((targetRoute)=>{
        const dataLayerSteps = {
            '': 1,
            where: 1,
            what: 2,
            when: 3,
            who: 4
        };
        if (isValidStepKey(currentRoute, dataLayerSteps) && isValidStepKey(targetRoute, dataLayerSteps)) {
            const dataLayerEvent = bookAppointmentSelectedChoiceClickEvent({
                store: store && !isVirtualAppointmentType(type) ? {
                    code: store.code,
                    streetName: store.streetName,
                    town: store.town,
                    name: store.name,
                    postalCode: store.postalCode,
                    streetNumber: store.streetNumber,
                    additionalStreetInfo: store.additionalStreetInfo
                } : undefined,
                appointment: type ? {
                    appointmentType: {
                        id: type.id,
                        isChildAppointment: type.isChildAppointment,
                        isVirtualAppointment: isVirtualAppointmentType(type)
                    },
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                } : undefined
            }, dataLayerSteps, currentRoute, targetRoute);
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        currentRoute,
        isVirtualAppointmentType,
        store,
        type,
        timeSlot
    ]);
    const choices = React.useMemo(()=>{
        const value = {};
        const changeLabel = getLabel('appointments.component.selectedChoices.change');
        const clearLabel = getLabel('appointments.component.selectedChoices.clear');
        if (store && !isVirtualAppointmentStore(store)) {
            value.store = {
                name: store.shortName,
                action: changeLabel,
                onClick: ()=>{
                    const nextStep = 'where';
                    const { typeId , search , userLocation  } = queryParams;
                    onNavigate(nextStep);
                    setStore(null);
                    goTo(nextStep, {
                        typeId,
                        search,
                        userLocation
                    });
                }
            };
        }
        if (type) {
            const typeValue = {
                name: type.name,
                action: changeLabel
            };
            const { storeId , search , userLocation  } = queryParams;
            if (store) {
                typeValue.onClick = ()=>{
                    const nextStep = isVirtualAppointmentStore(store) ? 'where' : 'what';
                    onNavigate(nextStep);
                    setTimeSlot(null);
                    setType(null);
                    if (nextStep === 'where') {
                        setStore(null);
                        goTo(nextStep, {
                            search,
                            userLocation
                        });
                        return;
                    }
                    goTo(nextStep, {
                        storeId,
                        search,
                        userLocation
                    });
                };
            } else {
                typeValue.action = clearLabel;
                typeValue.onClick = ()=>{
                    const nextStep = 'where';
                    onNavigate(nextStep);
                    setType(null);
                    goTo(nextStep, {
                        search,
                        userLocation
                    });
                };
            }
            value.type = typeValue;
        }
        if (timeSlot) {
            const name = `${formatLongDate(timeSlot.from)}, ${formatTime(timeSlot.from)} - ${formatTime(timeSlot.until)}`;
            value.timeSlot = {
                name,
                action: changeLabel,
                onClick: ()=>{
                    const nextStep = 'when';
                    const { storeId , typeId , search , userLocation  } = queryParams;
                    onNavigate(nextStep);
                    setTimeSlot(null);
                    goTo(nextStep, {
                        storeId,
                        typeId,
                        search,
                        userLocation
                    });
                }
            };
        }
        return value;
    }, [
        store,
        type,
        timeSlot,
        onNavigate,
        goTo,
        queryParams,
        setStore,
        setType,
        setTimeSlot,
        isVirtualAppointmentStore,
        getLabel,
        formatLongDate,
        formatTime, 
    ]);
    return /*#__PURE__*/ React.createElement(SelectedChoices, swcHelpers.extends({}, props, {
        choices: choices
    }));
};

const AppointmentCustomerForm = ({ className , loading , loggedIn , Form , title , layout , initialFormState , onChange , onSubmit , submitting =false , formAlert =null ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('appointment-customer-form', className)
    }, /*#__PURE__*/ React.createElement(SelectedChoicesContainer, null), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "appointment-customer-form__title"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "appointment-customer-form__container",
        "aria-live": "polite"
    }, loading ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-customer-form__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)) : Form && /*#__PURE__*/ React.createElement(Form, {
        className: "appointment-customer-form__content",
        name: "bookAppointment",
        initialFormState: initialFormState,
        layout: layout,
        loggedIn: loggedIn,
        submitting: submitting,
        formAlert: formAlert,
        onChange: onChange,
        onSubmit: onSubmit
    })))
;

const getElementOffsetTop = (element)=>{
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return element ? element.getBoundingClientRect().top + scrollTop : 0;
};
const useScrollToField = (fieldName, callback)=>{
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    React.useEffect(()=>{
        var ref;
        if (!fieldName) {
            return;
        }
        const headerOffset = isMobile ? 160 : 110;
        var ref1;
        const element = (ref1 = (ref = document.getElementsByName(fieldName)) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : null;
        /** Get top position of the fieldName */ const top = getElementOffsetTop(element);
        /** Scroll to this fieldName with static offset based on the viewport */ window.scrollTo(0, top - headerOffset);
        callback && callback();
    }, [
        fieldName,
        isMobile,
        callback
    ]);
};

const getFirstInvalidField = (state, formGroupNames)=>{
    let fieldName1 = '';
    formGroupNames.find((groupName)=>{
        var _groupName;
        const invalidField = Object.keys((_groupName = state[groupName]) !== null && _groupName !== void 0 ? _groupName : {}).find((fieldName)=>{
            var ref;
            return !((ref = state[groupName][fieldName]) === null || ref === void 0 ? void 0 : ref.isValid);
        });
        if (invalidField) {
            fieldName1 = invalidField;
            return true;
        }
        return false;
    });
    return fieldName1;
};

var // new errors (failures) with new book appointment mutation
Errors;
(function(Errors) {
    Errors["EXTERNAL_SERVER_ERROR"] = 'ExternalServerErrorFailure';
    Errors["APPOINTMENT_CREATION_ERROR"] = 'AppointmentCreationFailure';
    Errors["APPOINTMENT_MAX_EXCEEDED"] = 'AppointmentMaxExceededFailure';
    Errors["APPOINTMENT_ALREADY_BOOKED_OR_NOT_AVAILABLE"] = 'AlreadyBookedOrNotAvailableFailure';
})(Errors || (Errors = {}));
var // error label keys for labels configured in bloomreach
ErrorLabelKeys;
(function(ErrorLabelKeys) {
    ErrorLabelKeys["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ErrorLabelKeys["EXTERNAL_SERVER_ERROR"] = "EXTERNAL_SERVER_ERROR";
    ErrorLabelKeys["APPOINTMENT_CREATION_ERROR"] = "APPOINTMENT_CREATION_ERROR";
    ErrorLabelKeys["APPOINTMENT_MAX_EXCEEDED"] = "APPOINTMENT_MAX_EXCEEDED";
    ErrorLabelKeys["APPOINTMENT_ALREADY_BOOKED_OR_NOT_AVAILABLE"] = "APPOINTMENT_ALREADY_BOOKED_OR_NOT_AVAILABLE";
})(ErrorLabelKeys || (ErrorLabelKeys = {}));
const AppointmentCustomerFormContainer = ()=>{
    const { Form  } = useAppointmentForm();
    const [userQuery, userQueryState] = useUser();
    const [, authTokenState] = useAuthToken();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const intl = useIntl();
    const { getLabel  } = intl;
    const [{ goTo  }, { queryParams  }] = useRoutingContext$2();
    const [{ setAppointment  }, { type , store , timeSlot  }] = useAppointmentContext();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const layout = (type === null || type === void 0 ? void 0 : type.isChildAppointment) ? BookAppointmentFormLayout.CHILD : BookAppointmentFormLayout.DEFAULT;
    const [bookAppointment, bookAppointmentState] = useBookAppointment();
    const [errorLabelKey, setErrorLabelKey] = React.useState();
    const [redirecting, setRedirecting] = React.useState(false);
    const [firstInvalidField, setFirstInvalidField] = React.useState('');
    const [initialFormState, setInitialState] = React.useState();
    const authToken = authTokenState.data;
    React.useEffect(()=>{
        if (!userQueryState.data) {
            return;
        }
        const options = {
            intl,
            layout
        };
        setInitialState(Form === null || Form === void 0 ? void 0 : Form.fromDataToState(userQueryState.data, options));
    }, [
        Form,
        intl,
        layout,
        userQueryState.data
    ]);
    const loading = authTokenState.loading || userQueryState.loading;
    const loggedIn = isMyAccountEnabled && Boolean(authToken);
    const onSubmit = React.useCallback((state)=>{
        if (!state.formValid) {
            /** Touch all fields to show invalid styles if has invalid fields */ setInitialState(touchComposedFormFields(state.formState));
            toast.failed('appointments.component.bookAppointmentForm.validationError');
            var ref;
            /** Get first invalid fields name to use it as a reference to scroll to this field*/ setFirstInvalidField(getFirstInvalidField(state.formState, (ref = Form === null || Form === void 0 ? void 0 : Form.getFormGroups({
                layout
            })) !== null && ref !== void 0 ? ref : []));
            return;
        }
        if (Form) {
            const formData = Form.fromStateToData(state.formState, {
                intl,
                layout
            }, {
                loggedIn
            });
            bookAppointment(authToken, formData);
        }
    }, [
        Form,
        intl,
        layout,
        authToken,
        bookAppointment,
        loggedIn
    ]);
    useScrollToField(firstInvalidField, ()=>setFirstInvalidField('')
    );
    React.useEffect(()=>{
        if (authToken) {
            userQuery(authToken);
        }
    }, [
        authToken,
        userQuery
    ]);
    React.useEffect(()=>{
        const bookedAppointment = bookAppointmentState.data.appointment;
        if (!bookedAppointment || redirecting) {
            return;
        }
        setRedirecting(true);
        setAppointment(bookedAppointment);
        setStoredAppointment(bookedAppointment);
        const { typeId , storeId , start , end  } = queryParams;
        goTo('confirmation', {
            typeId,
            storeId,
            start,
            end,
            appointmentId: bookedAppointment.id
        });
    // Only run on createdAppointment updates
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        bookAppointmentState
    ]);
    React.useEffect(()=>{
        const { typeId , storeId , start , end  } = queryParams;
        /** Need to track when user go back/forth with browser navigation.
     * In this situation update event only with data based on query parameters.
     */ const hasEqualTimeSlotFromUrl = timeSlot && start === `${timeSlot.from.getTime()}` && end === `${timeSlot.until.getTime()}`;
        const canPushEvent = store && type && hasEqualTimeSlotFromUrl && Number(storeId) === store.code && typeId === type.id;
        if (canPushEvent) {
            const dataLayerEvent = bookAppointmentWhoStepScreenEvent({
                store: !isVirtualAppointmentType(type) ? {
                    code: store.code,
                    streetName: store.streetName,
                    town: store.town,
                    name: store.name,
                    postalCode: store.postalCode,
                    streetNumber: store.streetNumber,
                    additionalStreetInfo: store.additionalStreetInfo
                } : undefined,
                appointment: {
                    appointmentType: {
                        id: type.id,
                        isChildAppointment: type.isChildAppointment,
                        isVirtualAppointment: isVirtualAppointmentType(type)
                    },
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                }
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        store,
        type,
        timeSlot,
        queryParams,
        isVirtualAppointmentType
    ]);
    React.useEffect(()=>{
        if (bookAppointmentState.error) {
            // the only apollo error that is possible is internalServerError
            setErrorLabelKey(ErrorLabelKeys.INTERNAL_SERVER_ERROR);
            return;
        }
        const bookAppointmentFailures = bookAppointmentState.data.failures;
        if (bookAppointmentFailures && bookAppointmentFailures.length > 0) {
            var ref;
            // we can only display 1 error at a time
            const failureType = (ref = bookAppointmentFailures[0]) === null || ref === void 0 ? void 0 : ref.__typename;
            switch(failureType){
                case Errors.APPOINTMENT_ALREADY_BOOKED_OR_NOT_AVAILABLE:
                    setErrorLabelKey(ErrorLabelKeys.APPOINTMENT_ALREADY_BOOKED_OR_NOT_AVAILABLE);
                    break;
                case Errors.APPOINTMENT_CREATION_ERROR:
                    setErrorLabelKey(ErrorLabelKeys.APPOINTMENT_CREATION_ERROR);
                    break;
                case Errors.APPOINTMENT_MAX_EXCEEDED:
                    setErrorLabelKey(ErrorLabelKeys.APPOINTMENT_MAX_EXCEEDED);
                    break;
                case Errors.EXTERNAL_SERVER_ERROR:
                    setErrorLabelKey(ErrorLabelKeys.EXTERNAL_SERVER_ERROR);
                    break;
                default:
                    setErrorLabelKey(ErrorLabelKeys.INTERNAL_SERVER_ERROR);
            }
            return;
        }
        setErrorLabelKey(undefined);
    }, [
        bookAppointmentState
    ]);
    const toCamelCase = (str)=>str.toLowerCase().replace(/[-_][a-z]/g, (group)=>group.slice(-1).toUpperCase()
        )
    ;
    const errorLabelSuffix = errorLabelKey ? toCamelCase(errorLabelKey) : '';
    return /*#__PURE__*/ React.createElement(AppointmentCustomerForm, {
        loading: loading,
        loggedIn: loggedIn,
        Form: Form,
        layout: layout,
        initialFormState: initialFormState,
        onSubmit: onSubmit,
        submitting: bookAppointmentState.loading,
        title: getLabel('appointments.component.bookAppointmentForm.title'),
        formAlert: errorLabelKey ? /*#__PURE__*/ React.createElement(Alert, {
            type: "warning",
            icon: "warning",
            title: getLabel(`appointments.component.bookAppointmentForm.alert.title.${errorLabelSuffix}`),
            message: getLabel(`appointments.component.bookAppointmentForm.alert.message.${errorLabelSuffix}`)
        }) : null
    });
};

const usePreferredTimeDataLayerEventDispatchers = ({ appointmentCondition , store , type , isVirtualAppointment , timeSlot  })=>{
    const createDataLayerEvent = React__default.useCallback((text_of_the_element, step_number)=>{
        if (store && type) {
            const { isChildAppointment , id: typeId  } = type;
            return appointmentBookingPreferredTimeEvent({
                condition_of_appointment: appointmentCondition,
                isChildAppointment,
                step_number,
                appointment: {
                    type_of_appointment: isVirtualAppointment ? 'videocall' : 'onsite',
                    type_of_service: typeId
                },
                storeDetails: swcHelpers.objectSpread({
                    id: store.code.toString(),
                    city: store.town
                }, store),
                text_of_the_element,
                time: {
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                }
            });
        }
    }, [
        store,
        type,
        timeSlot,
        appointmentCondition,
        isVirtualAppointment
    ]);
    return React__default.useMemo(()=>({
            onPreferredTimeClick: ()=>{
                const stepNumber = getStepNumber(false, appointmentCondition);
                const dataLayerEvent = createDataLayerEvent('preferred time', stepNumber);
                if (dataLayerEvent) {
                    DataLayer.pushEvent(dataLayerEvent);
                }
            },
            onPreferredTimeFilterClick: ({ option  })=>{
                try {
                    const elementText = getElementTextBasedOnOption(option);
                    const stepNumber = getStepNumber(true, appointmentCondition);
                    const dataLayerEvent = createDataLayerEvent(elementText, stepNumber);
                    if (dataLayerEvent) {
                        DataLayer.pushEvent(dataLayerEvent);
                    }
                } catch (error) {
                    console.error(error);
                // noop
                }
            }
        })
    , [
        createDataLayerEvent,
        appointmentCondition
    ]);
};
const isOptionContainsTime = (obj)=>typeof obj === 'object' && !!obj && 'from' in obj && 'until' in obj
;
const getElementTextBasedOnOption = (option)=>{
    if (isOptionContainsTime(option)) {
        if (option.name === 'noPreference') {
            throw new Error('no preference option should not have times defined');
        }
        return `${option.from} - ${option.until}`;
    }
    /*
    if from and until are undefined
    then option.name === noPreference and in this case we need to send 'no time preference'
    because the user clicked the first option that doesn't contain any specific time preference
  */ return 'no time preference';
};
const getStepNumber = (refersToButtonInTimeFilterModal, appointmentCondition)=>{
    let step_number;
    if (refersToButtonInTimeFilterModal) {
        step_number = appointmentCondition === 'new' ? '330' : '820';
    } else {
        step_number = appointmentCondition === 'new' ? '320' : '810';
    }
    return step_number;
};

const fromStoreOpeningTimesByCodeQueryToOpeningTimes = (data)=>{
    if (!data) {
        return null;
    }
    try {
        return Object.entries(data).reduce((acc, [key, value])=>{
            if (key === '__typename') {
                return acc;
            } else if (key === 'specialOpenClosingHours') {
                acc[key] = value && Object.values(value).map((entry1)=>({
                        dateOpenClosed: entry1.dateOpenClosed,
                        openClosed: entry1.openClosed,
                        openClosedTime: entry1.openClosedTime ? entry1.openClosedTime.map((entry)=>({
                                open: entry.open,
                                close: entry.close
                            })
                        ) : null
                    })
                );
            } else {
                acc[key] = value ? Object.values(value).map((entry)=>({
                        open: entry.open,
                        close: entry.close
                    })
                ) : null;
            }
            return acc;
        }, {
            monOpenClose: null,
            tueOpenClose: null,
            wedOpenClose: null,
            thuOpenClose: null,
            friOpenClose: null,
            satOpenClose: null,
            sunOpenClose: null,
            specialOpenClosingHours: null
        });
    } catch (e) {
        console.error('Store offer data adapter failed to parse input data correctly.', e, data);
        return null;
    }
};

const useStoreOpeningTimes = ()=>{
    const [query, queryState] = useLazyQuery(GET_STORE_OPENING_TIMES_BY_CODE);
    const data = React.useMemo(()=>{
        var ref;
        return fromStoreOpeningTimesByCodeQueryToOpeningTimes((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        query,
        queryState,
        data
    ]);
};

const useTimeFilterContextValue = (options = [])=>{
    const initialActiveState = React.useRef(options.reduce((acc, option)=>{
        acc[option.name] = false;
        return acc;
    }, {}));
    const [active, setActive] = React.useState(initialActiveState.current);
    const addActiveFilter = React.useCallback((name)=>setActive((curr)=>swcHelpers.objectSpread({}, curr, {
                [name]: true
            })
        )
    , []);
    const removeActiveFilter = React.useCallback((name)=>setActive((curr)=>swcHelpers.objectSpread({}, curr, {
                [name]: false
            })
        )
    , []);
    const clearActiveFilters = React.useCallback(()=>setActive(initialActiveState.current)
    , []);
    return React.useMemo(()=>[
            {
                addActiveFilter,
                removeActiveFilter,
                clearActiveFilters
            },
            {
                options,
                active
            }, 
        ]
    , [
        addActiveFilter,
        removeActiveFilter,
        clearActiveFilters,
        options,
        active
    ]);
};
const missingContextProviderWarning = ()=>console.warn('Missing TimeFilterContextProvider')
;
const fallbackValue = [
    {
        addActiveFilter: missingContextProviderWarning,
        removeActiveFilter: missingContextProviderWarning,
        clearActiveFilters: missingContextProviderWarning
    },
    {
        options: [],
        active: {}
    }, 
];
const timeFilterContext = /*#__PURE__*/ React.createContext(fallbackValue);
const useTimeFilterContext = ()=>React.useContext(timeFilterContext)
;
const TimeFilterContextProvider = ({ configuration , children  })=>{
    const { Provider  } = timeFilterContext;
    const value = useTimeFilterContextValue(configuration);
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, children);
};

const timeStringToNumbers = (timeString)=>timeString.split(':').map((part)=>parseInt(part, 10)
    )
;
const isValidHoursInput = (numbers)=>numbers.length === 2
;
const getFilterDate = (baseDate, timeString)=>{
    let date = null;
    const numbers = timeStringToNumbers(timeString);
    if (isValidHoursInput(numbers)) {
        date = new Date(baseDate) // Create a date on the same day as the provided date
        ;
        date.setHours(...numbers) // Set the time to the filter time
        ;
    }
    return date;
};
const getFilterDates = (baseDate, fromTimeString, untilTimeString)=>{
    const filterFromDate = getFilterDate(baseDate, fromTimeString);
    const filterUntilDate = getFilterDate(baseDate, untilTimeString);
    if (!filterFromDate || !filterUntilDate) {
        throw new Error(`Invalid filter value(s) passed: ${fromTimeString} & ${untilTimeString}`);
    }
    return {
        filterFromDate,
        filterUntilDate
    };
};
const useActiveTimeFilters = ()=>{
    const [, { active , options  }] = useTimeFilterContext();
    const activeOptions = React.useMemo(()=>options.filter((option)=>active[option.name]
        )
    , [
        active,
        options, 
    ]);
    const getAvailabilityTimeFilters = React.useCallback((date = new Date())=>{
        if (!activeOptions.length) {
            return {
                startTime: undefined,
                endTime: undefined
            };
        }
        const optionDates = activeOptions.map((option)=>[
                getFilterDate(date, option.from),
                getFilterDate(date, option.until)
            ]
        ).reduce((acc, [from, until])=>{
            if (from) {
                acc.push(from);
            }
            if (until) {
                acc.push(until);
            }
            return acc;
        }, []).sort((a, b)=>a.getTime() - b.getTime()
        );
        const first = optionDates[0];
        const [last] = optionDates.slice(-1);
        return {
            startTime: first,
            endTime: last
        };
    }, [
        activeOptions
    ]);
    const activeFilters = React.useMemo(()=>activeOptions.map((option)=>{
            return (from)=>{
                const { filterFromDate , filterUntilDate  } = getFilterDates(from, option.from, option.until);
                if (!filterFromDate || !filterUntilDate) {
                    throw new Error(`Invalid filter value(s) passed for ${option.name}: ${option.from} & ${option.until}`);
                }
                return isWithinTimeSpan(from, filterFromDate, filterUntilDate);
            };
        })
    , [
        activeOptions
    ]);
    return React.useMemo(()=>[
            {
                getAvailabilityTimeFilters
            },
            {
                activeFilters
            }
        ]
    , [
        getAvailabilityTimeFilters,
        activeFilters, 
    ]);
};

const firstAvailableDate = (weeks, availability = {})=>{
    const sortedAvailableDates = Object.entries(availability).map(([dateString, available])=>available ? new Date(dateString) : null
    ).filter((entry)=>entry !== null
    ).sort((a, b)=>a.getTime() - b.getTime()
    );
    const allWeekDates = [].concat(...weeks);
    return sortedAvailableDates.find((date)=>allWeekDates.find((entry)=>isSameDay(entry, date)
        )
    );
};
const getNextAvailableDate = (after, availability = {})=>{
    if (!after) {
        return;
    }
    const normalizedDate = new Date(after);
    normalizedDate.setHours(0, 0, 0, 0);
    const sortedAvailableDates = Object.entries(availability).map(([dateString, available])=>available ? new Date(dateString) : null
    ).filter((entry)=>entry !== null
    ).sort((a, b)=>a.getTime() - b.getTime()
    );
    return sortedAvailableDates.find((date)=>date.getTime() > normalizedDate.getTime()
    );
};
const getLastWeekDay = (weeks)=>{
    const [lastWeek = []] = weeks.slice(-1);
    const [lastWeekDay] = lastWeek.slice(-1);
    return lastWeekDay;
};
const OPENING_TIMES_DAY_INDEX = [
    'sunOpenClose',
    'monOpenClose',
    'tueOpenClose',
    'wedOpenClose',
    'thuOpenClose',
    'friOpenClose',
    'satOpenClose', 
];
const getSpecifiedOpeningTimes = (weeks, openingTimes)=>{
    const timeStringToDate = (date, timeString)=>{
        const [hours, minutes] = timeString.split(':');
        const timeStringDate = new Date(date);
        timeStringDate.setHours(parseInt(hours, 10));
        timeStringDate.setMinutes(parseInt(minutes, 10));
        timeStringDate.setSeconds(0);
        timeStringDate.setMilliseconds(0);
        return timeStringDate;
    };
    const openCloseTimeStringsToDates = (date, pair)=>({
            open: timeStringToDate(date, pair.open),
            close: timeStringToDate(date, pair.close)
        })
    ;
    const getFormattedTimePairs = (date, pairs)=>pairs ? pairs.filter((pair)=>pair.open !== null && pair.close !== null
        ).map((pair)=>openCloseTimeStringsToDates(date, pair)
        ) : null
    ;
    return weeks.reduce((acc1, week)=>week.reduce((acc, date)=>{
            const dateKey = toLocalDate(date);
            var _specialOpenClosingHours;
            const specialRoster = ((_specialOpenClosingHours = openingTimes.specialOpenClosingHours) !== null && _specialOpenClosingHours !== void 0 ? _specialOpenClosingHours : []).find(({ dateOpenClosed  })=>dateOpenClosed !== null && isSameDay(new Date(dateOpenClosed), date)
            );
            const regularRoster = getFormattedTimePairs(date, openingTimes[OPENING_TIMES_DAY_INDEX[date.getDay()]]);
            if (specialRoster) {
                if (specialRoster.openClosed === 'CLOSED' || !specialRoster.openClosedTime) {
                    acc[dateKey] = null;
                    return acc;
                }
                acc[dateKey] = getFormattedTimePairs(date, specialRoster.openClosedTime);
                return acc;
            }
            acc[dateKey] = regularRoster;
            return acc;
        }, acc1)
    , {});
};
const getClosedDates = (weeks, openingTimes)=>{
    const specifiedOpeningTimes = getSpecifiedOpeningTimes(weeks, openingTimes);
    return Object.entries(specifiedOpeningTimes).filter(([, value])=>value === null
    ).map(([key])=>new Date(key)
    );
};
const tileNameLabelsByWeeks = (weeks)=>{
    const firstWeek = weeks[0];
    return firstWeek.map((day)=>getDayLabel(day, 'short')
    );
};
const formatTileData = (weeks, availability = {}, closedDates = [], minEnabledDate, maxEnabledDate, selectedDate)=>{
    const normalizedMinEnabledDate = new Date(minEnabledDate);
    const normalizedMaxEnabledDate = maxEnabledDate ? new Date(maxEnabledDate) : null;
    const normalizedSelectedDate = selectedDate ? new Date(selectedDate) : null;
    normalizedMinEnabledDate.setHours(0, 0, 0, 0);
    normalizedMaxEnabledDate === null || normalizedMaxEnabledDate === void 0 ? void 0 : normalizedMaxEnabledDate.setHours(0, 0, 0, 0);
    normalizedSelectedDate === null || normalizedSelectedDate === void 0 ? void 0 : normalizedSelectedDate.setHours(0, 0, 0, 0);
    return weeks.map((week)=>week.map((date)=>{
            const normalizedDate = new Date(date);
            normalizedDate.setHours(0, 0, 0, 0);
            const disabled = maxEnabledDate ? !isWithinTimeSpan(normalizedDate, normalizedMinEnabledDate, maxEnabledDate) : isDateBefore(normalizedDate, normalizedMinEnabledDate);
            const closed = closedDates.some((entry)=>isSameDay(entry, normalizedDate)
            );
            var ref;
            const available = !disabled && !closed && ((ref = availability[toLocalDate(date)]) !== null && ref !== void 0 ? ref : false);
            const selected = !disabled && normalizedSelectedDate ? isSameDay(normalizedSelectedDate, normalizedDate) : false;
            return {
                date,
                available,
                closed,
                selected,
                disabled
            };
        })
    );
};

const useNextAvailableDate = (date, calendarAvailability, skip = false)=>{
    return React.useMemo(()=>skip ? undefined : getNextAvailableDate(date, calendarAvailability.data)
    , [
        skip,
        date,
        calendarAvailability
    ]);
};

const useNextWeekDate = (weeks, skip = false)=>{
    return React.useMemo(()=>{
        if (skip || !weeks) {
            return;
        }
        const lastWeekDay = getLastWeekDay(weeks);
        return shiftDate(lastWeekDay, 'day', 1);
    }, [
        skip,
        weeks
    ]);
};

var Variant;
(function(Variant) {
    Variant['none'] = 'none';
    Variant['closedDate'] = 'closedDate';
    Variant['closedWeek'] = 'closedWeek';
    Variant['date'] = 'date';
    Variant['week'] = 'week';
    Variant["error"] = "error";
})(Variant || (Variant = {}));

const useNoTimeSlotsVariant = (timeSlots, nextAvailableDate, selectedDate, closedDates)=>{
    return React.useMemo(()=>{
        const storeClosed = Boolean(closedDates === null || closedDates === void 0 ? void 0 : closedDates.find((item)=>new Date(item).toDateString() === (selectedDate && new Date(selectedDate).toDateString())
        ));
        if (!selectedDate) {
            return Variant.none;
        }
        if (!timeSlots.called || timeSlots.loading) {
            return Variant.none;
        }
        if (timeSlots.error) {
            return Variant.error;
        }
        if (storeClosed && nextAvailableDate) {
            return Variant.closedDate;
        }
        if (storeClosed && !nextAvailableDate) {
            return Variant.closedWeek;
        }
        if (!timeSlots.filtered.included.length && nextAvailableDate) {
            return Variant.date;
        }
        if (!timeSlots.filtered.included.length && !nextAvailableDate) {
            return Variant.week;
        }
        return Variant.none;
    }, [
        selectedDate,
        timeSlots,
        nextAvailableDate,
        closedDates
    ]);
};

const Tile = (_param)=> {
    var { className , day , month , loading , available , closed , selected , disabled  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "day",
        "month",
        "loading",
        "available",
        "closed",
        "selected",
        "disabled"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        type: "button",
        className: classnames('availability-calendar-tile', {
            'availability-calendar-tile--loading': loading,
            'availability-calendar-tile--available': available,
            'availability-calendar-tile--closed': closed,
            'availability-calendar-tile--selected': selected
        }, className),
        disabled: loading || disabled
    }), /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__day"
    }, day), month && /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__month"
    }, "\xa0", month, "\xa0"), /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__availability",
        "aria-hidden": true
    }, /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__availability-dot"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__cross",
        "aria-hidden": true
    }));
};

const TileContainer = (_param)=>{
    var { date , loading , available , selected , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "date",
        "loading",
        "available",
        "selected",
        "onClick"
    ]);
    const { getLabel , dateTime , locale  } = useIntl();
    const ariaAvailability = getLabel(`appointments.component.availabilityCalendar.tile.${available ? 'timesAvailable' : 'noTimesAvailable'}`);
    const ariaDate = dateTime.formatMidsizeDate(date);
    const ariaLabel = `${ariaDate}, ${ariaAvailability}`;
    let day = date.getDate();
    let month = '';
    if (day === 1) {
        const dayFormatter = new Intl.DateTimeFormat(locale, {
            day: 'numeric'
        });
        const monthFormatter = new Intl.DateTimeFormat(locale, {
            month: 'short'
        });
        day = dayFormatter.format(date);
        month = monthFormatter.format(date);
    }
    const onClickHandler = React.useCallback(()=>onClick(date)
    , [
        onClick,
        date
    ]);
    return /*#__PURE__*/ React.createElement(Tile, swcHelpers.extends({}, rest, {
        day: day,
        month: month,
        loading: loading,
        available: available,
        selected: selected,
        "aria-label": ariaLabel,
        onClick: onClickHandler
    }));
};

const AvailabilityCalendar = (_param)=> {
    var { id ='availability-calendar' , className , ariaLabels , range , tileNames , showPastButton =true , showFutureButton =true , onClickPastButton , onClickFutureButton , onClickTile , tiles , loading =false  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        "className",
        "ariaLabels",
        "range",
        "tileNames",
        "showPastButton",
        "showFutureButton",
        "onClickPastButton",
        "onClickFutureButton",
        "onClickTile",
        "tiles",
        "loading"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        id: id,
        className: classnames('availability-calendar', className)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "availability-calendar__header"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "availability-calendar__header-button-container"
    }, showPastButton && /*#__PURE__*/ React.createElement("button", {
        className: "availability-calendar__header-button",
        "aria-label": ariaLabels.pastButton,
        "aria-controls": `${id}__tiles`,
        onClick: onClickPastButton
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-left"
    }))), /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar__range"
    }, range), /*#__PURE__*/ React.createElement("div", {
        className: "availability-calendar__header-button-container"
    }, showFutureButton && /*#__PURE__*/ React.createElement("button", {
        className: "availability-calendar__header-button",
        "aria-label": ariaLabels.futureButton,
        "aria-controls": `${id}__tiles`,
        onClick: onClickFutureButton
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-right"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "availability-calendar__tile-names"
    }, tileNames.map((name)=>/*#__PURE__*/ React.createElement("span", {
            key: name,
            className: "availability-calendar__tile-name"
        }, name)
    ))), /*#__PURE__*/ React.createElement("div", {
        id: `${id}__tiles`,
        className: "availability-calendar__tiles",
        "aria-live": "polite"
    }, tiles.map((week)=>week.map((tile)=>/*#__PURE__*/ React.createElement(TileContainer, swcHelpers.extends({}, tile, {
                key: tile.date.getTime(),
                loading: loading,
                onClick: onClickTile
            }))
        )
    )));
};

const getWeekCount = (globalThis)=>{
    var ref;
    if (typeof globalThis === 'undefined') {
        return undefined;
    }
    return globalThis === null || globalThis === void 0 ? void 0 : (ref = globalThis.optimizelyGAAB4658Values) === null || ref === void 0 ? void 0 : ref.weekCount;
};
const hasOptimizelyABValues = (globalThis)=>{
    return Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.optimizelyGAAB4658Values);
};
const useOptimizelyWeekCount = (fallbackWeekCount)=>{
    var ref;
    const [weekCount, setWeekCount] = React.useState(typeof window !== 'undefined' ? (ref = getWeekCount(window)) !== null && ref !== void 0 ? ref : fallbackWeekCount : fallbackWeekCount);
    React.useEffect(()=>{
        if (hasOptimizelyABValues(window)) {
            return;
        }
        window.optimizelyGAAB4658Values = Object.create(null, {
            _internalCount: {
                value: undefined,
                enumerable: false,
                writable: true
            },
            weekCount: {
                enumerable: true,
                get () {
                    return this.internalCount;
                },
                set (value) {
                    this.internalCount = value;
                    setWeekCount(value !== null && value !== void 0 ? value : fallbackWeekCount);
                }
            }
        });
    }, [
        setWeekCount,
        weekCount,
        fallbackWeekCount
    ]);
    return weekCount;
};

const useRangeByWeeks = (weeks)=>{
    const { locale  } = useIntl();
    const firstWeek = weeks[0];
    const [lastWeek] = weeks.slice(-1);
    const firstDay = firstWeek[0];
    const [lastDay] = lastWeek.slice(-1);
    const dateFormat = Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short'
    });
    return `${dateFormat.format(firstDay)} - ${dateFormat.format(lastDay)}`;
};

const AvailabilityCalendarContainer = (_param)=>{
    var { selectedDate: _selectedDate , weekDate: _weekDate , weekCount: _weekCount = 2 , closedDates , minEnabledDate: _minEnabledDate , maxEnabledDate , availability ={} , loading =false , onSelectDate , onChangeWeeks  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "selectedDate",
        "weekDate",
        "weekCount",
        "closedDates",
        "minEnabledDate",
        "maxEnabledDate",
        "availability",
        "loading",
        "onSelectDate",
        "onChangeWeeks"
    ]);
    const weekStartOffset = 1 // Currently, the weeks will start on monday for all opcos. In the future this may need configurability.
    ;
    const { getLabel  } = useIntl();
    var ref;
    const weekCount = (ref = useOptimizelyWeekCount(_weekCount)) !== null && ref !== void 0 ? ref : _weekCount // TODO: Remove this after Optimizely A/B test
    ;
    const today = React.useRef(new Date());
    const [weekDate, setWeekDate] = React.useState(_weekDate !== null && _weekDate !== void 0 ? _weekDate : today.current);
    const [weeks, setWeeks] = React.useState(getWeekDaysForWeeksFromDate(weekDate, weekCount, weekStartOffset));
    const [selectedDate, setSelectedDate] = React.useState(_selectedDate);
    const minEnabledDate = _minEnabledDate !== null && _minEnabledDate !== void 0 ? _minEnabledDate : today.current;
    const ariaLabels = React.useMemo(()=>({
            pastButton: getLabel('appointments.component.availabilityCalendar.ariaLabels.pastButton'),
            futureButton: getLabel('appointments.component.availabilityCalendar.ariaLabels.futureButton')
        })
    , [
        getLabel
    ]);
    const range = useRangeByWeeks(weeks);
    const tileNames = React.useMemo(()=>tileNameLabelsByWeeks(weeks).map((label)=>getLabel(label)
        )
    , [
        getLabel,
        weeks
    ]);
    const tiles = React.useMemo(()=>formatTileData(weeks, availability, closedDates, minEnabledDate, maxEnabledDate, selectedDate)
    , [
        weeks,
        availability,
        minEnabledDate,
        maxEnabledDate,
        selectedDate,
        closedDates
    ]);
    const showPastButton = isDateBefore(minEnabledDate, shiftDate(weeks[0][0], 'day', -1));
    const showFutureButton = maxEnabledDate ? isDateBefore(shiftDate(weeks.slice(-1)[0].slice(-1)[0], 'day', 1), maxEnabledDate) : true;
    const onClickPastButton = React.useCallback(()=>{
        const newWeekDate = shiftDate(weekDate !== null && weekDate !== void 0 ? weekDate : today.current, 'week', -weekCount);
        setWeekDate(newWeekDate);
        const newWeeks = getWeekDaysForWeeksFromDate(newWeekDate, weekCount, weekStartOffset);
        setWeeks(newWeeks);
        onChangeWeeks && onChangeWeeks(newWeeks);
    }, [
        weekDate,
        setWeekDate,
        weekCount,
        weekStartOffset,
        onChangeWeeks
    ]);
    const onClickFutureButton = React.useCallback(()=>{
        const newWeekDate = shiftDate(weekDate !== null && weekDate !== void 0 ? weekDate : today.current, 'week', weekCount);
        setWeekDate(newWeekDate);
        const newWeeks = getWeekDaysForWeeksFromDate(newWeekDate, weekCount, weekStartOffset);
        setWeeks(newWeeks);
        onChangeWeeks && onChangeWeeks(newWeeks);
    }, [
        weekDate,
        setWeekDate,
        weekCount,
        weekStartOffset,
        onChangeWeeks
    ]);
    const onClickTile = React.useCallback((date)=>{
        setSelectedDate(date);
        onSelectDate && onSelectDate(date);
    }, [
        onSelectDate
    ]);
    // Prop values changed
    React.useEffect(()=>setSelectedDate(_selectedDate)
    , [
        _selectedDate
    ]);
    React.useEffect(()=>{
        const newWeekDate = _weekDate !== null && _weekDate !== void 0 ? _weekDate : today.current;
        setWeekDate(_weekDate !== null && _weekDate !== void 0 ? _weekDate : today.current);
        const newWeeks = getWeekDaysForWeeksFromDate(newWeekDate, weekCount, weekStartOffset);
        setWeeks(newWeeks);
        const [[currFirstDay]] = weeks;
        const currLastDay = getLastWeekDay(weeks);
        const [[newFirstDay]] = newWeeks;
        const newLastDay = getLastWeekDay(newWeeks);
        if (isSameDay(currFirstDay, newFirstDay) && isSameDay(currLastDay, newLastDay)) {
            return;
        }
        onChangeWeeks && onChangeWeeks(newWeeks);
    // Run only when _weekDate changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        _weekDate,
        weekCount
    ]) // TODO: Remove "weekCount" after Optimizely A/B test
    ;
    // Run at first mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(()=>onChangeWeeks && onChangeWeeks(weeks)
    , []);
    return /*#__PURE__*/ React.createElement(AvailabilityCalendar, swcHelpers.extends({}, rest, {
        ariaLabels: ariaLabels,
        range: range,
        showPastButton: showPastButton,
        showFutureButton: showFutureButton,
        onClickPastButton: onClickPastButton,
        onClickFutureButton: onClickFutureButton,
        onClickTile: onClickTile,
        tileNames: tileNames,
        tiles: tiles,
        loading: loading
    }));
};

const useTimeFilterItems = ({ allowSingleFilter  } = {})=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const [{ addActiveFilter , removeActiveFilter , clearActiveFilters  }, { active , options  }, ] = useTimeFilterContext();
    const onClick = React.useCallback((name)=>{
        if (active[name]) {
            removeActiveFilter(name);
        } else {
            if (allowSingleFilter) {
                clearActiveFilters();
            }
            addActiveFilter(name);
        }
    }, [
        allowSingleFilter,
        addActiveFilter,
        removeActiveFilter,
        clearActiveFilters,
        active
    ]);
    const items = React.useMemo(()=>options.map((option)=>({
                option,
                label: getFormattedLabel(`appointments.component.timeFilter.options.${option.name}`, {
                    labelData: {
                        from: option.from,
                        until: option.until
                    }
                }),
                active: Boolean(active[option.name]),
                onClick: ()=>onClick(option.name)
            })
        )
    , [
        getFormattedLabel,
        options,
        onClick,
        active
    ]);
    const activeItems = React.useMemo(()=>items.filter((item)=>item.active
        )
    , [
        items
    ]);
    var ref;
    const activeItem = React.useMemo(()=>allowSingleFilter ? (ref = items.find((item)=>item.active
        )) !== null && ref !== void 0 ? ref : null : null
    , [
        allowSingleFilter,
        items
    ]);
    const hasActiveItems = activeItems.length > 0;
    const noPreferenceItem = React.useMemo(()=>({
            option: {
                name: 'noPreference'
            },
            label: getLabel(`appointments.component.timeFilter.options.noPreference`),
            active: !hasActiveItems,
            onClick: ()=>clearActiveFilters()
        })
    , [
        getLabel,
        hasActiveItems,
        clearActiveFilters
    ]);
    const reset = React.useCallback(()=>clearActiveFilters()
    , [
        clearActiveFilters
    ]);
    React.useEffect(()=>{
        if (allowSingleFilter && activeItems.length > 1) {
            clearActiveFilters();
        }
    // clearActiveFilters shouldn't trigger the effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowSingleFilter,
        activeItems
    ]);
    return React.useMemo(()=>[
            {
                reset
            },
            {
                noPreferenceItem,
                items,
                activeItems,
                activeItem,
                hasActiveItems
            }, 
        ]
    , [
        reset,
        noPreferenceItem,
        items,
        activeItems,
        activeItem,
        hasActiveItems
    ]);
};

var Distance = (_param)=> {
    var { className , label  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "label"
    ]);
    return React.createElement(Text, swcHelpers.extends({}, rest, {
        className: classnames('appointments-available-store-distance', className)
    }), label);
};

var DistanceContainer = (_param)=>{
    var { distance  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "distance"
    ]);
    const { getFormattedLabel  } = useIntl();
    const label = getFormattedLabel('appointments.component.store.distance', {
        labelData: {
            distance
        }
    });
    return /*#__PURE__*/ React.createElement(Distance, swcHelpers.extends({}, rest, {
        label: label
    }));
};

const { StoreFinderItem: StoreFinderItem$1  } = Components;
var AvailableNearbyStoreContainer = (_param)=>{
    var { store , appointmentType , date , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store",
        "appointmentType",
        "date",
        "onClick"
    ]);
    const { isAabAlternativeStoreAvailabilityEnabled  } = useFeatureToggles();
    const [query, queryState] = useAvailableStoreNearby();
    const [, { activeItem  }] = useTimeFilterItems({
        allowSingleFilter: true
    });
    React.useEffect(()=>{
        if (!isAabAlternativeStoreAvailabilityEnabled || store.lat === undefined || store.lon === undefined) {
            return;
        }
        query({
            latitude: store.lat,
            longitude: store.lon,
            appointmentTypeId: appointmentType.id,
            startDate: date,
            startTime: activeItem === null || activeItem === void 0 ? void 0 : activeItem.option.from,
            endTime: activeItem === null || activeItem === void 0 ? void 0 : activeItem.option.until
        });
    }, [
        query,
        store,
        appointmentType,
        date,
        activeItem === null || activeItem === void 0 ? void 0 : activeItem.option.from,
        activeItem === null || activeItem === void 0 ? void 0 : activeItem.option.until,
        isAabAlternativeStoreAvailabilityEnabled, 
    ]);
    const availableStore = queryState.data;
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province  } = availableStore !== null && availableStore !== void 0 ? availableStore : {};
    const addressData = React.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province
    ]);
    const onClickHandler = React.useCallback(()=>{
        if (!availableStore) {
            return;
        }
        onClick(availableStore);
    }, [
        onClick,
        availableStore
    ]);
    if (!availableStore) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreFinderItem$1, swcHelpers.extends({}, rest, {
        title: availableStore.shortName,
        variant: "list-item",
        addressData: addressData,
        addressSize: "MINIMAL",
        onClick: onClickHandler
    }), availableStore.distance !== undefined && /*#__PURE__*/ React.createElement(DistanceContainer, {
        distance: availableStore.distance
    }));
};

const LinkedAppointmentInfo = (_param)=> {
    var { className , labels , ctaUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "ctaUrl"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('linked-appointment-info', className)
    }, rest), /*#__PURE__*/ React.createElement(Icon, {
        name: "child-appointment"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "typography-text typography-text--caption linked-appointment-info__text"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "linked-appointment-info__title"
    }, labels.title), /*#__PURE__*/ React.createElement("a", {
        className: "linked-appointment-info__cta",
        href: ctaUrl
    }, labels.cta)));
};

const AppointmentInfoContainer = (_param)=>{
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    const { getLabel  } = useIntl();
    const [, { queryParams , basePath , currentRoute  }] = useRoutingContext$2();
    const shouldShowLinkedAppointmentInfo = React.useMemo(()=>{
        const isWhereRoute = currentRoute === '' || currentRoute === 'where';
        return !!(queryParams === null || queryParams === void 0 ? void 0 : queryParams.linkedAppointmentTypeId) && (isWhereRoute || currentRoute === 'when');
    }, [
        queryParams === null || queryParams === void 0 ? void 0 : queryParams.linkedAppointmentTypeId,
        currentRoute
    ]);
    const urlToBeReplaced = React.useMemo(()=>{
        if (!shouldShowLinkedAppointmentInfo) {
            return '';
        }
        const queryParamsOfInterest = swcHelpers.objectSpread({}, queryParams);
        delete queryParamsOfInterest.linkedAppointmentTypeId;
        queryParamsOfInterest.typeId = queryParams.linkedAppointmentTypeId;
        return `${basePath}/${currentRoute}${QueryString.stringify(queryParamsOfInterest)}`;
    }, [
        queryParams,
        basePath,
        currentRoute,
        shouldShowLinkedAppointmentInfo
    ]);
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.component.linkedAppointmentInfo.title'),
            cta: getLabel('appointments.component.linkedAppointmentInfo.cta')
        })
    , [
        getLabel
    ]);
    return shouldShowLinkedAppointmentInfo ? /*#__PURE__*/ React.createElement(LinkedAppointmentInfo, swcHelpers.extends({}, {
        labels,
        className
    }, {
        ctaUrl: urlToBeReplaced
    }, rest)) : null;
};

const renderAction = (index, labels, action)=>index === labels.lines.length - 1 && action !== undefined && labels.action !== undefined && labels.action.length > 0
;
const NoTimeSlots = (_param)=>{
    var { className , variant , labels , action  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "variant",
        "labels",
        "action"
    ]);
    return variant !== Variant.none ? /*#__PURE__*/ React.createElement(Alert, swcHelpers.extends({}, rest, {
        className: classnames('no-time-slots', {
            [`no-time-slots--${variant}`]: true
        }, className)
    }), labels.lines.map((line, i)=>/*#__PURE__*/ React.createElement("p", {
            key: slugify(line),
            className: "no-time-slots__line"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "no-time-slots__line-text"
        }, line, " "), renderAction(i, labels, action) ? /*#__PURE__*/ React.createElement(Button$1, {
            className: "no-time-slots__line-action",
            variant: "ghost",
            onClick: action
        }, labels.action) : null)
    )) : null;
};

const NoTimeSlotsContainer = ({ variant , noAvailabilityUntilDate , nextAvailableDate , action ,  })=>{
    const { getLabel , getFormattedLabel , dateTime  } = useIntl();
    const { formatLongDate  } = dateTime;
    const type = variant === Variant.error ? 'warning' : 'info';
    const icon = variant === Variant.error ? 'warning' : 'info';
    const labels = React.useMemo(()=>{
        switch(variant){
            case Variant.date:
                return {
                    lines: [
                        getLabel('appointments.component.timeslots.noSlotsAvailable'),
                        getLabel('appointments.component.timeslots.nextAvailableDate'), 
                    ],
                    action: nextAvailableDate ? formatLongDate(nextAvailableDate) : ''
                };
            case Variant.closedDate:
                return {
                    lines: [
                        getLabel('appointments.component.timeslots.storeClosed'),
                        getLabel('appointments.component.timeslots.nextAvailableDate'), 
                    ],
                    action: nextAvailableDate ? formatLongDate(nextAvailableDate) : ''
                };
            case Variant.week:
                return {
                    lines: [
                        getFormattedLabel('appointments.component.timeslots.noAvailabilityUntilDate', {
                            labelData: swcHelpers.objectSpread({}, noAvailabilityUntilDate ? {
                                date: formatLongDate(noAvailabilityUntilDate)
                            } : {})
                        }), 
                    ],
                    action: getLabel('appointments.component.timeslots.nextWeeks')
                };
            case Variant.closedWeek:
                return {
                    lines: [
                        getFormattedLabel('appointments.component.timeslots.storeClosed', {
                            labelData: swcHelpers.objectSpread({}, noAvailabilityUntilDate ? {
                                date: formatLongDate(noAvailabilityUntilDate)
                            } : {})
                        }), 
                    ],
                    action: getLabel('appointments.component.timeslots.nextWeeks')
                };
            case Variant.error:
                return {
                    lines: [
                        getLabel('appointments.component.timeslots.error')
                    ],
                    action: getLabel('appointments.component.timeslots.retry')
                };
            case Variant.none:
            default:
                return {
                    lines: []
                };
        }
    }, [
        getLabel,
        getFormattedLabel,
        formatLongDate,
        variant,
        noAvailabilityUntilDate,
        nextAvailableDate, 
    ]);
    return /*#__PURE__*/ React.createElement(NoTimeSlots, {
        variant: variant,
        type: type,
        icon: icon,
        labels: labels,
        action: action
    });
};

var PopupModal = (_param)=> {
    var { className , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "children"
    ]);
    return React.createElement(Modal, swcHelpers.extends({}, rest, {
        className: classnames('popup-modal', className)
    }), children);
};

var PreferredTimePopupModal = (_param)=> {
    var { className , children , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "children",
        "labels",
        "items"
    ]);
    return React.createElement(PopupModal, swcHelpers.extends({}, rest, {
        className: classnames('preferred-time-popup-modal', className),
        title: labels.title,
        showIcon: true
    }), /*#__PURE__*/ React.createElement("ul", {
        className: "preferred-time-popup-modal__list"
    }, items.map(({ option , label , active , onClick  })=>/*#__PURE__*/ React.createElement("li", {
            key: option.name,
            className: "preferred-time-popup-modal__list-item"
        }, /*#__PURE__*/ React.createElement("button", {
            className: "preferred-time-popup-modal__button",
            onClick: onClick,
            disabled: active
        }, label, active && /*#__PURE__*/ React.createElement("span", {
            className: "preferred-time-popup-modal__icon"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "checkmark"
        }))))
    )));
};

var PreferredTimePopupModalContainer = (_param)=>{
    var { items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "items"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.component.preferredTimePopupModal.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(PreferredTimePopupModal, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    }));
};

const PreferredTime = (_param)=>{
    var { className , labels , onClickPreferredTime , calendar , withPreferredTimeFilters =false , openPreferredTimePopup =false , onPreferredTimePopupClose , preferredTimeFilterItems , preferredTimeFilter  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "onClickPreferredTime",
        "calendar",
        "withPreferredTimeFilters",
        "openPreferredTimePopup",
        "onPreferredTimePopupClose",
        "preferredTimeFilterItems",
        "preferredTimeFilter"
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('preferred-time', className)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "preferred-time__title"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "preferred-time__title--heading"
    }, labels.title), withPreferredTimeFilters && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("button", {
        className: "preferred-time__button",
        onClick: onClickPreferredTime,
        "data-t": "quickFilter"
    }, labels.preferredTime))), withPreferredTimeFilters && /*#__PURE__*/ React.createElement(PreferredTimePopupModalContainer, {
        isOpen: openPreferredTimePopup,
        onModalClose: onPreferredTimePopupClose,
        items: preferredTimeFilterItems
    }), preferredTimeFilter && /*#__PURE__*/ React.createElement("div", {
        className: "preferred-time__filters"
    }, /*#__PURE__*/ React.createElement(QuickFilterButton, swcHelpers.extends({
        className: "preferred-time__filter"
    }, preferredTimeFilter))), calendar);
};

const PreferredTimeContainer = (_param)=>{
    var { labels: externalLabels , onPreferredTimeClick , onPreferredTimeFilterClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "labels",
        "onPreferredTimeClick",
        "onPreferredTimeFilterClick"
    ]);
    const { getLabel , getFormattedLabel  } = useIntl();
    const [, { options  }] = useTimeFilterContext();
    const [, { noPreferenceItem , items: timeFilterItems , activeItem  }] = useTimeFilterItems({
        allowSingleFilter: true
    });
    const [openPreferredTimePopup, setOpenPreferredTimePopup] = React.useState(false);
    const withPreferredTimeFilters = options.length > 0;
    var ref, ref1;
    const labels = React.useMemo(()=>{
        return {
            title: (ref = externalLabels === null || externalLabels === void 0 ? void 0 : externalLabels.title) !== null && ref !== void 0 ? ref : getLabel('appointments.component.preferredTime.title'),
            preferredTime: (ref1 = externalLabels === null || externalLabels === void 0 ? void 0 : externalLabels.preferredTime) !== null && ref1 !== void 0 ? ref1 : getLabel('appointments.component.preferredTime.preferredTime')
        };
    }, [
        getLabel,
        externalLabels
    ]);
    const preferredTimeFilterItems = React.useMemo(()=>{
        return [
            noPreferenceItem,
            ...timeFilterItems
        ].map((item)=>{
            return swcHelpers.objectSpread({}, item, {
                onClick: ()=>{
                    setOpenPreferredTimePopup(false);
                    onPreferredTimeFilterClick === null || onPreferredTimeFilterClick === void 0 ? void 0 : onPreferredTimeFilterClick(item);
                    item.onClick();
                }
            });
        });
    }, [
        noPreferenceItem,
        timeFilterItems,
        onPreferredTimeFilterClick
    ]);
    const preferredTimeFilter = React.useMemo(()=>{
        if (!activeItem) {
            return;
        }
        return {
            label: activeItem.label,
            ariaLabels: {
                inactive: getFormattedLabel('appointments.component.quickSelectFilter.inactive', {
                    labelData: {
                        description: activeItem.label
                    }
                }),
                active: getFormattedLabel('appointments.component.quickSelectFilter.active', {
                    labelData: {
                        description: activeItem.label
                    }
                })
            },
            active: activeItem.active,
            onClick: activeItem.onClick
        };
    }, [
        getFormattedLabel,
        activeItem
    ]);
    const onClickPreferredTime = React.useCallback(()=>{
        onPreferredTimeClick === null || onPreferredTimeClick === void 0 ? void 0 : onPreferredTimeClick();
        setOpenPreferredTimePopup(true);
    }, [
        onPreferredTimeClick
    ]);
    const onPreferredTimePopupClose = React.useCallback(()=>setOpenPreferredTimePopup(false)
    , []);
    return /*#__PURE__*/ React.createElement(PreferredTime, swcHelpers.extends({}, rest, {
        labels: labels,
        onClickPreferredTime: onClickPreferredTime,
        withPreferredTimeFilters: withPreferredTimeFilters,
        openPreferredTimePopup: openPreferredTimePopup,
        onPreferredTimePopupClose: onPreferredTimePopupClose,
        preferredTimeFilterItems: preferredTimeFilterItems,
        preferredTimeFilter: preferredTimeFilter
    }));
};

const TimeSlotsItem = (_param)=> {
    var { className , selected , label , onSelect  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "selected",
        "label",
        "onSelect"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        className: classnames('time-slots-item', className, {
            'time-slots-item--selected': selected
        }),
        role: "checkbox",
        "aria-checked": selected,
        onClick: onSelect
    }), label);
};

const TimeSlotItemContainer = (_param)=>{
    var { onSelect , slot  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onSelect",
        "slot"
    ]);
    const handleOnSelect = React.useCallback(()=>onSelect(slot)
    , [
        onSelect,
        slot
    ]);
    return /*#__PURE__*/ React.createElement(TimeSlotsItem, swcHelpers.extends({}, rest, {
        onSelect: handleOnSelect
    }));
};

const isEqualTimeSlot = (a, b)=>a === b || !!a && !!b && a.from.getTime() === b.from.getTime() && a.until.getTime() === b.until.getTime()
;

const TimeSlots = (_param)=> {
    var { className , loading , slots , selected , timeFormatter , onSelectTime  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "loading",
        "slots",
        "selected",
        "timeFormatter",
        "onSelectTime"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('timeslots', className)
    }), loading ? /*#__PURE__*/ React.createElement("div", {
        className: "timeslots__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)) : slots.map((slot)=>/*#__PURE__*/ React.createElement(TimeSlotItemContainer, {
            key: slot.from.toUTCString(),
            selected: isEqualTimeSlot(slot, selected),
            label: timeFormatter(slot.from),
            slot: slot,
            onSelect: onSelectTime
        })
    ));
};

const TimeSlotsContainer = (_param)=>{
    var { loading , slots  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "loading",
        "slots"
    ]);
    const { dateTime: { formatTime  } ,  } = useIntl();
    return /*#__PURE__*/ React.createElement(TimeSlots, swcHelpers.extends({}, rest, {
        loading: loading,
        slots: slots,
        timeFormatter: formatTime
    }));
};

const AppointmentDateTime = (_param)=>{
    var { className , labels , calendarLoading , calendarWeekCount , calendarWeekDate , calendarAvailability , calendarClosedDates , store , appointmentType , selectedDate , onCalendarWeeksChange , onSelectDate , timeSlotsLoading , noTimeSlotsVariant , timeSlots , showOtherTimeSlots , otherTimeSlots , onSelectTime , onToggleOtherTimeSlots , nextAvailableDate , noMoreAvailabilityUntilDate , noTimeSlotsAction , onSelectStore , onPreferredTimeClick , onPreferredTimeFilterClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "calendarLoading",
        "calendarWeekCount",
        "calendarWeekDate",
        "calendarAvailability",
        "calendarClosedDates",
        "store",
        "appointmentType",
        "selectedDate",
        "onCalendarWeeksChange",
        "onSelectDate",
        "timeSlotsLoading",
        "noTimeSlotsVariant",
        "timeSlots",
        "showOtherTimeSlots",
        "otherTimeSlots",
        "onSelectTime",
        "onToggleOtherTimeSlots",
        "nextAvailableDate",
        "noMoreAvailabilityUntilDate",
        "noTimeSlotsAction",
        "onSelectStore",
        "onPreferredTimeClick",
        "onPreferredTimeFilterClick"
    ]);
    const intl = useIntl();
    const { dateTime: { formatDate  } ,  } = intl;
    const hasTimeSlots = timeSlots.length > 0;
    const hasOtherTimeSlots = otherTimeSlots.length > 0;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-date-time', className)
    }), /*#__PURE__*/ React.createElement(SelectedChoicesContainer, null), /*#__PURE__*/ React.createElement(AppointmentInfoContainer, null), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "appointment-date-time__title"
    }, labels.title), /*#__PURE__*/ React.createElement(PreferredTimeContainer, {
        onPreferredTimeClick: onPreferredTimeClick,
        onPreferredTimeFilterClick: onPreferredTimeFilterClick,
        calendar: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(AvailabilityCalendarContainer, {
            "aria-controls": "appointment-date-time__timeslots",
            loading: calendarLoading,
            weekCount: calendarWeekCount,
            weekDate: calendarWeekDate,
            availability: calendarAvailability,
            closedDates: calendarClosedDates,
            selectedDate: selectedDate,
            onChangeWeeks: onCalendarWeeksChange,
            onSelectDate: onSelectDate
        }), selectedDate && /*#__PURE__*/ React.createElement(Text, {
            className: "appointment-date-time__selected-date"
        }, formatDate(selectedDate, 'long')))
    }), /*#__PURE__*/ React.createElement("section", {
        id: "appointment-date-time__timeslots",
        "aria-live": "polite"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "appointment-date-time__section-title"
    }, labels.selectATime), noTimeSlotsVariant === Variant.none ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        className: "appointment-date-time__section-subtitle"
    }, labels.selectATimeSubtitle), /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading,
        slots: timeSlots,
        onSelectTime: onSelectTime
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(NoTimeSlotsContainer, {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    }), store && appointmentType && selectedDate && onSelectStore && !hasOtherTimeSlots && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "appointment-date-time__section-title appointment-date-time__available-store-title"
    }, labels.availableStore), /*#__PURE__*/ React.createElement(AvailableNearbyStoreContainer, {
        className: "appointment-date-time__available-store",
        store: store,
        appointmentType: appointmentType,
        date: selectedDate,
        onClick: onSelectStore
    }))), hasOtherTimeSlots && /*#__PURE__*/ React.createElement(React.Fragment, null, hasTimeSlots && /*#__PURE__*/ React.createElement(Button$1, {
        className: "appointment-date-time__show-other-time-slots",
        variant: "ghost",
        onClick: onToggleOtherTimeSlots
    }, showOtherTimeSlots ? labels.hideOtherTimeSlots : labels.showOtherTimeSlots), showOtherTimeSlots && /*#__PURE__*/ React.createElement("div", {
        className: "appointment-date-time__other-time-slots"
    }, /*#__PURE__*/ React.createElement(ScrollIntoView, null, !hasTimeSlots && /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "appointment-date-time__section-title"
    }, labels.otherTimeSlots), /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading,
        slots: otherTimeSlots,
        onSelectTime: onSelectTime
    }))))));
};

const AppointmentDateTimeContainer = (props)=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const [{ setStore , setTimeSlot  }, { store: store1 , type , timeSlot: timeSlot1  }] = useAppointmentContext();
    const [{ goTo  }, { queryParams  }] = useRoutingContext$2();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [{ getAvailabilityTimeFilters  }, { activeFilters: activeTimeFilters  }, ] = useActiveTimeFilters();
    const today = React.useRef(new Date());
    const [weekDate, setWeekDate] = React.useState();
    const [weeks1, setWeeks] = React.useState();
    const [date1, setDate] = React.useState();
    const [availabilityRequestParamsChanged, setAvailabilityRequestParamsChanged] = React.useState(true);
    const [showOtherTimeSlots, setShowOtherTimeSlots] = React.useState(false);
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } = featureConfigs;
    const [getCalendarAvailability, calendarAvailability] = useCalendarAvailability();
    const [, bookAppointmentType] = useBookAppointmentType();
    const [, bookAppointmentStore] = useBookAppointmentStore();
    const [getStoreOpeningTimes, storeOpeningTimes] = useStoreOpeningTimes();
    /** Refetch store and appointment type data if has different typeIs, storeId in the url
   * and store code with appointment type id in the context.
   * This can be possible when user use back and forth browser button to navigate between steps */ useBookAppointmentStoreWithUrlParam();
    useBookAppointmentTypeWithUrlParam();
    const appointmentBookingAvailabiltyCalendarWeekCount = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.appointmentBookingAvailabiltyCalendarWeekCount;
    const labels = React.useMemo(()=>{
        // The fallback should never happen, but it's here to satisfy typescript
        const { duration ={
            amount: 0,
            unit: 'MINUTES'
        }  } = type !== null && type !== void 0 ? type : {};
        const durationLabel = duration.amount > 0 ? `${duration.amount} ${getLabel(`appointments.shortTimeUnits.${duration.unit.toLowerCase()}`)}` : '';
        return {
            title: getLabel('appointments.component.appointmentDateTimeContainer.title'),
            selectATime: getLabel('appointments.component.appointmentDateTimeContainer.selectATime'),
            selectATimeSubtitle: getFormattedLabel('appointments.component.appointmentDateTimeContainer.selectATimeSubtitle', {
                labelData: {
                    duration: durationLabel
                }
            }),
            showOtherTimeSlots: getLabel('appointments.component.appointmentDateTimeContainer.showOtherTimeSlots'),
            hideOtherTimeSlots: getLabel('appointments.component.appointmentDateTimeContainer.hideOtherTimeSlots'),
            otherTimeSlots: getLabel('appointments.component.appointmentDateTimeContainer.otherTimeSlots'),
            availableStore: getLabel('appointments.component.appointmentDateTimeContainer.availableStore')
        };
    }, [
        getLabel,
        getFormattedLabel,
        type
    ]);
    const closedDates = React.useMemo(()=>{
        if (!weeks1 || !storeOpeningTimes.data) {
            return [];
        }
        return getClosedDates(weeks1, storeOpeningTimes.data);
    }, [
        weeks1,
        storeOpeningTimes.data
    ]);
    useDebouncedEffect(()=>{
        const appointmentTypeId = type === null || type === void 0 ? void 0 : type.id;
        const storeCode = store1 === null || store1 === void 0 ? void 0 : store1.code;
        if (!appointmentTypeId || !storeCode || !weeks1) {
            /* istanbul ignore else */ if (process.env.NODE_ENV === 'test') {
                console.log('Awaiting availability request variables data');
            }
            return;
        }
        const [[firstWeekDay]] = weeks1.slice(0);
        const [lastWeek] = weeks1.slice(-1);
        const [lastWeekDay] = lastWeek.slice(-1);
        getCalendarAvailability(swcHelpers.objectSpread({
            appointmentTypeId,
            storeCode: storeCode.toString(),
            startDate: firstWeekDay,
            endDate: lastWeekDay
        }, getAvailabilityTimeFilters()));
        setAvailabilityRequestParamsChanged(false);
    }, 400, [
        getCalendarAvailability,
        type,
        store1,
        weeks1,
        getAvailabilityTimeFilters
    ]);
    const onCalendarWeeksChange = React.useCallback((weeks)=>{
        setAvailabilityRequestParamsChanged(true);
        setWeeks(weeks);
    }, []);
    const onSelectDate = React.useCallback((date)=>{
        setDate(date);
    }, []);
    const [getTimeSlots, timeSlots] = useTimeSlots({
        timeFilters: activeTimeFilters
    });
    const { onPreferredTimeClick , onPreferredTimeFilterClick ,  } = usePreferredTimeDataLayerEventDispatchers({
        appointmentCondition: 'new',
        isVirtualAppointment: isVirtualAppointmentType(type),
        type,
        store: store1,
        timeSlot: timeSlot1
    });
    const nextAvailableDate = useNextAvailableDate(date1, calendarAvailability, !timeSlots.called);
    const nextWeekDate = useNextWeekDate(weeks1, !date1 || Boolean(nextAvailableDate));
    const noTimeSlotsVariant = useNoTimeSlotsVariant(timeSlots, nextAvailableDate, date1, closedDates);
    const onSelectTimeSlot = React.useCallback((timeSlot)=>{
        setTimeSlot(timeSlot);
        const { typeId , storeId , search , userLocation  } = queryParams;
        goTo('who', {
            typeId,
            storeId,
            start: `${timeSlot.from.getTime()}`,
            end: `${timeSlot.until.getTime()}`,
            search,
            userLocation
        });
    }, [
        setTimeSlot,
        goTo,
        queryParams
    ]);
    const pushClickedOnAlternativeStoreEvent = React.useCallback((store)=>{
        if (type) {
            const { isChildAppointment , id: typeId  } = type;
            const dataLayerEvent = appointmentBookingAlternativeLocationEvent({
                condition_of_appointment: 'new',
                isChildAppointment,
                appointment: {
                    type_of_appointment: isVirtualAppointmentType(type) ? 'videocall' : 'onsite',
                    type_of_service: typeId
                },
                storeDetails: swcHelpers.objectSpread({
                    id: store.code.toString(),
                    city: store.town
                }, store),
                text_of_the_element: store.name,
                // timeslots are always going to be undefined in this case
                time: {}
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        type,
        isVirtualAppointmentType
    ]);
    const onSelectStore = React.useCallback((store)=>{
        pushClickedOnAlternativeStoreEvent(store);
        const invalidUrl = '##invalid_url##' // If no alternative url can be generated, this will be used in the result
        ;
        const alternativeLocation = Util.getBookAppointmentUrl(invalidUrl, {
            paddedLength: appointmentBookingUrlPaddedLength,
            alternativeUrl: appointmentBookingAlternativeUrl,
            alternativeUrlStores: appointmentBookingAlternativeUrlStores
        })(store);
        if (!alternativeLocation.includes(invalidUrl)) {
            // A valid alternative location was generated
            window.location.assign(alternativeLocation);
            return;
        }
        setStore(store);
        const { typeId , search , userLocation  } = queryParams;
        goTo('when', {
            typeId,
            storeId: `${store.code}`,
            search,
            userLocation
        });
    }, [
        appointmentBookingUrlPaddedLength,
        appointmentBookingAlternativeUrl,
        appointmentBookingAlternativeUrlStores,
        setStore,
        goTo,
        queryParams,
        pushClickedOnAlternativeStoreEvent, 
    ]);
    React.useEffect(()=>{
        const { typeId , storeId  } = queryParams;
        /** Need to track when user go back/forth with browser navigation.
     * In this situation update event only with data based on query parameters.
     */ if (store1 && type && Number(storeId) === store1.code && typeId === type.id) {
            const dataLayerEvent = bookAppointmentWhenStepScreenEvent({
                store: !isVirtualAppointmentType(type) ? {
                    code: store1.code,
                    streetName: store1.streetName,
                    town: store1.town,
                    name: store1.name,
                    postalCode: store1.postalCode,
                    streetNumber: store1.streetNumber,
                    additionalStreetInfo: store1.additionalStreetInfo
                } : undefined,
                appointment: {
                    appointmentType: {
                        id: type.id,
                        isChildAppointment: type.isChildAppointment,
                        isVirtualAppointment: isVirtualAppointmentType(type)
                    }
                }
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        store1,
        type,
        queryParams,
        isVirtualAppointmentType
    ]);
    const noTimeSlotsAction = React.useCallback(()=>{
        switch(noTimeSlotsVariant){
            case Variant.date:
            case Variant.closedDate:
                /* istanbul ignore if */ if (!nextAvailableDate) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                setDate(nextAvailableDate);
                break;
            case Variant.week:
            case Variant.closedWeek:
                /* istanbul ignore if */ if (!nextWeekDate) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                setWeekDate(nextWeekDate);
                setDate(nextWeekDate);
                break;
            case Variant.error:
                var ref;
                const storeCode = (ref = store1 === null || store1 === void 0 ? void 0 : store1.code) !== null && ref !== void 0 ? ref : undefined;
                var ref1;
                const appointmentTypeId = (ref1 = type === null || type === void 0 ? void 0 : type.id) !== null && ref1 !== void 0 ? ref1 : undefined;
                /* istanbul ignore if */ if (!date1 || storeCode === undefined || appointmentTypeId === undefined) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                getTimeSlots({
                    variables: {
                        storeCode: `${storeCode}`,
                        appointmentTypeId,
                        date: DateUtils.toLocalDate(date1)
                    }
                });
            case Variant.none:
                return;
        }
    }, [
        noTimeSlotsVariant,
        nextAvailableDate,
        nextWeekDate,
        getTimeSlots,
        store1,
        type,
        date1
    ]);
    const onToggleOtherTimeSlots = React.useCallback(()=>setShowOtherTimeSlots((curr)=>!curr
        )
    , []);
    React.useEffect(()=>{
        const dateIsAlreadySelected = Boolean(date1);
        const waitingForAvailability = !calendarAvailability.called || calendarAvailability.loading;
        if (dateIsAlreadySelected || !weeks1 || waitingForAvailability) {
            return;
        }
        const availableDate = firstAvailableDate(weeks1, calendarAvailability.data);
        const fallbackDate = today.current;
        setDate(availableDate !== null && availableDate !== void 0 ? availableDate : fallbackDate);
    }, [
        date1,
        weeks1,
        calendarAvailability
    ]);
    React.useEffect(()=>{
        if (!store1) {
            return;
        }
        getStoreOpeningTimes({
            variables: {
                code: store1.code
            }
        });
    }, [
        getStoreOpeningTimes,
        store1
    ]);
    React.useEffect(()=>{
        calendarAvailability.error && console.error('Error fetching appointment availabilty:', calendarAvailability.error.message);
    }, [
        calendarAvailability.error
    ]);
    React.useEffect(()=>{
        var ref;
        const storeCode = (ref = store1 === null || store1 === void 0 ? void 0 : store1.code) !== null && ref !== void 0 ? ref : undefined;
        var ref2;
        const appointmentTypeId = (ref2 = type === null || type === void 0 ? void 0 : type.id) !== null && ref2 !== void 0 ? ref2 : undefined;
        /* istanbul ignore if */ if (!date1 || storeCode === undefined || appointmentTypeId === undefined) {
            // This should never happen, but it's here to satisfy typescript
            return;
        }
        getTimeSlots({
            variables: {
                storeCode: `${storeCode}`,
                appointmentTypeId,
                date: DateUtils.toLocalDate(date1)
            }
        });
    }, [
        getTimeSlots,
        store1,
        type,
        date1
    ]);
    React.useEffect(()=>setShowOtherTimeSlots(timeSlots.filtered.included.length === 0 && timeSlots.filtered.excluded.length > 0)
    , [
        timeSlots.filtered
    ]);
    const calendarLoading = bookAppointmentStore.loading || bookAppointmentType.loading || calendarAvailability.loading || storeOpeningTimes.loading || availabilityRequestParamsChanged;
    return /*#__PURE__*/ React.createElement(AppointmentDateTime, swcHelpers.extends({}, props, {
        labels: labels,
        onCalendarWeeksChange: onCalendarWeeksChange,
        store: store1,
        appointmentType: type,
        selectedDate: date1,
        onSelectDate: onSelectDate,
        calendarLoading: calendarLoading,
        calendarWeekDate: weekDate,
        calendarAvailability: calendarAvailability.data,
        calendarClosedDates: closedDates,
        calendarWeekCount: appointmentBookingAvailabiltyCalendarWeekCount,
        timeSlotsLoading: timeSlots.loading,
        timeSlots: timeSlots.filtered.included,
        onSelectTime: onSelectTimeSlot,
        noTimeSlotsVariant: noTimeSlotsVariant,
        noTimeSlotsAction: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noMoreAvailabilityUntilDate: nextWeekDate,
        showOtherTimeSlots: showOtherTimeSlots,
        onToggleOtherTimeSlots: onToggleOtherTimeSlots,
        otherTimeSlots: timeSlots.filtered.excluded,
        onSelectStore: onSelectStore,
        onPreferredTimeClick: onPreferredTimeClick,
        onPreferredTimeFilterClick: onPreferredTimeFilterClick
    }));
};

const AppointmentError = (_param)=> {
    var { className , labels , buttonUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "buttonUrl"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-error', className)
    }), /*#__PURE__*/ React.createElement("div", {
        className: "appointment-error__icon-wrapper"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "calendar-time",
        height: 32,
        width: 32
    })), /*#__PURE__*/ React.createElement(Heading, {
        component: "h1",
        variant: "medium"
    }, labels.title), /*#__PURE__*/ React.createElement(Text, {
        className: "appointment-error__description"
    }, labels.description), /*#__PURE__*/ React.createElement(Button, {
        caption: labels.buttonCaption,
        href: buttonUrl
    }), /*#__PURE__*/ React.createElement("a", {
        className: "appointment-error__go-to-home-link",
        href: "/"
    }, labels.goToHome));
};

const AppointmentErrorContainer = (_param)=>{
    var { status , bookAppointmentUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "status",
        "bookAppointmentUrl"
    ]);
    const { getLabel  } = useIntl();
    const routes = useSelector(Selectors.getFormattedRoutes);
    const isTokenNotFoundStatus = status === 'JWT_TOKEN_NOT_FOUND';
    const labels = React.useMemo(()=>({
            title: getLabel(`appointments.component.appointmentError.${status}.title`),
            description: getLabel(`appointments.component.appointmentError.${status}.description`),
            buttonCaption: getLabel(`appointments.component.appointmentError.${isTokenNotFoundStatus ? 'goToMyAccount' : 'bookAppointment'}`),
            goToHome: getLabel('appointments.component.appointmentError.goToHome')
        })
    , [
        getLabel,
        status,
        isTokenNotFoundStatus
    ]);
    const buttonUrl = React.useMemo(()=>{
        if (isTokenNotFoundStatus) {
            const origin = typeof window === 'undefined' ? '' : window.location.origin;
            const returnPath = !origin ? '' : `${window.location.pathname}${window.location.search}`;
            return `${origin}${routes === null || routes === void 0 ? void 0 : routes.login}?returnPath=${returnPath}`;
        }
        return bookAppointmentUrl;
    }, [
        isTokenNotFoundStatus,
        bookAppointmentUrl,
        routes
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentError, swcHelpers.extends({}, rest, {
        labels: labels,
        buttonUrl: buttonUrl
    }));
};

const fromStoreResultToStore = (storeResultData)=>{
    if (!storeResultData) {
        return null;
    }
    const { code , name , shortName , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , slug ,  } = storeResultData;
    return {
        code,
        name,
        shortName,
        streetName,
        town,
        country,
        phone,
        streetNumber,
        additionalStreetInfo,
        postalCode,
        province,
        lat,
        lon,
        emailAddress: undefined,
        appointmentTypes: [],
        slug: slug !== null && slug !== void 0 ? slug : undefined
    };
};

const AppointmentPrice = (_param)=>{
    var { className , labels  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels"
    ]);
    if (labels.freeIndication) {
        return /*#__PURE__*/ React.createElement("span", swcHelpers.extends({
            className: classnames('appointment-price', 'appointment-price--is-free-indication', className)
        }, rest), labels.freeIndication);
    }
    return null;
};

const AppointmentPriceContainer = (_param)=>{
    var { amount , currency , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "amount",
        "currency",
        "className"
    ]);
    const { isAppointmentBookingTypeWithFreeIndication  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const isFree = React.useMemo(()=>amount === 0
    , [
        amount
    ]);
    const labels = React.useMemo(()=>({
            freeIndication: isAppointmentBookingTypeWithFreeIndication && isFree ? `${getLabel('common.free')}` : ''
        })
    , [
        isAppointmentBookingTypeWithFreeIndication,
        isFree,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentPrice, swcHelpers.extends({}, {
        amount,
        currency,
        labels,
        className
    }, rest));
};

var AppointmentTypeToolTip = (_param)=>{
    var { className , tabIndex =0  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "tabIndex"
    ]);
    return /*#__PURE__*/ React.createElement("span", swcHelpers.extends({}, rest, {
        className: classnames('appointment-type-tooltip', className),
        role: "button",
        tabIndex: tabIndex
    }), /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-tooltip__icon-container"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "info"
    })));
};

var AppointmentTypeToolTipContainer = (_param)=>{
    var { onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onClick"
    ]);
    const onClickHandler = React.useCallback((e)=>{
        e.preventDefault();
        e.stopPropagation();
        onClick();
        return;
    }, [
        onClick
    ]);
    const onKeyDownHandler = React.useCallback((e)=>{
        if ([
            'Enter',
            ' '
        ].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            onClick();
            return;
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentTypeToolTip, swcHelpers.extends({}, rest, {
        onClick: onClickHandler,
        onKeyDown: onKeyDownHandler
    }));
};

const AppointmentTypeButton = (_param)=> {
    var { className , icon , labels , toolTip , price , onClickToolTip  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "icon",
        "labels",
        "toolTip",
        "price",
        "onClickToolTip"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        className: classnames('appointment-type-button', className)
    }), icon && /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-button__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        width: 32,
        height: 32,
        viewBox: "0 0 24 24"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-button__text"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-button__name"
    }, labels.name), labels.description && /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-button__description"
    }, labels.description), price && /*#__PURE__*/ React.createElement(AppointmentPriceContainer, swcHelpers.extends({}, price))), toolTip && onClickToolTip && /*#__PURE__*/ React.createElement(AppointmentTypeToolTipContainer, {
        onClick: onClickToolTip,
        "aria-label": toolTip.title
    }));
};

const AppointmentTypeButtonContainer = (_param)=>{
    var { appointmentType , toolTip , onClick , onClickToolTip  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointmentType",
        "toolTip",
        "onClick",
        "onClickToolTip"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>{
        const { name , description , duration  } = appointmentType;
        const durationLabel = duration.amount > 0 ? `${duration.amount} ${getLabel(`appointments.shortTimeUnits.${duration.unit.toLowerCase()}`)}` : '';
        return {
            name,
            description: `${durationLabel}${durationLabel.length && (description === null || description === void 0 ? void 0 : description.length) ? ' · ' : ''}${description !== null && description !== void 0 ? description : ''}`
        };
    }, [
        getLabel,
        appointmentType
    ]);
    const onClickHandler = React.useCallback(()=>onClick(appointmentType)
    , [
        onClick,
        appointmentType, 
    ]);
    const onClickToolTipHandler = React.useCallback(()=>{
        if (!toolTip || !onClickToolTip) {
            return;
        }
        onClickToolTip(toolTip);
    }, [
        onClickToolTip,
        toolTip
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentTypeButton, swcHelpers.extends({}, rest, {
        price: appointmentType.price,
        labels: labels,
        toolTip: toolTip,
        onClick: onClickHandler,
        onClickToolTip: onClickToolTipHandler
    }));
};

const VirtualAppointmentButtonContainer = (_param)=>{
    var { className , appointmentType  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "appointmentType"
    ]);
    return appointmentType ? /*#__PURE__*/ React.createElement(AppointmentTypeButtonContainer, swcHelpers.extends({}, rest, {
        className: classnames('virtual-appointment-type-button', className),
        icon: "video-call",
        appointmentType: appointmentType
    })) : null;
};

const NoStoresAlert = ({ labels , onClearAppointmentType  })=>/*#__PURE__*/ React.createElement(Alert, {
        className: "no-stores-alert",
        type: "warning",
        icon: "warning"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "alert__message"
    }, `${labels.message} `, /*#__PURE__*/ React.createElement("button", {
        className: "no-stores-alert__button",
        onClick: onClearAppointmentType
    }, labels.action), "."))
;

const NoStoresAlertContainer = ()=>{
    const { getLabel  } = useIntl();
    const [{ setType  }] = useAppointmentContext();
    const [{ goTo  }, { queryParams  }] = useRoutingContext$2();
    const labels = React.useMemo(()=>({
            message: getLabel('appointments.component.storeFinder.noStoresAlert.message'),
            action: getLabel('appointments.component.storeFinder.noStoresAlert.action')
        })
    , [
        getLabel
    ]);
    const onClearAppointmentType = React.useCallback(()=>{
        setType(null);
        const newQueryParams = swcHelpers.objectSpread({}, queryParams);
        delete newQueryParams.typeId;
        goTo('where', newQueryParams);
    }, [
        queryParams,
        goTo,
        setType
    ]);
    return /*#__PURE__*/ React.createElement(NoStoresAlert, {
        labels: labels,
        onClearAppointmentType: onClearAppointmentType
    });
};

const fromStoreToStoreResult = (storeData)=>{
    if (!storeData) {
        return null;
    }
    const { code , name , shortName , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone ,  } = storeData;
    return {
        code,
        name,
        shortName,
        streetName,
        town,
        country,
        phone,
        streetNumber,
        additionalStreetInfo,
        postalCode,
        province,
        lat,
        lon,
        emailAddress: undefined,
        appointmentTypes: [],
        servicesNotAvailable: [],
        openingHours: {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: []
        },
        specialOpeningHours: []
    };
};

const { StoreFinderItem  } = Components;
const StoreFinderItemContainer = (_param)=>{
    var { store , variant  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store",
        "variant"
    ]);
    const { setHoveredStore  } = useStoreFinderContext();
    const [{ setStore  }] = useAppointmentContext();
    const [{ goTo  }, { queryParams  }] = useRoutingContext$2();
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } = featureConfigs;
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province  } = store !== null && store !== void 0 ? store : {};
    const addressData = React.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province
    ]);
    const onMouseEnterHandler = React.useCallback(()=>{
        if (variant === 'map-item') {
            return;
        }
        setHoveredStore(fromStoreToStoreResult(store));
    }, [
        setHoveredStore,
        store,
        variant
    ]);
    const onMouseLeaveHandler = React.useCallback(()=>{
        if (variant === 'map-item') {
            return;
        }
        setHoveredStore(null);
    }, [
        setHoveredStore,
        variant
    ]);
    const onClickHandler = React.useCallback(()=>{
        if (!store) {
            return;
        }
        const invalidUrl = '##invalid_url##' // If no alternative url can be generated, this will be used in the result
        ;
        const alternativeLocation = Util.getBookAppointmentUrl(invalidUrl, {
            paddedLength: appointmentBookingUrlPaddedLength,
            alternativeUrl: appointmentBookingAlternativeUrl,
            alternativeUrlStores: appointmentBookingAlternativeUrlStores
        })(store);
        if (!alternativeLocation.includes(invalidUrl)) {
            // A valid alternative location was generated
            window.location.assign(alternativeLocation);
            return;
        }
        setStore(store);
        const { typeId , search , userLocation , linkedAppointmentTypeId  } = queryParams;
        const nextStep = typeId ? 'when' : 'what';
        goTo(nextStep, {
            linkedAppointmentTypeId,
            typeId,
            storeId: `${store.code}`,
            search,
            userLocation
        });
    }, [
        setStore,
        store,
        goTo,
        queryParams,
        appointmentBookingUrlPaddedLength,
        appointmentBookingAlternativeUrl,
        appointmentBookingAlternativeUrlStores, 
    ]);
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreFinderItem, swcHelpers.extends({}, rest, {
        title: store.shortName,
        variant: variant,
        addressData: addressData,
        addressSize: "MINIMAL",
        onClick: onClickHandler,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler
    }));
};

const CurrentLocationPin = Components.CurrentLocationPin;
const currentLocationPin = CurrentLocationPin({
    theme: {
        borderColor: '#2B2E31',
        background: '#FFFFFF'
    }
});
const StoreFinderMapContainer = ({ stores , googleMapsId  })=>{
    const { hoveredStore: hoveredStoreInList , isUsingUserLocation , userLocation , isUserLocationRequested , setIsUserLocationRequested ,  } = useStoreFinderContext();
    const { getLabel  } = useIntl();
    const [hoveredStore, setHoveredStore] = React.useState(null);
    const handleOnMarkerHover = (code)=>{
        setHoveredStore(code);
    };
    const isPhone = MediaQuery.useIsPhone();
    const [activeInfoWindow, setActiveInfoWindow] = React.useState(null);
    const [activeStore, setActiveStore] = React.useState(null);
    const handleOnClickUseMyLocation = React.useCallback(()=>{
        if (!isUserLocationRequested) {
            setIsUserLocationRequested(true);
        }
    }, [
        isUserLocationRequested,
        setIsUserLocationRequested
    ]);
    const handleOnMarkerClick = React.useCallback((code)=>{
        if (activeInfoWindow === code) {
            setActiveInfoWindow(null);
            setActiveStore(null);
            return;
        }
        const store1 = stores.find((store)=>store.code === code
        );
        if (store1) {
            setActiveInfoWindow(code);
            setActiveStore(fromStoreResultToStore(store1));
        }
    }, [
        stores,
        activeInfoWindow,
        setActiveStore,
        setActiveInfoWindow
    ]);
    const handleOnMapClick = React.useCallback(()=>{
        setActiveInfoWindow(null);
    }, []);
    const markers = React.useMemo(()=>{
        const storeMarkers = stores.map((store)=>{
            const { code , lat , lon  } = store;
            return {
                code,
                title: getLabel('appointments.component.storeFinderMap.map.pin.title'),
                optimized: false,
                position: {
                    lat: Number(lat),
                    lng: Number(lon)
                },
                infoWindow: activeInfoWindow === code && !isPhone && /*#__PURE__*/ React.createElement(InfoWindow, {
                    position: {
                        lat: Number(lat),
                        lng: Number(lon)
                    },
                    onCloseClick: handleOnMapClick
                }, /*#__PURE__*/ React.createElement(StoreFinderItemContainer, {
                    variant: "map-item",
                    store: fromStoreResultToStore(store),
                    "data-t": "searchResultTile"
                }))
            };
        });
        const userMarker = isUsingUserLocation && userLocation ? [
            {
                position: {
                    lat: userLocation.lat,
                    lng: userLocation.lng
                },
                pin: currentLocationPin
            }, 
        ] : [];
        return [
            ...storeMarkers,
            ...userMarker
        ];
    }, [
        getLabel,
        stores,
        activeInfoWindow,
        isUsingUserLocation,
        handleOnMapClick,
        userLocation,
        isPhone, 
    ]);
    const center = React.useMemo(()=>{
        if (isUsingUserLocation && userLocation !== undefined) {
            return userLocation;
        }
        return undefined;
    }, [
        userLocation,
        isUsingUserLocation
    ]);
    var ref;
    return /*#__PURE__*/ React.createElement(LocationSearchMap, {
        id: googleMapsId,
        markers: markers,
        markersUpdateConfig: {
            centerToFirst: true,
            zoom: 13
        },
        center: center,
        highlight: (ref = activeStore === null || activeStore === void 0 ? void 0 : activeStore.code) !== null && ref !== void 0 ? ref : null,
        hovered: hoveredStore !== null && hoveredStore !== void 0 ? hoveredStore : hoveredStoreInList === null || hoveredStoreInList === void 0 ? void 0 : hoveredStoreInList.code,
        userLocation: isUsingUserLocation && userLocation ? userLocation : undefined,
        userLocationZoomLevel: 13,
        centerOnUserLocation: true,
        activeLocation: activeStore && isPhone ? /*#__PURE__*/ React.createElement(StoreFinderItemContainer, {
            variant: "map-item",
            store: activeStore
        }) : null,
        onClickUseMyLocation: handleOnClickUseMyLocation,
        onMarkerHover: handleOnMarkerHover,
        onMarkerClick: handleOnMarkerClick,
        onMapClick: handleOnMapClick
    });
};

const StoreSearchForm = Containers.StoreSearchForm;
const StoreFinderSearchForm = ({ labels , appointmentTypeId , storeQueryFilter ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "appointments-store-finder-search-form"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "appointments-store-finder-search-form__title h4"
    }, labels.title), /*#__PURE__*/ React.createElement(StoreSearchForm, {
        appointmentTypeId: appointmentTypeId,
        storeQueryFilter: storeQueryFilter
    }))
;

const StoreFinderSearchFormContainer = (props)=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.component.storeFinder.searchSubtitle')
        })
    , [
        getLabel
    ]);
    const storeQueryFilter = React.useMemo(()=>({
            servicesNotAvailable: {
                containsNone: [
                    Types.ServicesNotAvailable.APPOINTMENTS
                ]
            }
        })
    , []);
    return /*#__PURE__*/ React.createElement(StoreFinderSearchForm, swcHelpers.extends({}, props, {
        labels: labels,
        storeQueryFilter: storeQueryFilter
    }));
};

const StoreListTopContent = Components.StoreListTopContent;
const StoreFinderContainer = ({ appointmentTypeId  })=>{
    const { getLabel , hasLabel  } = useIntl();
    const [{ setStore , setType  }] = useAppointmentContext();
    const [{ goTo  }] = useRoutingContext$2();
    const { isPristineSearch , isStoresLoading , stores , config  } = useStoreFinderContext();
    const { googleMapsId  } = config;
    const [{ getAppointmentTypeData , getStoreData  }, { enabled: isVirtualAppointmentEnabled  }, ] = useVirtualAppointment();
    // Run this only once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const virtualAppointment = React__default.useMemo(()=>getAppointmentTypeData()
    , []);
    const onClickVirtualAppointmentType = React__default.useCallback((type)=>{
        const store = getStoreData(undefined, type);
        if (!type || !store) {
            return;
        }
        setType(type);
        setStore(store);
        const typeId = type.id;
        const storeId = `${store.code}`;
        goTo('when', {
            typeId,
            storeId
        });
    }, [
        getStoreData,
        setType,
        setStore,
        goTo
    ]);
    const storeListTopContent = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: "appointments-store-finder__selected-choices"
    }, /*#__PURE__*/ React__default.createElement(SelectedChoicesContainer, null)), /*#__PURE__*/ React__default.createElement(AppointmentInfoContainer, {
        className: "appointments-store-finder__linked-appointment-type"
    }), /*#__PURE__*/ React__default.createElement(StoreListTopContent, {
        title: getLabel('appointments.component.storeFinder.title'),
        description: hasLabel('appointments.component.storeFinder.description') ? getLabel('appointments.component.storeFinder.description') : undefined
    }));
    const showNoStoresAlert = !isPristineSearch && !isStoresLoading && stores.length === 0;
    const showVirtualAppointmentButton = isVirtualAppointmentEnabled && !isStoresLoading && stores.length === 0;
    const storeListInfoContent = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, showNoStoresAlert ? /*#__PURE__*/ React__default.createElement("div", {
        className: "appointments-store-finder__info-content"
    }, /*#__PURE__*/ React__default.createElement(NoStoresAlertContainer, null)) : null, showVirtualAppointmentButton ? /*#__PURE__*/ React__default.createElement("div", {
        className: "appointments-store-finder__info-content"
    }, /*#__PURE__*/ React__default.createElement(VirtualAppointmentButtonContainer, {
        "data-t": "virtualAppointment",
        appointmentType: virtualAppointment,
        onClick: onClickVirtualAppointmentType
    })) : null);
    // Add css variable var(--vh) to document
    useAddViewportHeightCssVariable();
    return /*#__PURE__*/ React__default.createElement(LocationSearch, {
        className: "appointments-store-finder",
        googleMapsId: googleMapsId,
        isPristineSearch: isPristineSearch,
        searchForm: /*#__PURE__*/ React__default.createElement(StoreFinderSearchFormContainer, {
            appointmentTypeId: appointmentTypeId
        }),
        listTopContent: storeListTopContent,
        listInfoContent: storeListInfoContent,
        loadingListItems: isStoresLoading,
        listItems: stores.length ? stores.map((store)=>/*#__PURE__*/ React__default.createElement(StoreFinderItemContainer, {
                key: store.code,
                variant: "list-item",
                store: fromStoreResultToStore(store),
                "data-t": "searchResults"
            })
        ) : [],
        mapContent: /*#__PURE__*/ React__default.createElement(StoreFinderMapContainer, {
            stores: stores,
            googleMapsId: googleMapsId
        })
    });
};

const AppointmentLocation = ({ appointmentTypeId  })=>/*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        withUrlParams: true
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(StoreFinderContainer, {
        appointmentTypeId: appointmentTypeId
    })))
;

const AppointmentLocationContainer = (props)=>{
    const [{ setStore , setType , setTimeSlot  }, { store , type , timeSlot  }] = useAppointmentContext();
    const [, { queryParams  }] = useRoutingContext$2();
    /** Refetch appointment type data if has different typeId appointment type id in the context.
   * This can be possible when user use back and forth browser button to navigate between steps */ useBookAppointmentTypeWithUrlParam();
    React.useEffect(()=>{
        if (store && !queryParams.storeId) {
            setStore(null);
        }
        if (type && !queryParams.typeId) {
            setType(null);
        }
        if (timeSlot && (!queryParams.start || !queryParams.end)) {
            setTimeSlot(null);
        }
    }, [
        queryParams,
        setStore,
        setType,
        setTimeSlot,
        store,
        type,
        timeSlot
    ]);
    React.useEffect(()=>{
        const dataLayerEvent = bookAppointmentWhereStepScreenEvent();
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    return /*#__PURE__*/ React.createElement(AppointmentLocation, swcHelpers.extends({}, props));
};

const AppointmentTypeList = (_param)=> {
    var { className , appointmentTypes , appointmentTypeIcons , appointmentTypeToolTips , appointmentGlobalLabels , onClick , onClickToolTip  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "appointmentTypes",
        "appointmentTypeIcons",
        "appointmentTypeToolTips",
        "appointmentGlobalLabels",
        "onClick",
        "onClickToolTip"
    ]);
    return React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('appointment-type-list', className)
    }), appointmentTypes.map((appointmentType)=>/*#__PURE__*/ React.createElement("li", {
            className: "appointment-type-list__item",
            key: appointmentType.id
        }, /*#__PURE__*/ React.createElement(AppointmentTypeButtonContainer, {
            icon: appointmentTypeIcons[appointmentType.id],
            appointmentType: appointmentType,
            toolTip: appointmentTypeToolTips[appointmentType.id],
            onClick: onClick,
            onClickToolTip: onClickToolTip,
            "data-t": appointmentGlobalLabels[appointmentType.id] || appointmentType.id
        }))
    ));
};

const ToggleInfoBox = (_param)=> {
    var { toggleId , icon , text , accessibleLabelText , className , checked , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "toggleId",
        "icon",
        "text",
        "accessibleLabelText",
        "className",
        "checked",
        "onChange"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('toggle-info-box', className)
    }), /*#__PURE__*/ React.createElement(Icon, {
        className: "toggle-info-box__icon",
        name: icon
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "span",
        "aria-hidden": true,
        className: "toggle-info-box__text"
    }, text), /*#__PURE__*/ React.createElement("label", {
        className: "toggle-info-box__label",
        htmlFor: toggleId
    }, accessibleLabelText && /*#__PURE__*/ React.createElement("span", {
        className: "toggle-info-box__accessibleLabel--visually-hidden"
    }, accessibleLabelText), /*#__PURE__*/ React.createElement(Toggle, {
        className: "toggle-info-box__toggle",
        id: toggleId,
        checked: checked,
        onChange: onChange
    })));
};

const getAccessibleLabel = (text, checked, toggleIsOn, toggleIsOff)=>`${text} ${checked ? toggleIsOn : toggleIsOff}`
;
const ToggleInfoBoxContainer = (_param)=>{
    var { text , checked , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "text",
        "checked",
        "onChange"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            toggleIsOn: getLabel('elements.toggleInfoBox.toggleIsOn'),
            toggleIsOff: getLabel('elements.toggleInfoBox.toggleIsOff')
        })
    , [
        getLabel
    ]);
    const [accessibleLabelText, setAccessibleLabel] = React.useState(getAccessibleLabel(text, checked, labels.toggleIsOn, labels.toggleIsOff));
    const handleOnChange = React.useCallback((isChecked)=>{
        onChange(isChecked);
        setAccessibleLabel(getAccessibleLabel(text, isChecked, labels.toggleIsOn, labels.toggleIsOff));
    }, [
        text,
        labels,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(ToggleInfoBox, swcHelpers.extends({}, rest, {
        text: text,
        checked: checked,
        onChange: handleOnChange,
        accessibleLabelText: accessibleLabelText
    }));
};

const ChildAppointmentToggle = (_param)=> {
    var { labels , checked , onChange , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "labels",
        "checked",
        "onChange",
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('child-appointment-toggle', className)
    }), /*#__PURE__*/ React.createElement(ToggleInfoBoxContainer, {
        icon: "child-appointment",
        text: labels.title,
        checked: checked,
        onChange: onChange,
        toggleId: "appointment-child-under-16",
        "data-t": "childAppointmentToggle"
    }));
};

const ChildAppointmentToggleContainer = ({ checked , onChange  })=>{
    const { getLabel  } = useIntl();
    const { sortedAppointmentTypes  } = useAppointmentTypes();
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.component.childAppointmentToggle.title')
        })
    , [
        getLabel
    ]);
    const hasChildAppointmentToggle = React.useMemo(()=>sortedAppointmentTypes.filter(({ isChildAppointment  })=>isChildAppointment
        ).length > 0
    , [
        sortedAppointmentTypes
    ]);
    return hasChildAppointmentToggle ? /*#__PURE__*/ React.createElement(ChildAppointmentToggle, {
        labels: labels,
        checked: checked,
        onChange: onChange
    }) : null;
};

var ref, _description;
var ToolTipPopUpModal = (_param)=>{
    var { className , toolTip , isPhone  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "toolTip",
        "isPhone"
    ]);
     return React.createElement(PopupModal, swcHelpers.extends({}, rest, {
        className: classnames('tool-tip-popup-modal', className),
        title: (ref = toolTip === null || toolTip === void 0 ? void 0 : toolTip.title) !== null && ref !== void 0 ? ref : '',
        showIcon: true
    }), toolTip && /*#__PURE__*/ React.createElement(React.Fragment, null, toolTip.image && /*#__PURE__*/ React.createElement("img", {
        className: "tool-tip-popup-modal__image",
        src: isPhone ? toolTip.image.mobile.url : toolTip.image.original.url,
        alt: (_description = toolTip.image.description) !== null && _description !== void 0 ? _description : undefined
    }), /*#__PURE__*/ React.createElement("div", {
        className: "tool-tip-popup-modal__content",
        dangerouslySetInnerHTML: {
            __html: toolTip.description.value
        }
    })));
};

const ToolTipPopUpModalContainer = (props)=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    return /*#__PURE__*/ React.createElement(ToolTipPopUpModal, swcHelpers.extends({}, props, {
        isPhone: isPhone
    }));
};

const AppointmentTypes = (_param)=> {
    var { className , labels , appointmentTypes , appointmentTypeIcons , appointmentTypeToolTips , appointmentGlobalLabels , isChildAppointmentToggleOn , onClick , onClickToolTip , onCloseToolTip , onChildAppointmentToggleChange , loading =false , activeToolTip =null  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "appointmentTypes",
        "appointmentTypeIcons",
        "appointmentTypeToolTips",
        "appointmentGlobalLabels",
        "isChildAppointmentToggleOn",
        "onClick",
        "onClickToolTip",
        "onCloseToolTip",
        "onChildAppointmentToggleChange",
        "loading",
        "activeToolTip"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-types', className)
    }), /*#__PURE__*/ React.createElement(ToolTipPopUpModalContainer, {
        toolTip: activeToolTip,
        isOpen: Boolean(activeToolTip),
        onModalClose: onCloseToolTip
    }), /*#__PURE__*/ React.createElement(SelectedChoicesContainer, null), /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-types__heading",
        component: "h2",
        variant: "small"
    }, labels.heading), labels.description && /*#__PURE__*/ React.createElement(Text, {
        className: "appointment-types__description",
        variant: "body"
    }, labels.description), loading ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-types__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ChildAppointmentToggleContainer, {
        onChange: onChildAppointmentToggleChange,
        checked: isChildAppointmentToggleOn
    }), /*#__PURE__*/ React.createElement(AppointmentTypeList, {
        className: "appointment-types__list",
        appointmentTypes: appointmentTypes,
        appointmentTypeIcons: appointmentTypeIcons,
        appointmentTypeToolTips: appointmentTypeToolTips,
        appointmentGlobalLabels: appointmentGlobalLabels,
        onClick: onClick,
        onClickToolTip: onClickToolTip
    })));
};

const AppointmentTypesContainer = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const [{ goTo  }, { queryParams  }] = useRoutingContext$2();
    const [{ setStore , setType  }, { store , type: type1  }] = useAppointmentContext();
    const [getBookAppointmentStore, getBookAppointmentStoreQuery] = useBookAppointmentStore();
    const { sortedAppointmentTypes , appointmentTypeIcons , appointmentTypeToolTips , appointmentGlobalLabels ,  } = useAppointmentTypes();
    const [isChildAppointmentToggleOn, setIsChildAppointmentToggleOn] = React.useState(queryParams.typeId ? !!(type1 === null || type1 === void 0 ? void 0 : type1.isChildAppointment) : false);
    const [activeToolTip, setActiveToolTip] = React.useState(null);
    const labels = React.useMemo(()=>({
            heading: getLabel('appointments.component.appointmentTypes.heading'),
            description: getFormattedLabel('appointments.component.appointmentTypes.description', {
                hideLabelKey: true,
                parseLink: true,
                openLinksInNewTab: true
            })
        })
    , [
        getLabel,
        getFormattedLabel
    ]);
    const onClick = React.useCallback((type)=>{
        /* istanbul ignore if */ if (!store) {
            // This should never happen, but it's here to satisfy typescript
            return;
        }
        setType(type);
        const typeId = type.id;
        const storeId = `${store.code}`;
        const { search , userLocation , linkedAppointmentTypeId  } = queryParams;
        goTo('when', {
            typeId,
            storeId,
            search,
            userLocation,
            linkedAppointmentTypeId
        });
    }, [
        queryParams,
        setType,
        goTo,
        store
    ]);
    const onClickToolTip = React.useCallback((toolTip)=>{
        setActiveToolTip(toolTip);
    }, []);
    const onCloseToolTip = React.useCallback(()=>{
        setActiveToolTip(null);
    }, []);
    React.useEffect(()=>{
        /* istanbul ignore if */ if (!store) {
            // This should never happen, but it's here to satisfy typescript
            return;
        }
        const { storeId  } = queryParams;
        const { appointmentTypes  } = store;
        /** Need to check for the appointment types existence to be sure that
     * we are going to send correct store data to the event */ if (Number(storeId) === store.code && appointmentTypes.length) {
            const dataLayerEvent = bookAppointmentWhatStepScreenEvent({
                store: {
                    code: store.code,
                    streetName: store.streetName,
                    town: store.town,
                    name: store.name,
                    postalCode: store.postalCode,
                    streetNumber: store.streetNumber,
                    additionalStreetInfo: store.additionalStreetInfo
                }
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        queryParams,
        store
    ]);
    React.useEffect(()=>{
        const { storeId: storeIdFromUrl  } = queryParams;
        const storeId = fromArrayToString(storeIdFromUrl);
        /** If no store in the context but has a storeId in the URL refetch store data */ if (!store) {
            if (storeId) {
                getBookAppointmentStore(Number(storeId));
            }
            return;
        }
        /** Refetch store data with parameters from url
     *  if has different storeId in url and in the context */ if (storeId && storeId !== `${store.code}`) {
            getBookAppointmentStore(Number(storeId));
            return;
        }
        const { code , appointmentTypes  } = store;
        if (appointmentTypes === null || appointmentTypes === void 0 ? void 0 : appointmentTypes.length) {
            return;
        }
        // Only request the store data when no appointmentTypes are found.
        getBookAppointmentStore(code);
    }, [
        getBookAppointmentStore,
        store
    ]);
    React.useEffect(()=>{
        const { called , data  } = getBookAppointmentStoreQuery;
        if (!called || !data) {
            return;
        }
        setStore(data);
    }, [
        setStore,
        getBookAppointmentStoreQuery
    ]);
    const appointmentTypes1 = React.useMemo(()=>sortedAppointmentTypes.filter(({ isChildAppointment  })=>isChildAppointmentToggleOn ? isChildAppointment : !isChildAppointment
        )
    , [
        isChildAppointmentToggleOn,
        sortedAppointmentTypes
    ]);
    const handleOnChildAppointmentToggleChange = React.useCallback((checked)=>{
        setIsChildAppointmentToggleOn(checked);
    }, []);
    const loading = getBookAppointmentStoreQuery.loading;
    return /*#__PURE__*/ React.createElement(AppointmentTypes, {
        labels: labels,
        appointmentTypes: appointmentTypes1,
        appointmentTypeIcons: appointmentTypeIcons,
        appointmentTypeToolTips: appointmentTypeToolTips,
        appointmentGlobalLabels: appointmentGlobalLabels,
        activeToolTip: activeToolTip,
        onClick: onClick,
        onClickToolTip: onClickToolTip,
        onCloseToolTip: onCloseToolTip,
        loading: loading,
        isChildAppointmentToggleOn: isChildAppointmentToggleOn,
        onChildAppointmentToggleChange: handleOnChildAppointmentToggleChange
    });
};

const DateAndTime = (_param)=>{
    var { className , formattedDate , formattedTime , placeholder  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "formattedDate",
        "formattedTime",
        "placeholder"
    ]);
    const showDateAndTime = formattedDate && formattedTime;
    const showPlaceholder = placeholder && (!formattedDate || !formattedTime);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('date-and-time', className)
    }), /*#__PURE__*/ React.createElement(Icon, {
        name: "calendar",
        height: 32,
        width: 32
    }), /*#__PURE__*/ React.createElement("div", null, showDateAndTime && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        className: "date-and-time__line date-and-time__date-line"
    }, formattedDate), /*#__PURE__*/ React.createElement("p", {
        className: "date-and-time__line"
    }, formattedTime)), showPlaceholder && /*#__PURE__*/ React.createElement("p", {
        className: "date-and-time__line"
    }, placeholder)));
};

const DateAndTimeContainer = (_param)=>{
    var { date , startTime , endTime  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "date",
        "startTime",
        "endTime"
    ]);
    const { dateTime: { formatLongDate , formatTime  } ,  } = useIntl();
    const formattedDate = React.useMemo(()=>{
        if (date) {
            return formatLongDate(date);
        }
    }, [
        date,
        formatLongDate
    ]);
    const formattedTime = React.useMemo(()=>{
        if (startTime && endTime) {
            return `${formatTime(startTime)} - ${formatTime(endTime)}`;
        }
    }, [
        startTime,
        endTime,
        formatTime
    ]);
    return /*#__PURE__*/ React.createElement(DateAndTime, swcHelpers.extends({}, rest, {
        formattedDate: formattedDate,
        formattedTime: formattedTime
    }));
};

const SelectedTypeContainer = ({ urls , store , type , onClick  })=>{
    const { getLabel  } = useIntl();
    const choices = React.useMemo(()=>{
        return {
            type: {
                name: type.name,
                action: getLabel('appointments.component.selectedChoices.change'),
                onClick: ()=>{
                    /* this exists because we need to fire some dataLayer events onClick
          when this is used in stores detail page but at the same time we want
          to keep the component generic in case it is used in another page */ onClick === null || onClick === void 0 ? void 0 : onClick();
                    window.location.assign(`${urls.bookAppointment}/what?storeId=${store.code}`);
                }
            }
        };
    }, [
        getLabel,
        urls,
        store,
        type
    ]);
    return /*#__PURE__*/ React.createElement(SelectedChoices, {
        choices: choices
    });
};

const DropInWidget = ({ className , urls , loading , labels , store , type , noTimeSlotsVariant , timeSlots , calendarLoading , calendarWeekDate , calendarWeekCount , calendarClosedDates , calendarAvailability , selectedDate , timeSlotsLoading , nextAvailableDate , noMoreAvailabilityUntilDate , selectedTimeSlot , preferredTimeLabels , onCalendarWeeksChange , onSelectDate , onSelectTime , noTimeSlotsAction , onBookAppointment , onSelectedTypeContainerClick ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('aab-drop-in-widget', {
            'aab-drop-in-widget--loading': loading,
            'aab-drop-in-widget--expanded': selectedDate !== undefined
        }, className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "smallest",
        className: "aab-drop-in-widget__title"
    }, labels.title), /*#__PURE__*/ React.createElement("section", {
        id: "aab-drop-in-widget__date",
        className: "aab-drop-in-widget__section"
    }, /*#__PURE__*/ React.createElement(PreferredTimeContainer, {
        labels: preferredTimeLabels,
        calendar: /*#__PURE__*/ React.createElement(AvailabilityCalendarContainer, {
            "aria-controls": "aab-drop-in-widget__timeslots",
            loading: calendarLoading,
            weekCount: calendarWeekCount,
            weekDate: calendarWeekDate,
            closedDates: calendarClosedDates,
            availability: calendarAvailability,
            selectedDate: selectedDate,
            onChangeWeeks: onCalendarWeeksChange,
            onSelectDate: onSelectDate
        })
    })), selectedDate ? /*#__PURE__*/ React.createElement(React.Fragment, null, store && type && /*#__PURE__*/ React.createElement("section", {
        id: "aab-drop-in-widget__type",
        className: "aab-drop-in-widget__section"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "aab-drop-in-widget__section-title"
    }, labels.type), /*#__PURE__*/ React.createElement(SelectedTypeContainer, {
        urls: urls,
        store: store,
        type: type,
        onClick: onSelectedTypeContainerClick
    })), /*#__PURE__*/ React.createElement("section", {
        id: "aab-drop-in-widget__timeslots",
        className: "aab-drop-in-widget__timeslots aab-drop-in-widget__section",
        "aria-live": "polite"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "aab-drop-in-widget__section-title"
    }, labels.selectATime), noTimeSlotsVariant === Variant.none ? /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading,
        slots: timeSlots,
        selected: selectedTimeSlot,
        onSelectTime: onSelectTime
    }) : /*#__PURE__*/ React.createElement(NoTimeSlotsContainer, {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    }))) : null, /*#__PURE__*/ React.createElement(Button$1, {
        className: "aab-drop-in-widget__book-appointment-button",
        variant: "solid",
        onClick: onBookAppointment,
        disabled: loading || !store
    }, labels.bookAppointment))
;

const hasRequiredUrls = (urls)=>typeof urls.bookAppointment !== 'undefined'
;
const sanitizeUrls = (urls)=>{
    var ref;
    const sanitizedBookAppointmentUrl = (ref = urls.bookAppointment) === null || ref === void 0 ? void 0 : ref.replace(/\/+(where|what|when|who|confirmation)+/, '');
    return swcHelpers.objectSpread({}, urls, {
        bookAppointment: sanitizedBookAppointmentUrl
    });
};
const DropInWidgetContainer = ({ urls , storeId , typeId , dataLayerEvents ,  })=>{
    const { featureConfigs  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const [storeQuery, storeQueryStatus] = useBookAppointmentStore();
    const [typeQuery, typeQueryStatus] = useBookAppointmentType();
    const [getCalendarAvailability, calendarAvailability] = useCalendarAvailability();
    const [getStoreOpeningTimes, storeOpeningTimes] = useStoreOpeningTimes();
    const [weekDate, setWeekDate] = React.useState();
    const [weeks1, setWeeks] = React.useState();
    const [date1, setDate] = React.useState();
    const [availabilityRequestParamsChanged, setAvailabilityRequestParamsChanged] = React.useState(true);
    const [timeSlot1, setTimeSlot] = React.useState();
    const appointmentBookingAvailabiltyCalendarWeekCount = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.appointmentBookingAvailabiltyCalendarWeekCount;
    // We need the urls without a specific route
    const sanitizedUrls = React.useMemo(()=>sanitizeUrls(urls)
    , [
        urls
    ]);
    const loading = storeQueryStatus.loading || typeQueryStatus.loading;
    const store = storeQueryStatus.data;
    const type = typeQueryStatus.data;
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.component.dropInWidget.title'),
            date: getLabel('appointments.component.dropInWidget.date'),
            type: getLabel('appointments.component.dropInWidget.type'),
            selectATime: getLabel('appointments.component.dropInWidget.selectATime'),
            bookAppointment: getLabel('appointments.component.dropInWidget.bookAppointment')
        })
    , [
        getLabel
    ]);
    const preferredTimeLabels = React.useMemo(()=>({
            title: getLabel('appointments.component.dropInWidget.preferredTime.title')
        })
    , [
        getLabel
    ]);
    const closedDates = React.useMemo(()=>{
        if (!weeks1 || !storeOpeningTimes.data) {
            return [];
        }
        return getClosedDates(weeks1, storeOpeningTimes.data);
    }, [
        weeks1,
        storeOpeningTimes.data
    ]);
    useDebouncedEffect(()=>{
        const appointmentTypeId = type === null || type === void 0 ? void 0 : type.id;
        const storeCode = store === null || store === void 0 ? void 0 : store.code;
        if (!appointmentTypeId || !storeCode || !weeks1) {
            /* istanbul ignore else */ if (process.env.NODE_ENV === 'test') {
                console.log('Awaiting availability request variables data');
            }
            return;
        }
        const [[firstWeekDay]] = weeks1.slice(0);
        const [lastWeek] = weeks1.slice(-1);
        const [lastWeekDay] = lastWeek.slice(-1);
        getCalendarAvailability({
            appointmentTypeId,
            storeCode: storeCode.toString(),
            startDate: firstWeekDay,
            endDate: lastWeekDay
        });
        setAvailabilityRequestParamsChanged(false);
    }, 400, [
        getCalendarAvailability,
        type,
        store,
        weeks1
    ]);
    const onCalendarWeeksChange = React.useCallback((weeks)=>{
        setAvailabilityRequestParamsChanged(true);
        setWeeks(weeks);
    }, []);
    const onSelectDate = React.useCallback((date)=>{
        setDate(date);
    }, []);
    const [getTimeSlots, timeSlots] = useTimeSlots();
    const nextAvailableDate = useNextAvailableDate(date1, calendarAvailability, !timeSlots.called);
    const nextWeekDate = useNextWeekDate(weeks1, !date1 || Boolean(nextAvailableDate));
    const noTimeSlotsVariant = useNoTimeSlotsVariant(timeSlots, nextAvailableDate, date1, closedDates);
    const onSelectTimeSlot = React.useCallback((timeSlot)=>setTimeSlot(timeSlot)
    , []);
    const onBookAppointment = React.useCallback(()=>{
        // This should never happen, but is here to satisfy ts.
        if (!store) {
            return;
        }
        if (dataLayerEvents) {
            const dataLayerEvent = timeSlot1 && type ? storeFastAppointmentClickEvent({
                event: dataLayerEvents.storeAppointmentClickEvent,
                storeDetails: swcHelpers.objectSpread({
                    id: store.code.toString(),
                    city: store.town
                }, store),
                selectedDateTime: timeSlot1.from,
                appointmentType: type.id.toString()
            }) : storeBookAppointmentClickEvent({
                event: dataLayerEvents.storeAppointmentClickEvent,
                storeDetails: swcHelpers.objectSpread({
                    id: store.code.toString(),
                    city: store.town
                }, store)
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
        // No further selections were performed, skip to what step
        if (!type || !timeSlot1) {
            window.location.assign(`${sanitizedUrls.bookAppointment}/what?storeId=${store.code}`);
            return;
        }
        // Skip to aab/who step
        window.location.assign(`${sanitizedUrls.bookAppointment}/who?storeId=${store.code}&typeId=${type.id}&start=${timeSlot1.from.getTime()}&end=${timeSlot1.until.getTime()}`);
    }, [
        sanitizedUrls,
        store,
        type,
        timeSlot1
    ]);
    const onSelectedTypeContainerClick = React.useCallback(()=>{
        // This should never happen, but is here to satisfy ts.
        if (!store) {
            return;
        }
        if (dataLayerEvents) {
            const dataLayerEvent = storeChangeAppointmentTypeClickEvent({
                event: dataLayerEvents.storeChangeAppointmentTypeClickEvent,
                storeDetails: swcHelpers.objectSpread({
                    id: store.code.toString(),
                    city: store.town
                }, store)
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        store
    ]);
    React.useEffect(()=>{
        if (!storeId) {
            return;
        }
        storeQuery(storeId);
    }, [
        storeId,
        storeQuery
    ]);
    React.useEffect(()=>{
        if (!typeId) {
            return;
        }
        typeQuery(typeId);
    }, [
        typeId,
        typeQuery
    ]);
    React.useEffect(()=>{
        if (!store) {
            return;
        }
        getStoreOpeningTimes({
            variables: {
                code: store.code
            }
        });
    }, [
        getStoreOpeningTimes,
        store
    ]);
    const noTimeSlotsAction = React.useCallback(()=>{
        switch(noTimeSlotsVariant){
            case Variant.date:
            case Variant.closedDate:
                /* istanbul ignore if */ if (!nextAvailableDate) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                setDate(nextAvailableDate);
                break;
            case Variant.week:
            case Variant.closedWeek:
                /* istanbul ignore if */ if (!nextWeekDate) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                setWeekDate(nextWeekDate);
                setDate(nextWeekDate);
                break;
            case Variant.error:
                var ref;
                const storeCode = (ref = store === null || store === void 0 ? void 0 : store.code) !== null && ref !== void 0 ? ref : undefined;
                var ref1;
                const appointmentTypeId = (ref1 = type === null || type === void 0 ? void 0 : type.id) !== null && ref1 !== void 0 ? ref1 : undefined;
                /* istanbul ignore if */ if (!date1 || storeCode === undefined || appointmentTypeId === undefined) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                getTimeSlots({
                    variables: {
                        storeCode: `${storeCode}`,
                        appointmentTypeId,
                        date: DateUtils.toLocalDate(date1)
                    }
                });
            case Variant.none:
                return;
        }
    }, [
        noTimeSlotsVariant,
        nextAvailableDate,
        nextWeekDate,
        getTimeSlots,
        store,
        type,
        date1
    ]);
    React.useEffect(()=>{
        calendarAvailability.error && console.error('Error fetching appointment availability:', calendarAvailability.error.message);
    }, [
        calendarAvailability.error
    ]);
    React.useEffect(()=>{
        var ref;
        const storeCode = (ref = store === null || store === void 0 ? void 0 : store.code) !== null && ref !== void 0 ? ref : undefined;
        var ref2;
        const appointmentTypeId = (ref2 = type === null || type === void 0 ? void 0 : type.id) !== null && ref2 !== void 0 ? ref2 : undefined;
        /* istanbul ignore if */ if (!date1 || storeCode === undefined || appointmentTypeId === undefined) {
            // This should never happen, but it's here to satisfy typescript
            return;
        }
        getTimeSlots({
            variables: {
                storeCode: `${storeCode}`,
                appointmentTypeId,
                date: DateUtils.toLocalDate(date1)
            }
        });
    }, [
        getTimeSlots,
        store,
        type,
        date1
    ]);
    const calendarLoading = storeQueryStatus.loading || typeQueryStatus.loading || storeOpeningTimes.loading || calendarAvailability.loading || availabilityRequestParamsChanged;
    if (!hasRequiredUrls(sanitizedUrls)) {
        console.error('Cannot render DropInWidget, missing required urls.');
        return null;
    }
    return /*#__PURE__*/ React.createElement(DropInWidget, {
        urls: sanitizedUrls,
        loading: loading,
        labels: labels,
        store: store,
        type: type,
        onCalendarWeeksChange: onCalendarWeeksChange,
        selectedDate: date1,
        onSelectDate: onSelectDate,
        calendarLoading: calendarLoading,
        calendarWeekDate: weekDate,
        calendarWeekCount: appointmentBookingAvailabiltyCalendarWeekCount,
        calendarClosedDates: closedDates,
        calendarAvailability: calendarAvailability.data,
        timeSlotsLoading: timeSlots.loading,
        timeSlots: timeSlots.filtered.included,
        onSelectTime: onSelectTimeSlot,
        selectedTimeSlot: timeSlot1,
        noTimeSlotsVariant: noTimeSlotsVariant,
        noTimeSlotsAction: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noMoreAvailabilityUntilDate: nextWeekDate,
        onBookAppointment: onBookAppointment,
        preferredTimeLabels: preferredTimeLabels,
        onSelectedTypeContainerClick: onSelectedTypeContainerClick
    });
};

const SignInBox = (_param)=> {
    var { className , labels , signInUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "signInUrl"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames(className, 'sign-in-box')
    }), /*#__PURE__*/ React.createElement(Icon, {
        name: "user",
        width: 56
    }), /*#__PURE__*/ React.createElement("div", {
        className: "sign-in-box__text"
    }, /*#__PURE__*/ React.createElement(Text, null, labels.haveAnAccount), /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement("a", {
        className: "sign-in-box__link",
        href: signInUrl
    }, labels.signIn), ' ', labels.addInfo)));
};

const SignInBoxContainer = (props)=>{
    const { hasLabel , getLabel  } = useIntl();
    const [, { basePath , signInMyAccountUrl , queryParams  }] = useRoutingContext$2();
    const labels = React.useMemo(()=>({
            haveAnAccount: getLabel('appointments.selectionSteps.details.haveAnAccount'),
            signIn: getLabel('appointments.selectionSteps.details.signIn'),
            addInfo: hasLabel('appointments.selectionSteps.details.addInfo') ? getLabel('appointments.selectionSteps.details.addInfo') : undefined
        })
    , [
        hasLabel,
        getLabel
    ]);
    const signInUrl = React.useMemo(()=>{
        const origin = typeof window === 'undefined' ? '' : window.location.origin;
        return `${origin}${signInMyAccountUrl}?returnPath=${basePath}/who${encodeURIComponent(QueryString.stringify(queryParams))}`;
    }, [
        basePath,
        signInMyAccountUrl,
        queryParams
    ]);
    return /*#__PURE__*/ React.createElement(SignInBox, swcHelpers.extends({}, props, {
        labels: labels,
        signInUrl: signInUrl
    }));
};

var containers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AppointmentConfirmation: AppointmentConfirmationContainer,
  AppointmentCustomerForm: AppointmentCustomerFormContainer,
  AppointmentDateTime: AppointmentDateTimeContainer,
  AppointmentError: AppointmentErrorContainer,
  AppointmentLocation: AppointmentLocationContainer,
  AppointmentOverview: AppointmentOverviewContainer,
  AppointmentPrice: AppointmentPriceContainer,
  AppointmentTypeButton: AppointmentTypeButtonContainer,
  AppointmentTypes: AppointmentTypesContainer,
  AvailabilityCalendar: AvailabilityCalendarContainer,
  ChildAppointmentToggle: ChildAppointmentToggleContainer,
  DateAndTime: DateAndTimeContainer,
  DropInWidget: DropInWidgetContainer,
  Header: HeaderContainer,
  Layout: LayoutContainer,
  LinkedAppointmentInfo: AppointmentInfoContainer,
  NoTimeSlots: NoTimeSlotsContainer,
  PreferredTime: PreferredTimeContainer,
  PreferredTimePopupModal: PreferredTimePopupModalContainer,
  SelectedChoices: SelectedChoicesContainer,
  StoreFinder: StoreFinderContainer,
  StoreOverview: StoreOverviewContainer,
  TimeSlots: TimeSlotsContainer,
  ToggleInfoBox: ToggleInfoBoxContainer,
  UserInfoOverview: UserInfoOverviewContainer,
  SignInBox: SignInBoxContainer,
  AppointmentSurvey: AppointmentSurveyContainer,
  AppointmentConfirmationInstructions: AppointmentConfirmationInstructionsContainer
});

const WhereRoot = ()=>{
    const [, { type  }] = useAppointmentContext();
    return /*#__PURE__*/ React.createElement(AppointmentLocationContainer, {
        appointmentTypeId: type === null || type === void 0 ? void 0 : type.id
    });
};
WhereRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        let promises = [
            null,
            null,
            null
        ];
        if (hasValidVirtualAppointmentParams(formattedParams)) {
            const type = yield getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
            promises = [
                type ? generateVirtualAppointmentStoreData(formattedParams.virtualStoreCode, type) : null,
                type,
                null, 
            ];
        } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        } else {
            promises = [
                getBookAppointmentStore(apolloClient, formattedParams.storeId, locale),
                getBookAppointmentType(apolloClient, formattedParams.typeId, locale),
                getBookAppointmentType(apolloClient, formattedParams.linkedAppointmentTypeId, locale), 
            ];
        }
        const [store, type, linkedAppointmentType] = yield Promise.all(promises);
        if (formattedParams.storeId && ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.storeId))) {
            throw AlternativeUrlStoreError();
        } else if (formattedParams.storeId && !store) {
            throw StoreNotFoundError();
        } else if (formattedParams.typeId && !type) {
            throw TypeNotFoundError();
        } else if (store && type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId) && !linkedAppointmentType) {
            throw LinkedAppointmentTypeNotValidError();
        }
        return Promise.resolve({
            store,
            type,
            timeSlot: null
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

const WhatRoot = ()=>/*#__PURE__*/ React.createElement(AppointmentTypesContainer, null)
;
WhatRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        if (formattedParams.storeId === undefined) {
            throw MissingStoreIdError();
        }
        if ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.storeId)) {
            throw AlternativeUrlStoreError();
        }
        // This route should not be visited with any virtual appointment params, valid or invalid.
        if (hasValidVirtualAppointmentParams(formattedParams) || hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        }
        const [store, type, linkedAppointmentType] = yield Promise.all([
            getBookAppointmentStore(apolloClient, formattedParams.storeId, locale),
            getBookAppointmentType(apolloClient, formattedParams.typeId, locale),
            getBookAppointmentType(apolloClient, formattedParams.linkedAppointmentTypeId, locale), 
        ]);
        if (!store) {
            throw StoreNotFoundError();
        } else if (formattedParams.typeId && !type) {
            throw TypeNotFoundError();
        } else if (type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId) && !linkedAppointmentType) {
            throw LinkedAppointmentTypeNotValidError();
        }
        return Promise.resolve({
            store,
            type,
            timeSlot: null
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

const WhenRoot = ()=>{
    return /*#__PURE__*/ React.createElement(AppointmentDateTimeContainer, null);
};
WhenRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        if (formattedParams.storeId === undefined) {
            throw MissingStoreIdError();
        }
        if ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.storeId)) {
            throw AlternativeUrlStoreError();
        }
        if (formattedParams.typeId === undefined) {
            throw MissingTypeIdError();
        }
        let promises = [
            null,
            null,
            null
        ];
        if (hasValidVirtualAppointmentParams(formattedParams)) {
            const type = yield getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
            promises = [
                type ? generateVirtualAppointmentStoreData(formattedParams.virtualStoreCode, type) : null,
                type,
                null, 
            ];
        } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        } else {
            promises = [
                getBookAppointmentStore(apolloClient, formattedParams.storeId, locale),
                getBookAppointmentType(apolloClient, formattedParams.typeId, locale),
                getBookAppointmentType(apolloClient, formattedParams.linkedAppointmentTypeId, locale), 
            ];
        }
        const [store, type, linkedAppointmentType] = yield Promise.all(promises);
        if (!store) {
            throw StoreNotFoundError();
        } else if (!type) {
            throw TypeNotFoundError();
        } else if (type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId) && !linkedAppointmentType) {
            throw LinkedAppointmentTypeNotValidError();
        }
        let timeSlot = null;
        if (formattedParams.start && formattedParams.end) {
            timeSlot = {
                from: formattedParams.start,
                until: formattedParams.end
            };
        }
        return Promise.resolve({
            store,
            type,
            timeSlot
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

const WhoRoot = ()=>{
    /** Refetch store, appointment type and time slots if has different typeId, storeId, start, end in the url
   * and store code, type id and time slot in the context.
   * This can be possible when user use back and forth browser button to navigate between steps */ useBookAppointmentStoreWithUrlParam();
    useBookAppointmentTypeWithUrlParam();
    useBookAppointmentTimeSlotWithUrlParam();
    return /*#__PURE__*/ React.createElement(AppointmentCustomerFormContainer, null);
};
WhoRoot.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, params, locale) {
        var ref;
        const formattedParams = getFormattedParams(params);
        if (formattedParams.storeId === undefined) {
            throw MissingStoreIdError();
        }
        if ((ref = formattedParams.alternativeUrlStores) === null || ref === void 0 ? void 0 : ref.includes(formattedParams.storeId)) {
            throw AlternativeUrlStoreError();
        }
        if (formattedParams.typeId === undefined) {
            throw MissingTypeIdError();
        }
        if (formattedParams.start === undefined) {
            throw MissingTimeSlotStartError();
        }
        if (formattedParams.end === undefined) {
            throw MissingTimeSlotEndError();
        }
        let promises = [
            null,
            null
        ];
        if (hasValidVirtualAppointmentParams(formattedParams)) {
            const type = yield getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
            promises = [
                type ? generateVirtualAppointmentStoreData(formattedParams.virtualStoreCode, type) : null,
                type, 
            ];
        } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
            throw InvalidVirtualAppointmentError();
        } else {
            promises = [
                getBookAppointmentStore(apolloClient, formattedParams.storeId, locale),
                getBookAppointmentType(apolloClient, formattedParams.typeId, locale), 
            ];
        }
        const [store, type] = yield Promise.all(promises);
        if (!store) {
            throw StoreNotFoundError();
        } else if (!type) {
            throw TypeNotFoundError();
        } else if (type && !isAppointmentTypeValid({
            typeId: type === null || type === void 0 ? void 0 : type.id,
            store
        })) {
            throw TypeNotAvailableForStoreError();
        } else if ((formattedParams === null || formattedParams === void 0 ? void 0 : formattedParams.linkedAppointmentTypeId) && !isAppointmentTypeValid({
            typeId: formattedParams.linkedAppointmentTypeId,
            store
        })) {
            throw LinkedAppointmentTypeNotValidError();
        }
        return Promise.resolve({
            store,
            type,
            timeSlot: {
                from: formattedParams.start,
                until: formattedParams.end
            }
        });
    });
    return function(apolloClient, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

const routeMap$2 = {
    '': WhereRoot,
    where: WhereRoot,
    what: WhatRoot,
    when: WhenRoot,
    who: WhoRoot,
    confirmation: ConfirmationRoot
};

const appointmentErrors = [
    'INTERNAL_SERVER_ERROR',
    'TOKEN_NOT_VALID_OR_EXPIRED',
    'JWT_TOKEN_NOT_FOUND',
    'APPOINTMENT_NOT_FOUND',
    'APPOINTMENT_IN_THE_PAST',
    'APPOINTMENT_CANCELLED_RESCHEDULED', 
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isAppointmentErrorStatus = (error)=>{
    return appointmentErrors.includes(error);
};

const ErrorBoundary = ({ bookAppointmentUrl , children  })=>/*#__PURE__*/ React.createElement(ErrorBoundary$1, null, (error)=>error ? /*#__PURE__*/ React.createElement(AppointmentErrorContainer, {
            bookAppointmentUrl: bookAppointmentUrl,
            status: isAppointmentErrorStatus(error.message) ? error.message : 'INTERNAL_SERVER_ERROR'
        }) : children
    )
;

var RoutingError$1;
(function(RoutingError) {
    RoutingError["INVALID_ROUTE"] = "INVALID_ROUTE";
    RoutingError["SERVER_SIDE_CONFIRMATION_ATTEMPT"] = "SERVER_SIDE_CONFIRMATION_ATTEMPT";
})(RoutingError$1 || (RoutingError$1 = {}));
const routingErrorHandler$1 = (errorMessage, selfUrl, asPath, currentRoute, queryParams, publicRuntimeConfig)=>{
    const { myAccount  } = getRuntimeFeatureValues(publicRuntimeConfig);
    switch(errorMessage){
        case RoutingError$1.INVALID_ROUTE:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, '', queryParams)
            };
        case RoutingError$1.SERVER_SIDE_CONFIRMATION_ATTEMPT:
            const redirectUrl = myAccount ? `${selfUrl}/my-account/profile` : `${selfUrl}/`;
            return {
                type: 'redirect',
                url: redirectUrl
            };
        default:
            return {
                type: 'not-found'
            };
    }
};

const rescheduleAppointmentContextDefaultValues = {
    config: {
        opco: '',
        googleMapsApiKey: '',
        storesUrl: '',
        bookAppointmentUrl: '',
        cancelAppointmentUrl: '',
        appointmentTypes: undefined,
        offerFallbackImageUrl: undefined
    },
    appointment: undefined,
    setAppointment: ()=>null
    ,
    store: undefined,
    setStore: ()=>null
    ,
    selectedTimeSlot: undefined,
    setSelectedTimeSlot: ()=>null
};
const RescheduleAppointmentContext = /*#__PURE__*/ React.createContext(rescheduleAppointmentContextDefaultValues);
const useRescheduleAppointmentContext = ()=>{
    const context = React.useContext(RescheduleAppointmentContext);
    if (context === rescheduleAppointmentContextDefaultValues) {
        throw new Error('No RescheduleAppointmentContext available. You might still need to wrap the application with the RescheduleAppointmentProvider component.');
    }
    return context;
};
RescheduleAppointmentContext.displayName = 'RescheduleAppointment';
RescheduleAppointmentContext.Consumer;

const RescheduleAppointmentProvider = ({ opco , googleMapsApiKey , storesUrl , bookAppointmentUrl , cancelAppointmentUrl , token , appointmentId , appointmentTypes , offerFallbackImageUrl , children ,  })=>{
    const [appointment, setAppointment] = React.useState(undefined);
    const [store, setStore] = React.useState(undefined);
    const [selectedTimeSlot, setSelectedTimeSlot] = React.useState(undefined);
    const values = React.useMemo(()=>({
            config: {
                opco,
                googleMapsApiKey,
                storesUrl,
                bookAppointmentUrl,
                cancelAppointmentUrl,
                token,
                appointmentId,
                appointmentTypes,
                offerFallbackImageUrl
            },
            store,
            appointment,
            selectedTimeSlot,
            setStore,
            setAppointment,
            setSelectedTimeSlot
        })
    , [
        opco,
        googleMapsApiKey,
        storesUrl,
        bookAppointmentUrl,
        cancelAppointmentUrl,
        token,
        appointmentId,
        appointmentTypes,
        offerFallbackImageUrl,
        store,
        appointment,
        selectedTimeSlot,
        setStore,
        setAppointment,
        setSelectedTimeSlot, 
    ]);
    return /*#__PURE__*/ React.createElement(RescheduleAppointmentContext.Provider, {
        value: values
    }, children);
};

const defaultRoutingContextValue$1 = [
    {
        goTo: ()=>null
    },
    {
        component: undefined,
        queryParams: {},
        currentRoute: '',
        basePath: ''
    }, 
];
const RoutingContext$1 = /*#__PURE__*/ React.createContext(defaultRoutingContextValue$1);
const useRoutingContext$1 = ()=>React.useContext(RoutingContext$1)
;

const RoutingContextProvider$1 = ({ routeMap , initialRoutingState , initialRescheduleAppointmentState , children ,  })=>{
    const { Provider  } = RoutingContext$1;
    const { basePath , currentRoute: initialRoute , queryParams: initialQueryParams ,  } = initialRoutingState;
    const [{ goTo  }, { queryParams: queryParams1 , currentRoute  }] = useClientSideRouter({
        basePath,
        initialRoute,
        initialQueryParams
    });
    const goToHandler = React.useCallback((route, queryParams)=>{
        const newQueryParams = swcHelpers.objectSpread({}, queryParams);
        Object.keys(newQueryParams).forEach((key)=>newQueryParams[key] === undefined ? delete newQueryParams[key] : {}
        );
        goTo(`${basePath}/${route}${QueryString.toQueryParams(newQueryParams)}`);
    }, [
        basePath,
        goTo
    ]);
    const value = React.useMemo(()=>[
            {
                goTo: goToHandler
            },
            {
                component: routeMap[currentRoute],
                queryParams: queryParams1,
                currentRoute,
                basePath
            }, 
        ]
    , [
        routeMap,
        goToHandler,
        currentRoute,
        basePath,
        queryParams1
    ]);
    const Component = routeMap[currentRoute];
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, /*#__PURE__*/ React.createElement(RescheduleAppointmentProvider, swcHelpers.extends({}, initialRescheduleAppointmentState), /*#__PURE__*/ React.createElement(ErrorBoundary, {
        bookAppointmentUrl: initialRescheduleAppointmentState.bookAppointmentUrl
    }, /*#__PURE__*/ React.createElement(Component, null))), children);
};
RoutingContextProvider$1.getServerSideProps = (currentRoute, routeMap /* locale */ )=>{
    const isValidRoute = currentRoute in routeMap;
    if (!isValidRoute) {
        throw new Error(RoutingError$1.INVALID_ROUTE);
    }
    if (currentRoute === 'confirmation') {
        throw new Error(RoutingError$1.SERVER_SIDE_CONFIRMATION_ATTEMPT);
    }
};

var AppointmentCommunicationChannel$1;
(function(AppointmentCommunicationChannel) {
    AppointmentCommunicationChannel["EMAIL"] = "EMAIL";
    AppointmentCommunicationChannel["SMS"] = "SMS";
})(AppointmentCommunicationChannel$1 || (AppointmentCommunicationChannel$1 = {}));

const ControlledCheckbox = (_param)=>{
    var { id , className , label , value , 'data-t': dataT , 'aria-label': ariaLabel , onChange: onChangeProp , required  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        "className",
        "label",
        "value",
        'data-t',
        'aria-label',
        "onChange",
        "required"
    ]);
    var ref;
    const formContext = useFormContext();
    const onChange = React.useCallback(({ checked  })=>{
        onChangeProp && onChangeProp(checked ? 'true' : '');
    }, [
        onChangeProp
    ]);
    var ref1;
    const { isTouched , isValid  } = (ref1 = (ref = formContext.getInitialState) === null || ref === void 0 ? void 0 : ref.call(formContext, id)) !== null && ref1 !== void 0 ? ref1 : {};
    return /*#__PURE__*/ React.createElement(CheckboxView, swcHelpers.extends({}, rest, {
        "data-t": dataT,
        id: id,
        className: classnames('controlled-checkbox', className),
        label: label,
        "aria-label": ariaLabel,
        value: value !== null && value !== void 0 ? value : '',
        checked: value === 'true',
        error: isTouched && isValid === false,
        errorId: `${id}_error`,
        required: required,
        onChange: onChange
    }));
};

var _id;
const CheckboxField = (_param)=> {
    var { label , 'data-t': dataT , 'aria-label': ariaLabel  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        'data-t',
        'aria-label'
    ]);
    return React.createElement(Field, swcHelpers.extends({}, rest), /*#__PURE__*/ React.createElement(ControlledCheckbox, {
        id: (_id = rest.id) !== null && _id !== void 0 ? _id : rest.name,
        "data-t": dataT,
        "aria-label": ariaLabel,
        label: label
    }));
};

const labelOptions = {
    parseHTML: false,
    parseLink: true,
    openLinksInNewTab: true
};
const ConsentsAndOptIns = (_param)=>{
    var { className , errorMessage , consents , optIns , showOptIns =true , showConsents =true  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "errorMessage",
        "consents",
        "optIns",
        "showOptIns",
        "showConsents"
    ]);
    const { getFormattedLabel  } = useIntl();
    if (!showConsents && !showOptIns) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('consents-and-opt-ins', className)
    }), showConsents && consents.map((consent)=>/*#__PURE__*/ React.createElement("li", {
            key: consent.title,
            className: "consents-and-opt-ins__consent"
        }, /*#__PURE__*/ React.createElement(CheckboxField, {
            name: consent.value,
            label: /*#__PURE__*/ React.createElement(React.Fragment, null, parseHtml(getFormattedLabel(consent.title, labelOptions)), /*#__PURE__*/ React.createElement("span", {
                className: "consents-and-opt-ins__required-asterisk"
            }, "*")),
            "aria-label": consent.ariaLabel,
            error: errorMessage,
            required: true,
            validations: [
                Util$1.validations.isRequired
            ],
            "data-t": consent.value
        }))
    ), showOptIns && optIns.map((optIn)=>/*#__PURE__*/ React.createElement("li", {
            key: optIn.title,
            className: "consents-and-opt-ins__opt-in"
        }, /*#__PURE__*/ React.createElement(CheckboxField, {
            name: optIn.value,
            label: parseHtml(getFormattedLabel(optIn.title, labelOptions)),
            "aria-label": optIn.ariaLabel,
            error: "",
            required: false,
            "data-t": optIn.value
        }))
    ));
};

var OptionalFieldset = (_param)=>{
    var { className , labels , active , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "active",
        "children"
    ]);
    return active ? /*#__PURE__*/ React.createElement("fieldset", swcHelpers.extends({}, rest, {
        className: classnames('optional-fieldset', className)
    }), /*#__PURE__*/ React.createElement("legend", {
        className: "optional-fieldset__legend"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1",
        component: "h3"
    }, labels.legend)), /*#__PURE__*/ React.createElement("div", {
        className: "optional-fieldset__content"
    }, children)) : /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AppointmentConfirmation: AppointmentConfirmation,
  AppointmentCustomerForm: AppointmentCustomerForm,
  AppointmentDateTime: AppointmentDateTime,
  AppointmentError: AppointmentError,
  AppointmentLocation: AppointmentLocation,
  AppointmentOverview: AppointmentOverview,
  AppointmentTypeButton: AppointmentTypeButton,
  AppointmentTypeList: AppointmentTypeList,
  AppointmentTypes: AppointmentTypes,
  AvailabilityCalendar: AvailabilityCalendar,
  ChildAppointmentToggle: ChildAppointmentToggle,
  ConsentsAndOptIns: ConsentsAndOptIns,
  CheckboxField: CheckboxField,
  DateAndTime: DateAndTime,
  DropInWidget: DropInWidget,
  Header: Header,
  ErrorBoundary: ErrorBoundary,
  ICSButton: ICSButton,
  Layout: Layout,
  NoTimeSlots: NoTimeSlots,
  OptionalFieldset: OptionalFieldset,
  PopupModal: PopupModal,
  PreferredTime: PreferredTime,
  PreferredTimePopupModal: PreferredTimePopupModal,
  SelectedChoices: SelectedChoices,
  SignInBox: SignInBox,
  StoreOverview: StoreOverview,
  TimeSlots: TimeSlots,
  ToggleInfoBox: ToggleInfoBox,
  UserInfoOverview: UserInfoOverview,
  AppointmentSurvey: AppointmentSurvey,
  AppointmentConfirmationInstructions: AppointmentConfirmationInstructions
});

const StoreOffers = Containers.StoreOffers;
const RescheduleAppointmentConfirmation = (_param)=>{
    var { className , labels , appointment , store , offers , timeSlot , storesUrl , directionsUrl , googleMapsApiKey , returnPath , returnLabel , appointmentConfirmationContent , offerFallbackImageUrl , isVirtualAppointmentType , onICSButtonClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "appointment",
        "store",
        "offers",
        "timeSlot",
        "storesUrl",
        "directionsUrl",
        "googleMapsApiKey",
        "returnPath",
        "returnLabel",
        "appointmentConfirmationContent",
        "offerFallbackImageUrl",
        "isVirtualAppointmentType",
        "onICSButtonClick"
    ]);
    var ref, ref1, ref2, ref3;
    const { id , appointmentType , startTime , endTime , isReservation  } = appointment;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('reschedule-appointment-confirmation', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "small",
        className: "cancel-appointment-confirmation__title"
    }, labels.title), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(Text, null, labels.confirmation), /*#__PURE__*/ React.createElement(Alert, {
        icon: "checkmark-circle",
        type: "success",
        message: /*#__PURE__*/ React.createElement("b", null, labels.notification),
        className: "reschedule-appointment-confirmation__alert"
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.subtitle), /*#__PURE__*/ React.createElement("div", {
        className: "reschedule-appointment-confirmation__appointment_overview_wrapper"
    }, /*#__PURE__*/ React.createElement(AppointmentOverview, {
        className: "reschedule-appointment-confirmation__appointment_overview",
        appointment: {
            id,
            appointmentType,
            startTime,
            endTime
        },
        labels: {
            child: ''
        }
    }, appointment.customerComment && /*#__PURE__*/ React.createElement(Text, {
        className: "reschedule-appointment-confirmation__customer-comment"
    }, labels.additionalInformation, ": ", appointment.customerComment)), store && appointmentType && timeSlot && !isReservation && /*#__PURE__*/ React.createElement(ICSButton, {
        caption: labels.addToCalendar,
        appointmentType: appointmentType,
        timeSlot: timeSlot,
        store: store,
        variant: "outline",
        className: "reschedule-appointment-confirmation__button",
        onClick: onICSButtonClick
    })), !isVirtualAppointmentType && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.where), store && /*#__PURE__*/ React.createElement(StoreOverviewContainer, {
        store: store,
        googleMapsApiKey: googleMapsApiKey,
        storesUrl: storesUrl
    })), directionsUrl && /*#__PURE__*/ React.createElement(Button, {
        icon: "location-pin",
        variant: "outline",
        hrefTarget: "_blank",
        href: directionsUrl,
        caption: labels.getDirections,
        className: "reschedule-appointment-confirmation__button reschedule-appointment-confirmation__button--get-direction"
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.who), /*#__PURE__*/ React.createElement(UserInfoOverviewContainer, {
        user: {
            firstName: (ref = appointment.invitee) === null || ref === void 0 ? void 0 : ref.firstName,
            lastName: (ref1 = appointment.invitee) === null || ref1 === void 0 ? void 0 : ref1.lastName,
            email: (ref2 = appointment.invitee) === null || ref2 === void 0 ? void 0 : ref2.email,
            phone: (ref3 = appointment.invitee) === null || ref3 === void 0 ? void 0 : ref3.phone,
            child: appointment.child
        }
    }), !isReservation && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.cantMakeIt), /*#__PURE__*/ React.createElement(Text, null, labels.confirmationEmailInstruction)), !isReservation && appointmentConfirmationContent && /*#__PURE__*/ React.createElement(AppointmentConfirmationInstructionsContainer, {
        confirmationContent: appointmentConfirmationContent
    }), !isReservation && offers && offers.length > 0 && /*#__PURE__*/ React.createElement(StoreOffers, {
        className: "reschedule-appointment-confirmation__store-offers",
        fallbackImage: offerFallbackImageUrl,
        offers: offers,
        linkTarget: "_blank"
    }), /*#__PURE__*/ React.createElement(Button, {
        caption: returnLabel,
        href: returnPath,
        variant: "outline",
        className: "reschedule-appointment-confirmation__button reschedule-appointment-confirmation__button--close"
    }));
};

const emptyArray = [];
const RescheduleAppointmentConfirmationContainer = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const { appointment , store , selectedTimeSlot , config: { googleMapsApiKey , opco , storesUrl , appointmentTypes , offerFallbackImageUrl  } ,  } = useRescheduleAppointmentContext();
    const [getStoreOfferByCode, storeOfferByCode] = useStoreOfferByCode({
        code: 0
    });
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [, { queryParams: { returnPath , returnLabel  } ,  }, ] = useRoutingContext$1();
    var ref6, ref1;
    const labels = React.useMemo(()=>{
        var ref5, ref4;
        return {
            title: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getFormattedLabel('appointments.page.reschedule.reservation.title', {
                labelData: {
                    name: (ref6 = appointment === null || appointment === void 0 ? void 0 : (ref5 = appointment.invitee) === null || ref5 === void 0 ? void 0 : ref5.firstName) !== null && ref6 !== void 0 ? ref6 : ''
                }
            }) : getFormattedLabel('appointments.page.reschedule.confirm.title', {
                labelData: {
                    name: (ref1 = appointment === null || appointment === void 0 ? void 0 : (ref4 = appointment.invitee) === null || ref4 === void 0 ? void 0 : ref4.firstName) !== null && ref1 !== void 0 ? ref1 : ''
                }
            }),
            subtitle: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getLabel('appointments.page.reschedule.reservation.subtitle') : getLabel('appointments.page.reschedule.confirm.subtitle'),
            confirmation: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getLabel('appointments.page.reschedule.reservation.confirmation') : getLabel('appointments.page.reschedule.confirm.confirmation'),
            additionalInformation: getLabel('appointments.page.reschedule.confirm.additionalInformation'),
            addToCalendar: getLabel('appointments.page.reschedule.confirm.addToCalendar'),
            where: getLabel('appointments.page.reschedule.confirm.where'),
            who: getLabel('appointments.page.reschedule.confirm.who'),
            cantMakeIt: getLabel('appointments.page.reschedule.confirm.cantMakeIt'),
            getDirections: getLabel('appointments.page.reschedule.confirm.getDirections'),
            returnLabel: getLabel('appointments.page.cancel.reschedule.closeButtonLabel.backHome'),
            confirmationEmailInstruction: getFormattedLabel('appointments.page.reschedule.confirm.confirmationEmailInstruction', {
                parseLink: true
            }),
            notification: (appointment === null || appointment === void 0 ? void 0 : appointment.preferredChannelOfCommunication) === AppointmentCommunicationChannel$1.EMAIL ? getLabel('appointments.page.cancel.confirm.notification.email') : getLabel('appointments.page.cancel.confirm.notification.sms')
        };
    }, [
        appointment,
        getLabel,
        getFormattedLabel
    ]);
    const directionsUrl = React.useMemo(()=>store ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([
            ...store.streetName.split(' '),
            store.town,
            opco
        ].join(' '))}` : undefined
    , [
        store,
        opco
    ]);
    const appointmentConfirmationContent = React.useMemo(()=>{
        const foundContent = appointmentTypes === null || appointmentTypes === void 0 ? void 0 : appointmentTypes.find((content)=>{
            var ref;
            return content.typeId === (appointment === null || appointment === void 0 ? void 0 : (ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id);
        });
        return foundContent === null || foundContent === void 0 ? void 0 : foundContent.appointmentConfirmationContent;
    }, [
        appointment,
        appointmentTypes
    ]);
    React.useEffect(()=>{
        if (!store) return;
        getStoreOfferByCode({
            variables: {
                code: Number(store.code)
            }
        });
    }, [
        getStoreOfferByCode,
        appointment,
        store
    ]);
    React.useEffect(()=>{
        if (appointment && store) {
            var ref, ref7;
            const dataLayerEvent = rescheduleAppointmentConfirmationScreenEvent({
                appointment: {
                    startTime: appointment.startTime,
                    endTime: appointment.endTime,
                    appointmentType: {
                        id: ((ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id) || '',
                        isChildAppointment: !!((ref7 = appointment.appointmentType) === null || ref7 === void 0 ? void 0 : ref7.isChildAppointment)
                    }
                },
                store
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        appointment,
        store
    ]);
    const appointmentType = React.useMemo(()=>{
        return !(appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType) ? undefined : {
            id: appointment.appointmentType.id,
            isChildAppointment: appointment.appointmentType.isChildAppointment
        };
    }, [
        appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType
    ]);
    const { pushAddToCalendarDlEvent  } = useAddToCalendarDlEventDispatcher({
        appointmentCondition: 'new',
        type: appointmentType,
        store,
        isVirtualAppointment: isVirtualAppointmentType(appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType),
        timeSlot: selectedTimeSlot
    });
    if (!appointment) {
        // TODO: add empty screen in scope of the ticket https://jira.grandvision.global/browse/GAAB-3886
        return null;
    }
    var _data, ref2, ref3;
    return /*#__PURE__*/ React.createElement(RescheduleAppointmentConfirmation, {
        labels: labels,
        appointment: appointment,
        store: store,
        offers: (_data = storeOfferByCode.data) !== null && _data !== void 0 ? _data : emptyArray,
        timeSlot: selectedTimeSlot,
        googleMapsApiKey: googleMapsApiKey,
        directionsUrl: directionsUrl,
        storesUrl: storesUrl,
        appointmentConfirmationContent: appointmentConfirmationContent,
        offerFallbackImageUrl: offerFallbackImageUrl,
        isVirtualAppointmentType: isVirtualAppointmentType(appointment.appointmentType),
        returnPath: (ref2 = fromArrayToString(returnPath)) !== null && ref2 !== void 0 ? ref2 : '/',
        returnLabel: (ref3 = fromArrayToString(returnLabel)) !== null && ref3 !== void 0 ? ref3 : labels.returnLabel,
        onICSButtonClick: pushAddToCalendarDlEvent
    });
};

const appointmentByToken$1 = gql`
  fragment Reschedule_AppointmentByToken on Appointment {
    id
    invitee {
      firstName
      lastName
    }
    child {
      firstName
      lastName
    }
    preferredChannelOfCommunication
    appointmentType {
      id
      name
      description
      isChildAppointment
    }
    startTime
    endTime
    store {
      code
    }
  }
`;
const GET_APPOINTMENT_BY_TOKEN$1 = gql`
  query RescheduleAppointment_GetAppointmentByToken($token: String!) {
    appointmentByToken(token: $token) {
      ...Reschedule_AppointmentByToken
    }
  }
  ${appointmentByToken$1}
`;

const appointmentById$1 = gql`
  fragment Reschedule_AppointmentById on Appointment {
    id
    invitee {
      firstName
      lastName
    }
    child {
      firstName
      lastName
    }
    preferredChannelOfCommunication
    appointmentType {
      id
      name
      description
      isChildAppointment
    }
    startTime
    endTime
    store {
      code
    }
  }
`;
const GET_APPOINTMENT_BY_ID$1 = gql`
  query RescheduleAppointment_GetAppointmentById($id: ID!) {
    appointment(id: $id) {
      ...Reschedule_AppointmentById
    }
  }
  ${appointmentById$1}
`;

const store$1 = gql`
  fragment Reschedule_StoreByCode on Store {
    town
    additionalStreetInfo
    streetNumber
    streetName
    name
    postalCode
    code
    slug
    province
    country
    lat
    lon
    phone
    email
  }
`;
const GET_STORE_BY_CODE$1 = gql`
  query RescheduleAppointment_GetStoreByCode($code: Int!) {
    store(code: $code) {
      ...Reschedule_StoreByCode
    }
  }
  ${store$1}
`;

const failures = gql`
  fragment FailureMessage on AppointmentFailure {
    message
  }
`;

const appointment$3 = gql`
  fragment RescheduleAppointmentByIdResult on Appointment {
    id
    startTime
    endTime
    preferredChannelOfCommunication
    customerComment
    invitee {
      firstName
      lastName
      email
      phone
    }
    child {
      firstName
      lastName
    }
    isReservation
    appointmentType {
      id
      name
      description
      isChildAppointment
    }
  }
`;
const RESCHEDULE_APPOINTMENT_BY_ID = gql`
  mutation RescheduleAppointmentById($id: ID!, $startTime: String!, $endTime: String!) {
    rescheduleAppointment(id: $id, startTime: $startTime, endTime: $endTime) {
      ... on RescheduleAppointmentResponse {
        appointment {
          ...RescheduleAppointmentByIdResult
        }
        failures {
          ...FailureMessage
        }
      }
    }
  }
  ${appointment$3}
  ${failures}
`;

const appointment$2 = gql`
  fragment RescheduleAppointmentByTokenResult on Appointment {
    id
    startTime
    endTime
    preferredChannelOfCommunication
    customerComment
    invitee {
      firstName
      lastName
      email
      phone
    }
    child {
      firstName
      lastName
    }
    isReservation
    appointmentType {
      id
      name
      description
      isChildAppointment
    }
  }
`;
const RESCHEDULE_APPOINTMENT_BY_TOKEN = gql`
  mutation RescheduleAppointmentByToken($token: String!, $startTime: String!, $endTime: String!) {
    rescheduleAppointmentByToken(token: $token, startTime: $startTime, endTime: $endTime) {
      ... on RescheduleAppointmentResponse {
        appointment {
          ...RescheduleAppointmentByTokenResult
        }
        failures {
          ...FailureMessage
        }
      }
    }
  }
  ${appointment$2}
  ${failures}
`;

const fromAppointmentQueryToAppointment$1 = (data)=>{
    if (!data) {
        return null;
    }
    const { id , invitee , appointmentType , startTime , endTime , store , child , preferredChannelOfCommunication ,  } = data;
    var _lastName, _lastName1;
    return {
        id,
        endTime: new Date(endTime),
        startTime: new Date(startTime),
        invitee: invitee ? {
            firstName: invitee.firstName,
            lastName: (_lastName = invitee.lastName) !== null && _lastName !== void 0 ? _lastName : undefined
        } : undefined,
        appointmentType: appointmentType ? {
            id: appointmentType.id,
            name: appointmentType.name,
            description: appointmentType.description,
            isChildAppointment: appointmentType.isChildAppointment
        } : undefined,
        store: store ? {
            code: store.code
        } : undefined,
        child: child ? {
            firstName: child.firstName,
            lastName: (_lastName1 = child.lastName) !== null && _lastName1 !== void 0 ? _lastName1 : undefined
        } : undefined,
        preferredChannelOfCommunication: preferredChannelOfCommunication !== null && preferredChannelOfCommunication !== void 0 ? preferredChannelOfCommunication : undefined
    };
};

const fromStoreQueryToStore$1 = (data)=>{
    if (!data) {
        return null;
    }
    const { town , streetName , name , postalCode , additionalStreetInfo , streetNumber , code , country , province , lat , lon , phone , email , slug ,  } = data;
    return {
        town,
        streetName,
        name,
        code,
        country,
        phone,
        postalCode: postalCode ? postalCode : undefined,
        additionalStreetInfo: additionalStreetInfo ? additionalStreetInfo : undefined,
        streetNumber: streetNumber ? streetNumber : undefined,
        province: province !== null && province !== void 0 ? province : undefined,
        lat: lat !== null && lat !== void 0 ? lat : undefined,
        lon: lon !== null && lon !== void 0 ? lon : undefined,
        email: email !== null && email !== void 0 ? email : undefined,
        slug: slug !== null && slug !== void 0 ? slug : undefined
    };
};

const isRescheduleAppointmentResponse = (data)=>typeof data === 'object' && data !== null && 'appointment' in data && 'failures' in data
;
const fromRescheduleAppointmentQueryToAppointment = (data)=>{
    if (!data || !isRescheduleAppointmentResponse(data)) {
        return {
            appointment: undefined,
            failures: undefined
        };
    }
    let appointment;
    if (data.__typename === 'RescheduleAppointmentResponse' && data.appointment) {
        const { id , invitee , appointmentType , startTime , endTime , child , preferredChannelOfCommunication , customerComment , isReservation ,  } = data.appointment;
        var _lastName, _phone, _email;
        const inviteeForAppointment = invitee ? {
            firstName: invitee.firstName,
            lastName: (_lastName = invitee.lastName) !== null && _lastName !== void 0 ? _lastName : undefined,
            phone: (_phone = invitee.phone) !== null && _phone !== void 0 ? _phone : undefined,
            email: (_email = invitee.email) !== null && _email !== void 0 ? _email : undefined
        } : undefined;
        const typeForAppointment = appointmentType ? {
            id: appointmentType.id,
            name: appointmentType.name,
            description: appointmentType.description,
            isChildAppointment: appointmentType.isChildAppointment
        } : undefined;
        var _lastName1;
        const childForAppointment = child ? {
            firstName: child.firstName,
            lastName: (_lastName1 = child.lastName) !== null && _lastName1 !== void 0 ? _lastName1 : undefined
        } : undefined;
        appointment = {
            id,
            isReservation: isReservation !== null && isReservation !== void 0 ? isReservation : undefined,
            endTime: new Date(endTime),
            startTime: new Date(startTime),
            invitee: inviteeForAppointment,
            appointmentType: typeForAppointment,
            child: childForAppointment,
            customerComment: customerComment !== null && customerComment !== void 0 ? customerComment : undefined,
            preferredChannelOfCommunication: preferredChannelOfCommunication !== null && preferredChannelOfCommunication !== void 0 ? preferredChannelOfCommunication : undefined
        };
    }
    const failures = data.__typename === 'RescheduleAppointmentResponse' ? data === null || data === void 0 ? void 0 : data.failures.map((failure)=>{
        return {
            type: failure.__typename,
            message: failure.message
        };
    }) : [];
    return {
        appointment,
        failures
    };
};

const useAppointmentById$1 = (variables, token = '')=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_APPOINTMENT_BY_ID$1, {
        variables,
        context: {
            fetchPolicy: 'no-cache',
            forwardHeaders: {
                'Accept-Language': locale,
                Authorization: `Bearer ${token}`
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.appointment) ? fromAppointmentQueryToAppointment$1(queryState.data.appointment) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useAppointmentByToken$1 = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_APPOINTMENT_BY_TOKEN$1, {
        variables,
        context: {
            fetchPolicy: 'no-cache',
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.appointmentByToken) ? fromAppointmentQueryToAppointment$1(queryState.data.appointmentByToken) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useStoreByCode$1 = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_BY_CODE$1, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store) ? fromStoreQueryToStore$1(queryState.data.store) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useRescheduleAppointmentById = (token = '')=>{
    const { locale  } = useIntl();
    const [query, queryState] = useMutation(RESCHEDULE_APPOINTMENT_BY_ID, {
        context: {
            fetchPolicy: 'no-cache',
            forwardHeaders: {
                'Accept-Language': locale,
                Authorization: `Bearer ${token}`
            },
            timeout: 60000
        },
        onError: (error)=>{
            console.error(`Error occurred while executing RESCHEDULE_APPOINTMENT_BY_ID mutation: `, error);
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return fromRescheduleAppointmentQueryToAppointment((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.rescheduleAppointment);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useRescheduleAppointmentByToken = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useMutation(RESCHEDULE_APPOINTMENT_BY_TOKEN, {
        context: {
            fetchPolicy: 'no-cache',
            forwardHeaders: {
                'Accept-Language': locale
            },
            timeout: 60000
        },
        onError: (error)=>{
            console.error(`Error occurred while executing RESCHEDULE_APPOINTMENT_BY_TOKEN mutation: `, error);
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return fromRescheduleAppointmentQueryToAppointment((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.rescheduleAppointmentByToken);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const RescheduleAppointmentRoot$1 = (_param)=>{
    var { className , labels , cancelAppointmentRoute , noTimeSlotsVariant , timeSlots , appointment , loading , returnPath , calendarLoading , calendarWeekCount , calendarWeekDate , calendarClosedDates , calendarAvailability , selectedDate , timeSlotsLoading , nextAvailableDate , noMoreAvailabilityUntilDate , selectedTimeSlot , hasError , buttonState , showOtherTimeSlots , otherTimeSlots , onCalendarWeeksChange , onSelectDate , onSelectTime , noTimeSlotsAction , onToggleOtherTimeSlots , onRescheduleButtonClick , onPreferredTimeClick , onPreferredTimeFilterClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "cancelAppointmentRoute",
        "noTimeSlotsVariant",
        "timeSlots",
        "appointment",
        "loading",
        "returnPath",
        "calendarLoading",
        "calendarWeekCount",
        "calendarWeekDate",
        "calendarClosedDates",
        "calendarAvailability",
        "selectedDate",
        "timeSlotsLoading",
        "nextAvailableDate",
        "noMoreAvailabilityUntilDate",
        "selectedTimeSlot",
        "hasError",
        "buttonState",
        "showOtherTimeSlots",
        "otherTimeSlots",
        "onCalendarWeeksChange",
        "onSelectDate",
        "onSelectTime",
        "noTimeSlotsAction",
        "onToggleOtherTimeSlots",
        "onRescheduleButtonClick",
        "onPreferredTimeClick",
        "onPreferredTimeFilterClick"
    ]);
    if (loading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "reschedule-appointment__loader"
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    if (!appointment) {
        return null;
    }
    const hasTimeSlots = timeSlots.length > 0;
    const hasOtherTimeSlots = otherTimeSlots.length > 0;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('reschedule-appointment', className)
    }), /*#__PURE__*/ React.createElement("section", {
        className: "reschedule-appointment__current-appointment"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "reschedule-appointment__section-title"
    }, labels.currentAppointment), /*#__PURE__*/ React.createElement(DateAndTimeContainer, {
        date: appointment.startTime,
        startTime: appointment.startTime,
        endTime: appointment.endTime,
        placeholder: labels.noAppointment
    })), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "reschedule-appointment__title"
    }, labels.title), /*#__PURE__*/ React.createElement(PreferredTimeContainer, {
        onPreferredTimeClick: onPreferredTimeClick,
        onPreferredTimeFilterClick: onPreferredTimeFilterClick,
        calendar: /*#__PURE__*/ React.createElement(AvailabilityCalendarContainer, {
            "aria-controls": "reschedule-appointment__timeslots",
            loading: calendarLoading,
            weekCount: calendarWeekCount,
            weekDate: calendarWeekDate,
            closedDates: calendarClosedDates,
            availability: calendarAvailability,
            selectedDate: selectedDate,
            onChangeWeeks: onCalendarWeeksChange,
            onSelectDate: onSelectDate
        })
    }), /*#__PURE__*/ React.createElement("section", {
        id: "reschedule-appointment__timeslots",
        "aria-live": "polite"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "reschedule-appointment__section-title"
    }, labels.selectATime), noTimeSlotsVariant === Variant.none ? /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading,
        slots: timeSlots,
        selected: selectedTimeSlot,
        onSelectTime: onSelectTime
    }) : /*#__PURE__*/ React.createElement(NoTimeSlotsContainer, {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    }), hasOtherTimeSlots && /*#__PURE__*/ React.createElement(React.Fragment, null, hasTimeSlots && /*#__PURE__*/ React.createElement(Button$1, {
        className: "reschedule-appointment__show-other-time-slots",
        variant: "ghost",
        onClick: onToggleOtherTimeSlots
    }, showOtherTimeSlots ? labels.hideOtherTimeSlots : labels.showOtherTimeSlots), showOtherTimeSlots && /*#__PURE__*/ React.createElement("div", {
        className: "reschedule-appointment__other-time-slots"
    }, /*#__PURE__*/ React.createElement(ScrollIntoView, null, !hasTimeSlots && /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "reschedule-appointment__section-title"
    }, labels.otherTimeSlots), /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading,
        slots: otherTimeSlots,
        onSelectTime: onSelectTime
    }))))), /*#__PURE__*/ React.createElement("section", null, /*#__PURE__*/ React.createElement("h4", {
        className: "reschedule-appointment__section-title"
    }, labels.selectedDateAndTime), /*#__PURE__*/ React.createElement(DateAndTimeContainer, {
        placeholder: labels.selectADateAndTime,
        date: selectedDate,
        startTime: selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.from,
        endTime: selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.until
    })), hasError && /*#__PURE__*/ React.createElement(Alert, {
        icon: "warning",
        type: "warning",
        message: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
            variant: "body-head"
        }, labels.errorTitle), labels.errorMessage && /*#__PURE__*/ React.createElement(Text, null, labels.errorMessage))
    }), /*#__PURE__*/ React.createElement("div", {
        className: "reschedule-appointment__cta"
    }, /*#__PURE__*/ React.createElement(Button$1, {
        variant: "solid",
        onClick: onRescheduleButtonClick,
        disabled: buttonState.disabled,
        loading: buttonState.loading
    }, labels.rescheduleAppointment), /*#__PURE__*/ React.createElement("div", {
        className: "reschedule-appointment__close-link"
    }, /*#__PURE__*/ React.createElement("a", {
        href: returnPath
    }, labels.close))), /*#__PURE__*/ React.createElement("footer", {
        className: "reschedule-appointment__footer"
    }, /*#__PURE__*/ React.createElement(Text, null, labels.cantFindSlot, " ", /*#__PURE__*/ React.createElement("a", {
        href: cancelAppointmentRoute
    }, labels.cancelYourAppointment))));
};

const INTERNAL_SERVER_ERROR_FAILURE = 'InternalServerErrorFailure';
const RescheduleAppointmentRootContainer = ({ cancelAppointmentUrl , userToken , appointmentId , token ,  })=>{
    const { getLabel  } = useIntl();
    const { featureConfigs  } = useFeatureToggles();
    const { appointment: currentAppointment , setAppointment: setCurrentAppointment , store , setStore , selectedTimeSlot , setSelectedTimeSlot ,  } = useRescheduleAppointmentContext();
    const [failure, setFailure] = React.useState('');
    const [{ goTo  }, { queryParams  }] = useRoutingContext$1();
    const appointmentBookingAvailabiltyCalendarWeekCount = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.appointmentBookingAvailabiltyCalendarWeekCount;
    const [getStoreOpeningTimes, storeOpeningTimes] = useStoreOpeningTimes();
    const [getCalendarAvailability, calendarAvailability] = useCalendarAvailability();
    const [{ getAvailabilityTimeFilters  }, { activeFilters: activeTimeFilters  }, ] = useActiveTimeFilters();
    const today = React.useRef(new Date());
    const [weekDate, setWeekDate] = React.useState();
    const [weeks1, setWeeks] = React.useState();
    const [date1, setDate] = React.useState();
    const [availabilityRequestParamsChanged, setAvailabilityRequestParamsChanged] = React.useState(true);
    const [showOtherTimeSlots, setShowOtherTimeSlots] = React.useState(false);
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.page.reschedule.title'),
            currentAppointment: getLabel('appointments.page.reschedule.currentAppointment'),
            noAppointment: getLabel('appointments.page.reschedule.noAppointment'),
            selectADateAndTime: getLabel('appointments.page.reschedule.selectADateAndTime'),
            selectATime: getLabel('appointments.page.reschedule.selectATime'),
            selectedDateAndTime: getLabel('appointments.page.reschedule.selectedDateAndTime'),
            showOtherTimeSlots: getLabel('appointments.page.reschedule.showOtherTimeSlots'),
            hideOtherTimeSlots: getLabel('appointments.page.reschedule.hideOtherTimeSlots'),
            otherTimeSlots: getLabel('appointments.page.reschedule.otherTimeSlots'),
            rescheduleAppointment: getLabel('appointments.page.reschedule.rescheduleAppointment'),
            close: getLabel('appointments.page.reschedule.close'),
            cantFindSlot: getLabel('appointments.page.reschedule.cantFindSlot'),
            cancelYourAppointment: getLabel('appointments.page.reschedule.cancelYourAppointment'),
            errorTitle: getLabel('appointments.page.reschedule.errorTitle'),
            errorMessage: getLabel(`appointments.page.reschedule.error.${failure}`, {
                hideLabelKey: true
            })
        })
    , [
        getLabel,
        failure
    ]);
    const closedDates = React.useMemo(()=>{
        if (!weeks1 || !storeOpeningTimes.data) {
            return [];
        }
        return getClosedDates(weeks1, storeOpeningTimes.data);
    }, [
        weeks1,
        storeOpeningTimes.data
    ]);
    const [getCurrentAppointmentById, currentAppointmentById] = useAppointmentById$1({
        id: appointmentId !== null && appointmentId !== void 0 ? appointmentId : ''
    }, userToken);
    const [getCurrentAppointmentByToken, currentAppointmentByToken] = useAppointmentByToken$1({
        token: token !== null && token !== void 0 ? token : ''
    });
    const [getTimeSlots, timeSlots] = useTimeSlots({
        timeFilters: activeTimeFilters
    });
    const [rescheduleAppointmentById, rescheduledAppointmentById] = useRescheduleAppointmentById(userToken !== null && userToken !== void 0 ? userToken : '');
    const [rescheduleAppointmentByToken, rescheduledAppointmentByToken, ] = useRescheduleAppointmentByToken();
    const [getStoreByCode, storeByCode] = useStoreByCode$1({
        code: 0
    });
    const nextAvailableDate = useNextAvailableDate(date1, calendarAvailability, !timeSlots.called);
    const nextWeekDate = useNextWeekDate(weeks1, !date1 || Boolean(nextAvailableDate));
    const noTimeSlotsVariant = useNoTimeSlotsVariant(timeSlots, nextAvailableDate, date1, closedDates);
    const onCalendarWeeksChange = React.useCallback((weeks)=>{
        setAvailabilityRequestParamsChanged(true);
        setWeeks(weeks);
    }, []);
    const onSelectDate = React.useCallback((date)=>{
        setDate(date);
    }, []);
    const onSelectTime = React.useCallback((slot)=>{
        setSelectedTimeSlot(slot);
    }, [
        setSelectedTimeSlot
    ]);
    const noTimeSlotsAction = React.useCallback(()=>{
        switch(noTimeSlotsVariant){
            case Variant.date:
            case Variant.closedDate:
                /* istanbul ignore if */ if (!nextAvailableDate) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                setDate(nextAvailableDate);
                break;
            case Variant.week:
            case Variant.closedWeek:
                /* istanbul ignore if */ if (!nextWeekDate) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                setWeekDate(nextWeekDate);
                setDate(nextWeekDate);
                break;
            case Variant.error:
                var ref, ref1;
                var ref2;
                const storeCode = (ref2 = currentAppointment === null || currentAppointment === void 0 ? void 0 : (ref = currentAppointment.store) === null || ref === void 0 ? void 0 : ref.code) !== null && ref2 !== void 0 ? ref2 : undefined;
                var ref3;
                const appointmentTypeId = (ref3 = currentAppointment === null || currentAppointment === void 0 ? void 0 : (ref1 = currentAppointment.appointmentType) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref3 !== void 0 ? ref3 : undefined;
                /* istanbul ignore if */ if (!date1 || storeCode === undefined || appointmentTypeId === undefined) {
                    // This should never happen, but it's here to satisfy typescript
                    return;
                }
                getTimeSlots({
                    variables: {
                        storeCode,
                        appointmentTypeId,
                        date: DateUtils.toLocalDate(date1)
                    }
                });
            case Variant.none:
                return;
        }
    }, [
        noTimeSlotsVariant,
        nextAvailableDate,
        nextWeekDate,
        getTimeSlots,
        date1,
        currentAppointment
    ]);
    React.useEffect(()=>{
        if (currentAppointment && store) {
            var ref, ref5;
            const dataLayerEvent = rescheduleAppointmentScreenEvent({
                appointment: {
                    startTime: currentAppointment.startTime,
                    endTime: currentAppointment.endTime,
                    appointmentType: {
                        id: ((ref = currentAppointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id) || '',
                        isChildAppointment: !!((ref5 = currentAppointment.appointmentType) === null || ref5 === void 0 ? void 0 : ref5.isChildAppointment)
                    }
                },
                store
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        currentAppointment,
        store
    ]);
    React.useEffect(()=>{
        if (appointmentId) {
            getCurrentAppointmentById({
                variables: {
                    id: appointmentId
                }
            });
        }
    }, [
        appointmentId,
        getCurrentAppointmentById
    ]);
    React.useEffect(()=>{
        if (token) {
            getCurrentAppointmentByToken({
                variables: {
                    token
                }
            });
        }
    }, [
        token,
        getCurrentAppointmentByToken
    ]);
    React.useEffect(()=>{
        if (!currentAppointmentById.data) {
            return;
        }
        setCurrentAppointment(currentAppointmentById.data);
    }, [
        setCurrentAppointment,
        currentAppointmentById.data
    ]);
    React.useEffect(()=>{
        if (!currentAppointmentByToken.data) {
            return;
        }
        setCurrentAppointment(currentAppointmentByToken.data);
    }, [
        setCurrentAppointment,
        currentAppointmentByToken.data
    ]);
    React.useEffect(()=>{
        const INTERNAL_SERVER_ERROR_STATUS = 'INTERNAL_SERVER_ERROR';
        if (currentAppointmentById.error) {
            var ref, ref6, ref7;
            var ref8;
            throw new Error((ref8 = (ref = currentAppointmentById.error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref6 = ref[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.extensions) === null || ref7 === void 0 ? void 0 : ref7.code) !== null && ref8 !== void 0 ? ref8 : INTERNAL_SERVER_ERROR_STATUS);
        }
        if (currentAppointmentByToken.error) {
            var ref9, ref10, ref11, ref12;
            var ref13;
            throw new Error((ref13 = (ref9 = currentAppointmentByToken.error) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.graphQLErrors) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.extensions) === null || ref12 === void 0 ? void 0 : ref12.code) !== null && ref13 !== void 0 ? ref13 : INTERNAL_SERVER_ERROR_STATUS);
        }
    }, [
        currentAppointmentById.error,
        currentAppointmentByToken.error
    ]);
    React.useEffect(()=>{
        var ref;
        const storeCode = currentAppointment === null || currentAppointment === void 0 ? void 0 : (ref = currentAppointment.store) === null || ref === void 0 ? void 0 : ref.code;
        if (storeCode) {
            getStoreByCode({
                variables: {
                    code: +storeCode
                }
            });
        }
    }, [
        getStoreByCode,
        currentAppointment
    ]);
    React.useEffect(()=>{
        if (!storeByCode.data) {
            return;
        }
        setStore(storeByCode.data);
    }, [
        setStore,
        storeByCode.data
    ]);
    React.useEffect(()=>{
        if (!store) {
            return;
        }
        getStoreOpeningTimes({
            variables: {
                code: store.code
            }
        });
    }, [
        getStoreOpeningTimes,
        store
    ]);
    React.useEffect(()=>setAvailabilityRequestParamsChanged(true)
    , [
        currentAppointment
    ]);
    useDebouncedEffect(()=>{
        var ref, ref14;
        const appointmentTypeId = currentAppointment === null || currentAppointment === void 0 ? void 0 : (ref = currentAppointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id;
        const storeCode = currentAppointment === null || currentAppointment === void 0 ? void 0 : (ref14 = currentAppointment.store) === null || ref14 === void 0 ? void 0 : ref14.code;
        if (!appointmentTypeId || !storeCode || !weeks1) {
            /* istanbul ignore else */ if (process.env.NODE_ENV === 'test') {
                console.log('Awaiting availability request variables data');
            }
            return;
        }
        const [[firstWeekDay]] = weeks1.slice(0);
        const [lastWeek] = weeks1.slice(-1);
        const [lastWeekDay] = lastWeek.slice(-1);
        getCalendarAvailability(swcHelpers.objectSpread({
            appointmentTypeId,
            storeCode: storeCode.toString(),
            startDate: firstWeekDay,
            endDate: lastWeekDay
        }, getAvailabilityTimeFilters()));
        setAvailabilityRequestParamsChanged(false);
    }, 400, [
        getCalendarAvailability,
        currentAppointment,
        weeks1,
        getAvailabilityTimeFilters
    ]);
    React.useEffect(()=>{
        const dateIsAlreadySelected = Boolean(date1);
        const waitingForAvailability = !calendarAvailability.called || calendarAvailability.loading;
        if (dateIsAlreadySelected || !weeks1 || waitingForAvailability) {
            return;
        }
        const availableDate = firstAvailableDate(weeks1, calendarAvailability.data);
        const fallbackDate = today.current;
        setDate(availableDate !== null && availableDate !== void 0 ? availableDate : fallbackDate);
    }, [
        date1,
        weeks1,
        calendarAvailability
    ]);
    React.useEffect(()=>{
        calendarAvailability.error && console.error('Error fetching appointment reschedule availabilty:', calendarAvailability.error.message);
    }, [
        calendarAvailability.error
    ]);
    React.useEffect(()=>{
        var ref, ref15;
        var ref16;
        const storeCode = (ref16 = currentAppointment === null || currentAppointment === void 0 ? void 0 : (ref = currentAppointment.store) === null || ref === void 0 ? void 0 : ref.code) !== null && ref16 !== void 0 ? ref16 : undefined;
        var ref17;
        const appointmentTypeId = (ref17 = currentAppointment === null || currentAppointment === void 0 ? void 0 : (ref15 = currentAppointment.appointmentType) === null || ref15 === void 0 ? void 0 : ref15.id) !== null && ref17 !== void 0 ? ref17 : undefined;
        if (!date1 || storeCode === undefined || appointmentTypeId === undefined) {
            return;
        }
        getTimeSlots({
            variables: {
                storeCode,
                appointmentTypeId,
                date: DateUtils.toLocalDate(date1)
            }
        });
    }, [
        currentAppointment,
        getTimeSlots,
        date1
    ]);
    React.useEffect(()=>setSelectedTimeSlot(undefined)
    , [
        setSelectedTimeSlot,
        date1
    ]);
    const onRescheduleButtonClick = React.useCallback(()=>{
        setFailure('');
        if (appointmentId && selectedTimeSlot) {
            rescheduleAppointmentById({
                variables: {
                    id: appointmentId,
                    startTime: DateUtils.toLocalDateTime(selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.from),
                    endTime: DateUtils.toLocalDateTime(selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.until)
                }
            });
        }
        if (token && selectedTimeSlot) {
            rescheduleAppointmentByToken({
                variables: {
                    token,
                    startTime: DateUtils.toLocalDateTime(selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.from),
                    endTime: DateUtils.toLocalDateTime(selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.until)
                }
            });
        }
    }, [
        appointmentId,
        token,
        selectedTimeSlot,
        rescheduleAppointmentById,
        rescheduleAppointmentByToken, 
    ]);
    const onToggleOtherTimeSlots = React.useCallback(()=>setShowOtherTimeSlots((curr)=>!curr
        )
    , []);
    React.useEffect(()=>{
        var ref;
        if (!((ref = rescheduledAppointmentById.data) === null || ref === void 0 ? void 0 : ref.appointment)) {
            return;
        }
        setCurrentAppointment(rescheduledAppointmentById.data.appointment);
        goTo('confirmation', queryParams);
    }, [
        rescheduledAppointmentById.data,
        queryParams,
        setCurrentAppointment,
        goTo
    ]);
    React.useEffect(()=>{
        var ref;
        if (!((ref = rescheduledAppointmentByToken.data) === null || ref === void 0 ? void 0 : ref.appointment)) {
            return;
        }
        setCurrentAppointment(rescheduledAppointmentByToken.data.appointment);
        goTo('confirmation', queryParams);
    }, [
        rescheduledAppointmentByToken.data,
        queryParams,
        setCurrentAppointment,
        goTo
    ]);
    React.useEffect(()=>{
        var ref, ref18;
        var _error;
        const error = (_error = rescheduledAppointmentById.error) !== null && _error !== void 0 ? _error : rescheduledAppointmentByToken.error;
        if (error) {
            setFailure(INTERNAL_SERVER_ERROR_FAILURE);
        }
        var ref19;
        const failures = (ref19 = (ref = rescheduledAppointmentById.data) === null || ref === void 0 ? void 0 : ref.failures) !== null && ref19 !== void 0 ? ref19 : (ref18 = rescheduledAppointmentByToken.data) === null || ref18 === void 0 ? void 0 : ref18.failures;
        if (failures && (failures === null || failures === void 0 ? void 0 : failures.length) > 0 && failures[0].type) {
            setFailure(failures[0].type);
        }
    }, [
        rescheduledAppointmentById,
        rescheduledAppointmentByToken
    ]);
    const buttonState = React.useMemo(()=>({
            disabled: !selectedTimeSlot || !!failure && failure !== INTERNAL_SERVER_ERROR_FAILURE,
            loading: rescheduledAppointmentById.loading
        })
    , [
        selectedTimeSlot,
        failure,
        rescheduledAppointmentById.loading
    ]);
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const { onPreferredTimeClick , onPreferredTimeFilterClick ,  } = usePreferredTimeDataLayerEventDispatchers({
        appointmentCondition: 'reschedule',
        isVirtualAppointment: isVirtualAppointmentType(currentAppointment === null || currentAppointment === void 0 ? void 0 : currentAppointment.appointmentType),
        type: currentAppointment === null || currentAppointment === void 0 ? void 0 : currentAppointment.appointmentType,
        store,
        timeSlot: selectedTimeSlot
    });
    var ref4;
    return /*#__PURE__*/ React.createElement(RescheduleAppointmentRoot$1, {
        labels: labels,
        returnPath: (ref4 = fromArrayToString(queryParams.returnPath)) !== null && ref4 !== void 0 ? ref4 : '/',
        cancelAppointmentRoute: cancelAppointmentUrl,
        appointment: currentAppointment !== null && currentAppointment !== void 0 ? currentAppointment : undefined,
        loading: currentAppointmentById.loading || currentAppointmentByToken.loading,
        calendarLoading: availabilityRequestParamsChanged || storeOpeningTimes.loading || calendarAvailability.loading,
        calendarWeekDate: weekDate,
        calendarClosedDates: closedDates,
        calendarAvailability: calendarAvailability.data,
        calendarWeekCount: appointmentBookingAvailabiltyCalendarWeekCount,
        onCalendarWeeksChange: onCalendarWeeksChange,
        selectedDate: date1,
        onSelectDate: onSelectDate,
        timeSlotsLoading: !timeSlots.called || timeSlots.loading,
        timeSlots: timeSlots.filtered.included,
        selectedTimeSlot: selectedTimeSlot,
        onSelectTime: onSelectTime,
        noTimeSlotsVariant: noTimeSlotsVariant,
        noTimeSlotsAction: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noMoreAvailabilityUntilDate: nextWeekDate,
        onRescheduleButtonClick: onRescheduleButtonClick,
        hasError: !!failure,
        buttonState: buttonState,
        showOtherTimeSlots: showOtherTimeSlots,
        onToggleOtherTimeSlots: onToggleOtherTimeSlots,
        otherTimeSlots: timeSlots.filtered.excluded,
        onPreferredTimeClick: onPreferredTimeClick,
        onPreferredTimeFilterClick: onPreferredTimeFilterClick
    });
};

const withUserToken = (Component)=>{
    const displayName = Component.displayName || Component.name || 'Component';
    const WithUserToken = (props)=>{
        const [userToken, setUserToken] = React.useState();
        const [loading, setLoading] = React.useState(true);
        React.useEffect(()=>{
            getToken().then((token)=>{
                setUserToken(token);
                setLoading(false);
            }).catch((error)=>{
                console.error(error);
                setLoading(false);
            });
        }, []);
        if (loading) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "with-user-token__loader-wrapper"
            }, /*#__PURE__*/ React.createElement(Loader, null));
        }
        if (!userToken) {
            throw new Error('JWT_TOKEN_NOT_FOUND');
        }
        return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props, {
            userToken: userToken
        }));
    };
    WithUserToken.displayName = `WithUserToken(${displayName})`;
    return WithUserToken;
};

const RescheduleAppointmentRootWithUserToken = withUserToken(RescheduleAppointmentRootContainer);
const RescheduleAppointmentRootWithUserData = WithUserData(RescheduleAppointmentRootWithUserToken);
const RescheduleAppointmentRootWithMyAccountEnabled = (_param)=> {
    var props = swcHelpers.extends({}, _param);
    return React.createElement(RescheduleAppointmentRootWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: true
    }));
};

const RescheduleAppointmentRoot = ()=>{
    const { config: { appointmentId , token , cancelAppointmentUrl , bookAppointmentUrl  } ,  } = useRescheduleAppointmentContext();
    const props = {
        cancelAppointmentUrl
    };
    if (appointmentId) {
        return /*#__PURE__*/ React.createElement(RescheduleAppointmentRootWithMyAccountEnabled, swcHelpers.extends({}, props, {
            appointmentId: appointmentId
        }));
    }
    if (token) {
        return /*#__PURE__*/ React.createElement(RescheduleAppointmentRootContainer, swcHelpers.extends({}, props, {
            token: token
        }));
    }
    return /*#__PURE__*/ React.createElement(AppointmentErrorContainer, {
        status: appointmentErrors[0],
        bookAppointmentUrl: bookAppointmentUrl
    });
};

const routeMap$1 = {
    '': RescheduleAppointmentRoot,
    confirmation: RescheduleAppointmentConfirmationContainer
};

var RoutingError;
(function(RoutingError) {
    RoutingError["INVALID_ROUTE"] = "INVALID_ROUTE";
    RoutingError["SERVER_SIDE_CONFIRMATION_ATTEMPT"] = "SERVER_SIDE_CONFIRMATION_ATTEMPT";
})(RoutingError || (RoutingError = {}));
const routingErrorHandler = (errorMessage, selfUrl, asPath, currentRoute, queryParams, publicRuntimeConfig)=>{
    const { myAccount  } = getRuntimeFeatureValues(publicRuntimeConfig);
    switch(errorMessage){
        case RoutingError.INVALID_ROUTE:
            return {
                type: 'redirect',
                url: replaceCurrentRoute(selfUrl, asPath, currentRoute, '', queryParams)
            };
        case RoutingError.SERVER_SIDE_CONFIRMATION_ATTEMPT:
            const redirectUrl = myAccount ? `${selfUrl}/my-account/profile` : `${selfUrl}/`;
            return {
                type: 'redirect',
                url: redirectUrl
            };
        default:
            return {
                type: 'not-found'
            };
    }
};

const appointmentContextDefaultValues = {
    config: {
        bookAppointmentUrl: ''
    },
    store: undefined,
    appointment: undefined,
    setStore: ()=>null
    ,
    setAppointment: ()=>null
};
const CancelAppointmentContext = /*#__PURE__*/ React.createContext(appointmentContextDefaultValues);
const useCancelAppointmentContext = ()=>{
    const context = React.useContext(CancelAppointmentContext);
    if (context === appointmentContextDefaultValues) {
        throw new Error('No CancelAppointmentContext available. You might still need to wrap the application with the CancelAppointmentProvider component.');
    }
    return context;
};
CancelAppointmentContext.displayName = 'CancelAppointment';
CancelAppointmentContext.Consumer;

var CancelAppointmentProvider = (_param)=>{
    var { children  } = _param, config = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    const [appointment, setAppointment] = React.useState(undefined);
    const [store, setStore] = React.useState(undefined);
    const values = React.useMemo(()=>({
            config,
            store,
            appointment,
            setAppointment,
            setStore
        })
    , [
        appointment,
        store,
        config,
        setStore,
        setAppointment
    ]);
    return /*#__PURE__*/ React.createElement(CancelAppointmentContext.Provider, {
        value: values
    }, children);
};

const defaultRoutingContextValue = [
    {
        goTo: ()=>null
    },
    {
        component: undefined,
        queryParams: {},
        currentRoute: '',
        basePath: ''
    }, 
];
const RoutingContext = /*#__PURE__*/ React.createContext(defaultRoutingContextValue);
const useRoutingContext = ()=>React.useContext(RoutingContext)
;

const RoutingContextProvider = ({ routeMap , initialRoutingState , initialState , children ,  })=>{
    const { Provider  } = RoutingContext;
    const { basePath , currentRoute: initialRoute , queryParams: initialQueryParams ,  } = initialRoutingState;
    const [{ goTo  }, { queryParams: queryParams1 , currentRoute  }] = useClientSideRouter({
        basePath,
        initialRoute,
        initialQueryParams
    });
    const goToHandler = React.useCallback((route, queryParams)=>{
        const newQueryParams = swcHelpers.objectSpread({}, queryParams);
        Object.keys(newQueryParams).forEach((key)=>newQueryParams[key] === undefined ? delete newQueryParams[key] : {}
        );
        goTo(`${basePath}/${route}${QueryString.toQueryParams(newQueryParams)}`);
    }, [
        basePath,
        goTo
    ]);
    const value = React.useMemo(()=>[
            {
                goTo: goToHandler
            },
            {
                component: routeMap[currentRoute],
                queryParams: queryParams1,
                currentRoute,
                basePath
            }, 
        ]
    , [
        routeMap,
        goToHandler,
        currentRoute,
        basePath,
        queryParams1
    ]);
    const Component = routeMap[currentRoute];
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, /*#__PURE__*/ React.createElement(CancelAppointmentProvider, swcHelpers.extends({}, initialState), /*#__PURE__*/ React.createElement(ErrorBoundary, {
        bookAppointmentUrl: initialState.bookAppointmentUrl
    }, /*#__PURE__*/ React.createElement(Component, null))), children);
};
RoutingContextProvider.getServerSideProps = (currentRoute, routeMap /* locale */ )=>{
    const isValidRoute = currentRoute in routeMap;
    if (!isValidRoute) {
        throw new Error(RoutingError.INVALID_ROUTE);
    }
    if (currentRoute === 'confirmation') {
        throw new Error(RoutingError.SERVER_SIDE_CONFIRMATION_ATTEMPT);
    }
};

var AppointmentCommunicationChannel;
(function(AppointmentCommunicationChannel) {
    AppointmentCommunicationChannel["EMAIL"] = "EMAIL";
    AppointmentCommunicationChannel["SMS"] = "SMS";
})(AppointmentCommunicationChannel || (AppointmentCommunicationChannel = {}));

const CancelAppointmentConfirmation = (_param)=> {
    var { appointment , store , labels , returnPath , returnLabel , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointment",
        "store",
        "labels",
        "returnPath",
        "returnLabel",
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('cancel-appointment-confirmation', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "small",
        className: "cancel-appointment-confirmation__title"
    }, labels.title), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(Alert, {
        icon: "checkmark-circle",
        type: "success",
        message: /*#__PURE__*/ React.createElement("b", null, labels.notification),
        className: "cancel-appointment-confirmation__alert"
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: ""
    }, labels.subtitle), /*#__PURE__*/ React.createElement(AppointmentOverviewContainer, {
        className: "cancel-appointment-confirmation__overview",
        appointment: appointment,
        store: store,
        isStoreLoading: false
    }), /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        className: "cancel-appointment-confirmation__button",
        caption: returnLabel,
        href: returnPath
    }));
};

const CancelAppointmentConfirmationContainer = ()=>{
    const { appointment , store  } = useCancelAppointmentContext();
    const { getLabel , getFormattedLabel  } = useIntl();
    const [, { queryParams: { returnPath , returnLabel  } ,  }, ] = useRoutingContext();
    var ref5;
    const labels = React.useMemo(()=>{
        var ref3;
        return {
            title: getFormattedLabel('appointments.page.cancel.confirm.title', {
                labelData: {
                    name: (ref5 = appointment === null || appointment === void 0 ? void 0 : (ref3 = appointment.invitee) === null || ref3 === void 0 ? void 0 : ref3.firstName) !== null && ref5 !== void 0 ? ref5 : ''
                }
            }),
            subtitle: getLabel('appointments.page.cancel.confirm.subtitle'),
            notification: (appointment === null || appointment === void 0 ? void 0 : appointment.preferredChannelOfCommunication) === AppointmentCommunicationChannel.EMAIL ? getLabel(`appointments.page.cancel.confirm.notification.email`) : getLabel('appointments.page.cancel.confirm.notification.sms'),
            returnLabel: getLabel('appointments.page.cancel.confirm.closeButtonLabel.backHome')
        };
    }, [
        appointment,
        getLabel,
        getFormattedLabel
    ]);
    React.useEffect(()=>{
        if (appointment && store) {
            var ref, ref4;
            const dataLayerEvent = cancelAppointmentConfirmationScreenEvent({
                appointment: {
                    startTime: appointment.startTime,
                    endTime: appointment.endTime,
                    appointmentType: {
                        id: ((ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id) || '',
                        isChildAppointment: !!((ref4 = appointment.appointmentType) === null || ref4 === void 0 ? void 0 : ref4.isChildAppointment)
                    }
                },
                store
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        appointment,
        store
    ]);
    if (!appointment) {
        // TODO: add empty screen in scope of the ticket https://jira.grandvision.global/browse/GAAB-3886
        return null;
    }
    var ref1, ref2;
    return /*#__PURE__*/ React.createElement(CancelAppointmentConfirmation, {
        labels: labels,
        appointment: appointment,
        store: store,
        returnLabel: (ref1 = fromArrayToString(returnLabel)) !== null && ref1 !== void 0 ? ref1 : labels.returnLabel,
        returnPath: (ref2 = fromArrayToString(returnPath)) !== null && ref2 !== void 0 ? ref2 : '/'
    });
};

const appointment$1 = gql`
  fragment CancelAppointmentByTokenResult on Appointment {
    status
    id
    invitee {
      firstName
      lastName
    }
    child {
      firstName
      lastName
    }
    appointmentType {
      id
      name
      isChildAppointment
    }
    startTime
    endTime
    store {
      code
    }
    preferredChannelOfCommunication
  }
`;
const CANCEL_APPOINTMENT_BY_TOKEN = gql`
  mutation CancelAppointmentByToken($token: String!, $cancellationReason: String) {
    cancelAppointmentByToken(token: $token, cancellationReason: $cancellationReason) {
      ...CancelAppointmentByTokenResult
    }
  }
  ${appointment$1}
`;

const appointment = gql`
  fragment CancelAppointmentByIdResult on Appointment {
    status
    id
    invitee {
      firstName
      lastName
    }
    child {
      firstName
      lastName
    }
    appointmentType {
      id
      name
      isChildAppointment
    }
    startTime
    endTime
    store {
      code
    }
    preferredChannelOfCommunication
  }
`;
const CANCEL_APPOINTMENT_BY_ID = gql`
  mutation CancelAppointmentById($id: ID!, $cancellationReason: String) {
    cancelAppointment(id: $id, cancellationReason: $cancellationReason) {
      ...CancelAppointmentByIdResult
    }
  }
  ${appointment}
`;

const appointmentById = gql`
  fragment AppointmentById on Appointment {
    id
    invitee {
      firstName
      lastName
    }
    child {
      firstName
      lastName
    }
    preferredChannelOfCommunication
    appointmentType {
      id
      name
      isChildAppointment
    }
    startTime
    endTime
    store {
      code
    }
  }
`;
const GET_APPOINTMENT_BY_ID = gql`
  query CancelAppointment_GetAppointmentById($id: ID!) {
    appointment(id: $id) {
      ...AppointmentById
    }
  }
  ${appointmentById}
`;

const appointmentByToken = gql`
  fragment AppointmentByToken on Appointment {
    id
    invitee {
      firstName
      lastName
    }
    child {
      firstName
      lastName
    }
    preferredChannelOfCommunication
    appointmentType {
      id
      name
      isChildAppointment
    }
    startTime
    endTime
    store {
      code
    }
  }
`;
const GET_APPOINTMENT_BY_TOKEN = gql`
  query CancelAppointment_GetAppointmentByToken($token: String!) {
    appointmentByToken(token: $token) {
      ...AppointmentByToken
    }
  }
  ${appointmentByToken}
`;

const store = gql`
  fragment CancelAppointment_StoreByCode on Store {
    town
    additionalStreetInfo
    streetNumber
    streetName
    name
    postalCode
    code
  }
`;
const GET_STORE_BY_CODE = gql`
  query CancelAppointment_GetStoreByCode($code: Int!) {
    store(code: $code) {
      ...CancelAppointment_StoreByCode
    }
  }
  ${store}
`;

const fromAppointmentQueryToAppointment = (data)=>{
    if (!data) {
        return null;
    }
    const { id , invitee , appointmentType , startTime , endTime , store , child , preferredChannelOfCommunication ,  } = data;
    var _lastName, _lastName1;
    return {
        id,
        endTime: new Date(endTime),
        startTime: new Date(startTime),
        invitee: invitee ? {
            firstName: invitee.firstName,
            lastName: (_lastName = invitee.lastName) !== null && _lastName !== void 0 ? _lastName : undefined
        } : undefined,
        appointmentType: appointmentType ? {
            id: appointmentType.id,
            name: appointmentType.name,
            isChildAppointment: appointmentType.isChildAppointment
        } : undefined,
        store: store ? {
            code: store.code
        } : undefined,
        child: child ? {
            firstName: child.firstName,
            lastName: (_lastName1 = child.lastName) !== null && _lastName1 !== void 0 ? _lastName1 : undefined
        } : undefined,
        preferredChannelOfCommunication: preferredChannelOfCommunication !== null && preferredChannelOfCommunication !== void 0 ? preferredChannelOfCommunication : undefined
    };
};

const fromStoreQueryToStore = (data)=>{
    if (!data) {
        return null;
    }
    const { town , streetName , name , postalCode , additionalStreetInfo , streetNumber , code  } = data;
    return {
        town,
        streetName,
        name,
        code,
        postalCode: postalCode ? postalCode : undefined,
        additionalStreetInfo: additionalStreetInfo ? additionalStreetInfo : undefined,
        streetNumber: streetNumber ? streetNumber : undefined
    };
};

const fromCancelAppointmentQueryToAppointment = (data)=>{
    if (!data) {
        return null;
    }
    const { id , invitee , appointmentType , startTime , endTime , store , child , preferredChannelOfCommunication ,  } = data;
    var _lastName, _lastName1;
    return {
        id,
        endTime: new Date(endTime),
        startTime: new Date(startTime),
        invitee: invitee ? {
            firstName: invitee.firstName,
            lastName: (_lastName = invitee.lastName) !== null && _lastName !== void 0 ? _lastName : undefined
        } : undefined,
        appointmentType: appointmentType ? {
            id: appointmentType.id,
            name: appointmentType.name,
            isChildAppointment: appointmentType.isChildAppointment
        } : undefined,
        store: store ? {
            code: store.code
        } : undefined,
        child: child ? {
            firstName: child.firstName,
            lastName: (_lastName1 = child.lastName) !== null && _lastName1 !== void 0 ? _lastName1 : undefined
        } : undefined,
        preferredChannelOfCommunication: preferredChannelOfCommunication !== null && preferredChannelOfCommunication !== void 0 ? preferredChannelOfCommunication : undefined
    };
};

const useAppointmentById = (variables, token = '')=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_APPOINTMENT_BY_ID, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale,
                Authorization: `Bearer ${token}`
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.appointment) ? fromAppointmentQueryToAppointment(queryState.data.appointment) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useAppointmentByToken = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_APPOINTMENT_BY_TOKEN, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.appointmentByToken) ? fromAppointmentQueryToAppointment(queryState.data.appointmentByToken) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useCancelAppointmentById = (token = '')=>{
    const { locale  } = useIntl();
    const [query, queryState] = useMutation(CANCEL_APPOINTMENT_BY_ID, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale,
                Authorization: `Bearer ${token}`
            },
            timeout: 30000
        },
        onError: (error)=>{
            console.error(`Error occurred while executing CANCEL_APPOINTMENT_BY_ID mutation: `, error);
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.cancelAppointment) ? fromCancelAppointmentQueryToAppointment(queryState.data.cancelAppointment) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useCancelAppointmentByToken = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useMutation(CANCEL_APPOINTMENT_BY_TOKEN, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            },
            timeout: 30000
        },
        onError: (error)=>{
            console.error(`Error occurred while executing CANCEL_APPOINTMENT_BY_TOKEN query: `, error);
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.cancelAppointmentByToken) ? fromCancelAppointmentQueryToAppointment(queryState.data.cancelAppointmentByToken) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useStoreByCode = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_BY_CODE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store) ? fromStoreQueryToStore(queryState.data.store) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const CancelAppointment = (_param)=>{
    var { className , appointment , labels , store , hasError , isAppointmentLoading , returnPath , isStoreLoading , disableCancelAppointmentButton , isCancellationInProgress , onSubmit  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "appointment",
        "labels",
        "store",
        "hasError",
        "isAppointmentLoading",
        "returnPath",
        "isStoreLoading",
        "disableCancelAppointmentButton",
        "isCancellationInProgress",
        "onSubmit"
    ]);
    if (isAppointmentLoading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "cancel-appointment__loader-wrapper"
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    if (!appointment) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('cancel-appointment', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "cancel-appointment--border-bottom"
    }, labels.title), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.subtitle), /*#__PURE__*/ React.createElement(AppointmentOverviewContainer, {
        className: "cancel-appointment__overview",
        appointment: appointment,
        store: store,
        isStoreLoading: isStoreLoading
    }), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "cancel-appointment--border-bottom"
    }, labels.reason), /*#__PURE__*/ React.createElement(Form, {
        name: "cancellation-reason",
        onSubmit: (state)=>{
            var ref, ref1;
            onSubmit(state === null || state === void 0 ? void 0 : (ref = state.formState) === null || ref === void 0 ? void 0 : (ref1 = ref.cancellationReason) === null || ref1 === void 0 ? void 0 : ref1.value);
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cancel-appointment__textarea-wrapper"
    }, /*#__PURE__*/ React.createElement(TextArea, {
        name: "cancellationReason",
        label: labels.textareaLabel,
        maxLength: 255,
        errorMessage: labels.errorValidation,
        validations: [
            Util$1.validations.maxLength(255)
        ]
    })), hasError && /*#__PURE__*/ React.createElement(Alert, {
        icon: "warning",
        type: "warning",
        message: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
            variant: "body-head"
        }, labels.errorTitle), labels.errorMessage && /*#__PURE__*/ React.createElement(Text, {
            className: "cancel-appointment__error-message"
        }, labels.errorMessage))
    }), /*#__PURE__*/ React.createElement(Button, {
        variant: "solid",
        caption: labels.cancelButtonLabel,
        className: "cancel-appointment__button",
        isLoading: isCancellationInProgress,
        disabled: disableCancelAppointmentButton,
        type: "submit"
    }), /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        caption: labels.closeButtonLabel,
        className: "cancel-appointment__button",
        href: returnPath
    }), isCancellationInProgress && /*#__PURE__*/ React.createElement(Delayed, {
        delay: 2500,
        scrollIntoView: true,
        className: "cancel-appointment__item"
    }, /*#__PURE__*/ React.createElement(Text, {
        color: "text-secondary",
        align: "center"
    }, labels.slowLoadingIndication))));
};

const INTERNAL_SERVER_ERROR_STATUS = 'INTERNAL_SERVER_ERROR';
const CancelAppointmentContainer = ({ userToken , appointmentId , token  })=>{
    const { appointment , setAppointment , setStore  } = useCancelAppointmentContext();
    const [{ goTo  }, { queryParams  }] = useRoutingContext();
    const [errorCode, setErrorCode] = React.useState('');
    const { getLabel , getFormattedLabel  } = useIntl();
    const labels = React.useMemo(()=>{
        var ref;
        return {
            title: getFormattedLabel('appointments.page.cancel.title', {
                labelData: {
                    name: (appointment === null || appointment === void 0 ? void 0 : (ref = appointment.invitee) === null || ref === void 0 ? void 0 : ref.firstName) || ''
                }
            }),
            subtitle: getLabel('appointments.page.cancel.subtitle'),
            reason: getLabel('appointments.page.cancel.reason'),
            cancelButtonLabel: getLabel('appointments.page.cancel.buttonLabel.cancel'),
            closeButtonLabel: getLabel('appointments.page.cancel.buttonLabel.close'),
            textareaLabel: getLabel('appointments.page.cancel.textareaLabel'),
            errorValidation: getLabel('appointments.page.cancel.errorValidation'),
            errorTitle: getLabel('appointments.page.cancel.errorTitle'),
            errorMessage: getLabel(`appointments.page.cancel.error.${errorCode.toLowerCase()}`, {
                hideLabelKey: true
            }),
            slowLoadingIndication: getLabel('appointments.page.cancel.slowLoadingIndication')
        };
    }, [
        appointment,
        errorCode,
        getLabel,
        getFormattedLabel
    ]);
    const [getAppointmentById, { data: appointmentById , loading: appointmentByIdLoading , error: appointmentByIdError  }, ] = useAppointmentById({
        id: appointmentId !== null && appointmentId !== void 0 ? appointmentId : ''
    }, userToken !== null && userToken !== void 0 ? userToken : '');
    const [getAppointmentByToken, { data: appointmentByToken , loading: appointmentByTokenLoading , error: appointmentByTokenError ,  }, ] = useAppointmentByToken({
        token: token !== null && token !== void 0 ? token : ''
    });
    const [cancelAppointmentByToken, { data: cancelAppointmentByTokenData , loading: cancelAppointmentByTokenDataLoading , error: cancelAppointmentByTokenError ,  }, ] = useCancelAppointmentByToken();
    const [cancelAppointmentById, { data: cancelAppointmentByIdData , loading: cancelAppointmentByIdDataLoading , error: cancelAppointmentByIdError ,  }, ] = useCancelAppointmentById(userToken !== null && userToken !== void 0 ? userToken : '');
    const [getStoreByCode, { data: store , loading: storeLoading  }] = useStoreByCode({
        code: 0
    });
    const onSubmit = React.useCallback((cancellationReason)=>{
        setErrorCode('');
        if (token) {
            cancelAppointmentByToken({
                variables: swcHelpers.objectSpread({
                    token
                }, cancellationReason ? {
                    cancellationReason
                } : {})
            });
        }
        if (appointmentId) {
            cancelAppointmentById({
                variables: swcHelpers.objectSpread({
                    id: appointmentId
                }, cancellationReason ? {
                    cancellationReason
                } : {})
            });
        }
    }, [
        token,
        appointmentId,
        cancelAppointmentByToken,
        cancelAppointmentById
    ]);
    React.useEffect(()=>{
        if (appointment && store) {
            var ref, ref2;
            const dataLayerEvent = cancelAppointmentScreenEvent({
                appointment: {
                    startTime: appointment.startTime,
                    endTime: appointment.endTime,
                    appointmentType: {
                        id: ((ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id) || '',
                        isChildAppointment: !!((ref2 = appointment.appointmentType) === null || ref2 === void 0 ? void 0 : ref2.isChildAppointment)
                    }
                },
                store
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        appointment,
        store
    ]);
    React.useEffect(()=>{
        if (!cancelAppointmentByTokenData) {
            return;
        }
        goTo('confirmation', queryParams);
    }, [
        cancelAppointmentByTokenData,
        queryParams,
        goTo
    ]);
    React.useEffect(()=>{
        if (!cancelAppointmentByIdData) {
            return;
        }
        goTo('confirmation', queryParams);
    }, [
        cancelAppointmentByIdData,
        queryParams,
        goTo
    ]);
    React.useEffect(()=>{
        if (appointmentId && userToken) {
            getAppointmentById({
                variables: {
                    id: appointmentId
                }
            });
        }
    }, [
        appointmentId,
        userToken
    ]);
    React.useEffect(()=>{
        if (token) {
            getAppointmentByToken({
                variables: {
                    token
                }
            });
        }
    }, [
        token
    ]);
    React.useEffect(()=>{
        if (!appointmentById) {
            return;
        }
        setAppointment(appointmentById);
    }, [
        appointmentById
    ]);
    React.useEffect(()=>{
        if (!appointmentByToken) {
            return;
        }
        setAppointment(appointmentByToken);
    }, [
        appointmentByToken
    ]);
    React.useEffect(()=>{
        if (appointmentByIdError) {
            var ref, ref3, ref4;
            var ref5;
            throw new Error((ref5 = (ref = appointmentByIdError.graphQLErrors) === null || ref === void 0 ? void 0 : (ref3 = ref[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.extensions) === null || ref4 === void 0 ? void 0 : ref4.code) !== null && ref5 !== void 0 ? ref5 : INTERNAL_SERVER_ERROR_STATUS);
        }
        if (appointmentByTokenError) {
            var ref6, ref7, ref8;
            var ref9;
            throw new Error((ref9 = appointmentByTokenError === null || appointmentByTokenError === void 0 ? void 0 : (ref6 = appointmentByTokenError.graphQLErrors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.extensions) === null || ref8 === void 0 ? void 0 : ref8.code) !== null && ref9 !== void 0 ? ref9 : INTERNAL_SERVER_ERROR_STATUS);
        }
    }, [
        appointmentByIdError,
        appointmentByTokenError
    ]);
    React.useEffect(()=>{
        if (!store) {
            return;
        }
        setStore(store);
    }, [
        store
    ]);
    React.useEffect(()=>{
        var ref;
        const storeCode = appointment === null || appointment === void 0 ? void 0 : (ref = appointment.store) === null || ref === void 0 ? void 0 : ref.code;
        if (storeCode) {
            getStoreByCode({
                variables: {
                    code: +storeCode
                }
            });
        }
    }, [
        appointment
    ]);
    React.useEffect(()=>{
        if (cancelAppointmentByTokenError) {
            var ref, ref10, ref11;
            var ref12;
            setErrorCode((ref12 = cancelAppointmentByTokenError === null || cancelAppointmentByTokenError === void 0 ? void 0 : (ref = cancelAppointmentByTokenError.graphQLErrors) === null || ref === void 0 ? void 0 : (ref10 = ref[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.extensions) === null || ref11 === void 0 ? void 0 : ref11.code) !== null && ref12 !== void 0 ? ref12 : INTERNAL_SERVER_ERROR_STATUS);
        }
        if (cancelAppointmentByIdError) {
            var ref13, ref14, ref15;
            var ref16;
            setErrorCode((ref16 = cancelAppointmentByIdError === null || cancelAppointmentByIdError === void 0 ? void 0 : (ref13 = cancelAppointmentByIdError.graphQLErrors) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.extensions) === null || ref15 === void 0 ? void 0 : ref15.code) !== null && ref16 !== void 0 ? ref16 : INTERNAL_SERVER_ERROR_STATUS);
        }
    }, [
        cancelAppointmentByIdError,
        cancelAppointmentByTokenError
    ]);
    var ref1;
    return /*#__PURE__*/ React.createElement(CancelAppointment, {
        appointment: appointment !== null && appointment !== void 0 ? appointment : undefined,
        store: store !== null && store !== void 0 ? store : undefined,
        isAppointmentLoading: appointmentByIdLoading || appointmentByTokenLoading,
        isStoreLoading: storeLoading,
        labels: labels,
        returnPath: (ref1 = fromArrayToString(queryParams.returnPath)) !== null && ref1 !== void 0 ? ref1 : '/',
        onSubmit: onSubmit,
        isCancellationInProgress: cancelAppointmentByTokenDataLoading || cancelAppointmentByIdDataLoading,
        hasError: !!errorCode,
        disableCancelAppointmentButton: !!errorCode && errorCode !== INTERNAL_SERVER_ERROR_STATUS
    });
};

const CancelAppointmentRootWithUserToken = withUserToken(CancelAppointmentContainer);
const CancelAppointmentRootWithUserData = WithUserData(CancelAppointmentRootWithUserToken);
const CancelAppointmentRootWithMyAccountEnabled = (_param)=> {
    var props = swcHelpers.extends({}, _param);
    return React.createElement(CancelAppointmentRootWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: true
    }));
};

const CancelAppointmentRoot = ()=>{
    const { config: { appointmentId , token , bookAppointmentUrl  } ,  } = useCancelAppointmentContext();
    if (appointmentId) {
        return /*#__PURE__*/ React.createElement(CancelAppointmentRootWithMyAccountEnabled, {
            appointmentId: appointmentId
        });
    }
    if (token) {
        return /*#__PURE__*/ React.createElement(CancelAppointmentContainer, {
            token: token
        });
    }
    return /*#__PURE__*/ React.createElement(AppointmentErrorContainer, {
        status: appointmentErrors[0],
        bookAppointmentUrl: bookAppointmentUrl
    });
};

const routeMap = {
    '': CancelAppointmentRoot,
    confirmation: CancelAppointmentConfirmationContainer
};

export { AppointmentFormContextProvider, types as AppointmentFormTypes, index as AppointmentUtils, BookAppointmentFormLayout, RoutingContextProvider$2 as BookAppointmentRoutingContextProvider, RoutingError$2 as BookAppointmentRoutingError, RoutingError as CancelAppointmentRoutingError, RoutingContextProvider as CancelAppointmentRoutingProvider, components as Components, containers as Containers, ErrorBoundary, PageDataProvider, RoutingError$1 as RescheduleAppointmentRoutingError, RoutingContextProvider$1 as RescheduleAppointmentRoutingProvider, TimeFilterContextProvider, routeMap$2 as bookAppointmentRouteMap, routingErrorHandler$2 as bookAppointmentRoutingErrorHandler, routeMap as cancelAppointmentRouteMap, routingErrorHandler as cancelAppointmentRoutingErrorHandler, routeMap$1 as rescheduleAppointmentRouteMap, routingErrorHandler$1 as rescheduleAppointmentRoutingErrorHandler };
//# sourceMappingURL=index.js.map
